(function () {
    if (typeof window.SwymStorefrontLayoutAPI === 'undefined') {
      window.SwymStorefrontLayoutAPI = {};
    }
    if (typeof window.SwymStorefrontLayoutContext === 'undefined') {
      window.SwymStorefrontLayoutContext = {};
    }
    if(typeof window.SwymStorefrontLayoutExtensions === 'undefined'){
      window.SwymStorefrontLayoutExtensions = {};
    }
    var SWYM_SHOP_API_KEY = 'd612f58ce0decfaba38849af3396fb5b';
    function swymEscAttr(str) {
      if (!str) return '';
      return String(str)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/'/g, '&#39;');
    }
    
    function isShopifyStoreRTLEnabled() {
      // Check dir attributes
      const htmlDir = document.documentElement.getAttribute('dir');
      const bodyDir = document.body.getAttribute('dir');
    
      // Check computed CSS direction
      const htmlCSSDir = getComputedStyle(document.documentElement).direction;
      const bodyCSSDir = getComputedStyle(document.body).direction;
    
      // Optional: check for common theme class
      const hasRTLClass = document.documentElement.classList.contains('rtl') || 
                          document.body.classList.contains('rtl') ||
                          document.querySelector('.rtl, .is-rtl') !== null;
    
      return (
        htmlDir === 'rtl' ||
        bodyDir === 'rtl' ||
        htmlCSSDir === 'rtl' ||
        bodyCSSDir === 'rtl' ||
        hasRTLClass
      );
    }
    
    const isRTL = isShopifyStoreRTLEnabled();
    if (isRTL) {
      document.body.classList.add('swym-ccui-rtl');
    }
    
    SwymStorefrontLayoutContext.ActionTypes = {
      ManageListItem: 'ManageListItem',
      ManageSflListItem: 'ManageSflListItem',
      ManageSfyListItem: 'ManageSfyListItem',
      AddToCollection: 'AddToCollection',
      CreateCollection: 'CreateCollection',
      EditCollection: 'EditCollection',
      SaveCollection: 'SaveCollection',
      ShareSingleWishlist: 'ShareSingleWishlist'
    }
    
    SwymStorefrontLayoutContext.NotificationStatusTypes = {
      Success: 'success',
      Error: 'error',
      Warning: 'Warning',
      Info: 'info',
      Neutral: 'neutral',
      Toast: 'toast'
    }
    
    SwymStorefrontLayoutContext.NotificationActionTypes = {
      AddedToWishlist: 'added-to-wishlist',
      AddToCollection: 'add-to-collection',
      AddedToCollection: 'added-to-collection',
      AddedToCart: 'added-to-cart'
    }
    
    SwymStorefrontLayoutContext.StorefrontLayoutUrls = Object.assign(
      SwymStorefrontLayoutContext.StorefrontLayoutUrls || {},
      {
        List: '#swym-list',
        Collections: '#swym-collections',
        CollectionList: '#swym-collection:'
      }
    );
    
    SwymStorefrontLayoutContext.NotificationIconType = {
      SuccessIcon: 'SuccessIcon',
      RemoveIcon: 'RemoveIcon'
    }
    
    SwymStorefrontLayoutContext.LoaderViewType = {
      WishlistListItem: 'wishlist-list-item',
      CarouselListItem: 'carousel-list-item',
      CollectionImages: 'collection-view-images',
      SpinnerLoader: 'spinner-loader'
    }
    
    SwymStorefrontLayoutContext.StorefrontLayoutViewType = {
      Wishlist: 'tabWishlist',
      SaveForLater: 'tabSavedForLater',
      SavedForYou: 'tabSavedForYou'
    }
    
    SwymStorefrontLayoutContext.Tabs = [SwymStorefrontLayoutContext.StorefrontLayoutViewType.Wishlist]
    
    SwymStorefrontLayoutContext.ListItemType = {
      WishlistItem: 'WishlistItem',
      CollectionItem: 'CollectionItem',
      SaveForLaterItem: 'SaveForLaterItem',
      SavedForYouItem: 'SavedForYouItem'
    }
    SwymStorefrontLayoutContext.CommonAddtoWL = false;
    SwymStorefrontLayoutContext.CommonRemovefromWL = false;

    SwymStorefrontLayoutContext.dragMovingEpis = new Set();

    SwymStorefrontLayoutContext.DragDrop = {
      activeItem: null,
      activeTarget: null,
      excludedLids: [],

      isDragging() {
        // A re-render mid-drag detaches the source card, and dragend never fires.
        if (this.activeItem && !this.activeItem.element?.isConnected) this.endDrag();
        return !!this.activeItem;
      },

      beginDrag(itemElement) {
        // item.epi, not dataset.epi, which the variant selector rewrites.
        const item = itemElement.item;
        const epi = item?.epi;
        const empi = item?.empi;
        const du = item?.['du-mkt'] || item?.du;
        if (!epi || !empi) return false;

        this.activeItem = { epi, empi, du, element: itemElement };
        this.excludedLids = (SwymStorefrontLayoutContext.collections || [])
          .filter((collection) =>
            (collection?.listcontents || []).some((content) => String(content.epi) === String(epi))
          )
          .map((collection) => collection.lid);

        itemElement.classList.add('swym-storefront-layout-item-dragging');
        return true;
      },

      canDropOn(lid) {
        return this.isDragging() && !!lid && !this.excludedLids.includes(lid);
      },

      setDropTarget(targetElement) {
        if (this.activeTarget === targetElement) return;
        this.clearDropTarget();
        this.activeTarget = targetElement;
        targetElement?.classList.add('swym-storefront-layout-collection-grid-item-drop-target');
      },

      clearDropTarget() {
        this.activeTarget?.classList.remove('swym-storefront-layout-collection-grid-item-drop-target');
        this.activeTarget = null;
      },

      endDrag() {
        this.clearDropTarget();
        this.activeItem?.element?.classList.remove('swym-storefront-layout-item-dragging');
        this.activeItem = null;
        this.excludedLids = [];
      },

      async commitDrop(lid) {
        if (!this.canDropOn(lid)) {
          this.endDrag();
          return;
        }

        const { epi, empi, du } = this.activeItem;
        const defaultLid = SwymStorefrontLayoutContext?.DefaultList?.lid;
        const movedElement = this.activeItem.element;
        this.endDrag();
        movedElement?.classList.add('swym-storefront-layout-item-moving');

        const movingEpis = SwymStorefrontLayoutContext.dragMovingEpis;
        let releaseTimer;
        try {
          // Keyed by item so unrelated adds and removes are not suppressed with it.
          movingEpis.add(String(epi));
          // An SDK callback that never fires would otherwise leave the card hidden and
          // swallow this product's events for the rest of the session.
          releaseTimer = setTimeout(() => this.releaseMove(String(epi)), 30000);

          const api = SwymStorefrontLayoutAPI?.SwymWLAsyncApis;
          // Optional chaining would resolve to undefined and report a phantom success.
          if (!api) throw new Error('Wishlist async APIs unavailable');

          await api.addProductToLists({ empi, epi, du }, [lid]);
          if (defaultLid) {
            await api.removeProductFromLists({ empi, epi, du }, [defaultLid]);
          }

          SwymStorefrontLayoutExtensions?.Notification?.setMessage({
            message: SwymStorefrontLayoutContext?.Strings?.notificationMessageAddedToCollection,
            status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
            duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
            action: {
              label: SwymStorefrontLayoutContext?.Strings?.notificationActionViewCollection,
              onClick: () => {
                window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList + lid;
              }
            }
          }, {
            showActionButton: true,
            showTitle: false,
            showProgress: true
          });

          window._swat?.instrumentV3(
            SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemAddedToList,
            { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi }
          );
          if (defaultLid) {
            window._swat?.instrumentV3(
              SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemRemovedFromList,
              { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi }
            );
          }
        } catch (error) {
          movedElement?.classList.remove('swym-storefront-layout-item-moving');
          window._swat?.utils.error('Error moving product to list on drop', error);
        } finally {
          clearTimeout(releaseTimer);
          this.releaseMove(String(epi));
        }
      },

      releaseMove(epi) {
        const movingEpis = SwymStorefrontLayoutContext.dragMovingEpis;
        if (!movingEpis.delete(epi)) return;
        if (movingEpis.size === 0) {
          SwymStorefrontLayoutExtensions?.refreshWishList();
        }
      }
    }
    
    /**
     * Helper function to determine if multiple wishlists should be shown
     * Returns an object with two flags:
     * - shouldShowMultiple: true if carousel and collections should be displayed
     * - canCreateLists: true if user can create new lists (feature flag is on)
     */
    SwymStorefrontLayoutContext.getMultiWishlistConfig = function() {
      const isOldControlCentre = !('multiple-wishlist' in (window?.SwymEnabledCommonFeatures || {}));
      const canCreateLists = isOldControlCentre
        ? SwymStorefrontLayoutContext?.Settings?.EnableStorefrontLayoutCollection
        : window?.SwymEnabledCommonFeatures?.['multiple-wishlist'];
      
      // Show multiple wishlists if feature is enabled OR if user has more than 1 list
      const hasMultipleLists = window.SwymStorefrontLayoutContext?.allLists?.length > 1;
      const shouldShowMultiple = canCreateLists || hasMultipleLists;
      
      return {
        shouldShowMultiple,
        canCreateLists
      };
    };
    
    // The list name used by the SDK's auto-wishlist feature in multi-list mode
    const SFY_LIST_NAME = 'Saved For Me';
    
    // Returns the dedicated "Saved For Me" list object in multi-list mode, or null in single-list mode.
    SwymStorefrontLayoutContext.getSfyList = function() {
      const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
      if (!shouldShowMultiple) return null;
      return (SwymStorefrontLayoutContext.allLists || []).find(l => l.lname === SFY_LIST_NAME) || null;
    };
    
    /**
     * Helper function to check if education layer (tooltips/toasts on collection and PDP pages) is enabled.
     * Controlled via shop metafield `swym_wishlist.educationLayerEnabled`.
     * Defaults to true (enabled) unless explicitly set to false.
     */
    SwymStorefrontLayoutContext.isEducationLayerEnabled = function() {
      return window.SwymEducationLayerEnabled !== false;
    };
    
    /**
     * Returns whether the login nudge is enabled for this store.
     * Defaults to true (enabled) unless explicitly set to false.
     */
    SwymStorefrontLayoutContext.isLoginNudgeEnabled = function() {
      return window.SwymLoginNudgeEnabled !== false;
    };
    
    window._SwymAJAXCart = async function () {
      try {
        const cartComponent = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (!cartComponent || typeof cartComponent.getSectionsToRender !== 'function') {
          console.warn('[Cart Refresh] Cart component or getSectionsToRender is missing.');
          const modalPopup = document.querySelector("modal-popup");
          if(modalPopup && window.routes.cart) {
            modalPopup.trigger("updateCart", {
                callback: () => {
                    modalPopup.forwardEvent("openPopup", {
                        target: "CART",
                        url: window.routes.cart
                    });
                }
            });
            return;
          } 
          
          // Get current theme info
          const currentThemeName = window?.Shopify?.theme?.schema_name?.trim();
          const currentThemeId = window?.Shopify?.theme?.theme_store_id;
    
          if (!currentThemeName) return false;
    
          // Use preset API to get theme event configuration
          window._swat.fetchThemePreset({ 
            themeStoreId: currentThemeId, 
            schemaName: currentThemeName
          }, (themeData) => {
            if (themeData?.AJAXCartEvent?.[0]?.eventName) {
              try {
                // Get event details from preset API response
                const event = themeData.AJAXCartEvent?.[0];
                
                // Create event config object only with defined properties
                const eventConfig = {};
                if (event.bubbles !== undefined) {
                  eventConfig.bubbles = event.bubbles;
                }
                if (event.detail !== undefined) {
                  eventConfig.detail = event.detail;
                }
                
                // Create and dispatch custom event with only defined properties
                const customEvent = new CustomEvent(event?.eventName, eventConfig);
    
                // Dispatch event on appropriate target
                const target = event.bubbles ? document.documentElement : document;
                target.dispatchEvent(customEvent);
              } catch (err) {
                console.warn(`[Cart Refresh] Failed to dispatch event for theme ${currentThemeName}`, err);
              }
            }
          });
          return;
        }
        
        const sectionsToRender = cartComponent.getSectionsToRender();
        const sectionIds = sectionsToRender.map(section => section.id).join(',');
        if (!sectionIds) {
          console.warn('[Cart Refresh] No section IDs found to render.');
          return;
        }
    
        const [sectionRes, cartDataRes] = await Promise.all([
          fetch(`/?sections=${sectionIds}`).then(res => res.ok ? res.json() : Promise.reject('Failed to fetch sections')),
          fetch('/cart.js').then(res => res.ok ? res.json() : Promise.reject('Failed to fetch cart data'))
        ]);
    
        const parser = new DOMParser();
    
        // Update cart icon bubble
        const cartIconBubble = document.getElementById('cart-icon-bubble');
        const iconHtmlDoc = parser.parseFromString(sectionRes['cart-icon-bubble'], 'text/html');
        const iconBubbleContent = iconHtmlDoc.getElementById('shopify-section-cart-icon-bubble')?.innerHTML;
        if (cartIconBubble && iconBubbleContent) {
          cartIconBubble.innerHTML = iconBubbleContent;
        }
    
        // Update cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          const drawerHtmlDoc = parser.parseFromString(sectionRes['cart-drawer'], 'text/html');
          const newDrawerContent = drawerHtmlDoc.querySelector('cart-drawer')?.innerHTML;
    
          if (newDrawerContent !== undefined) {
            cartDrawer.classList.toggle('is-empty', cartDataRes.item_count === 0);
            cartDrawer.innerHTML = newDrawerContent;
    
            const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
            if (overlay) {
            overlay.addEventListener('click', cartDrawer.close?.bind(cartDrawer));
            }
          }
        }
      } catch (error) {
          console.error('[Cart Refresh] An error occurred:', error);
      }
    };
    
    /**
     * Checks if the current user has permission to edit the given wishlist.
     * @param {Object} list - The wishlist to check.
     * @returns {boolean} - Returns true if the user can edit the list, otherwise false.
     */
    SwymStorefrontLayoutContext.checkUserCanEditList = (list) => {
      if(!list){
          window._swat?.utils.warn('list not exist to check list access');
        return false;
      }
      if(list?.lty === 'sfl'){
        let canEditList = SwymStorefrontLayoutContext?.sflList?.lid === list?.lid;
        return canEditList;
      }
      let canEditList = SwymStorefrontLayoutContext?.lists?.some((userList)=> userList?.lid === list?.lid);
      return canEditList;
    }
    
    /**
     * Formats a given price based on the store's money formatting settings.
     * @param {number} value - The price value to format.
     * @returns {string} - The formatted price string.
     */
    SwymStorefrontLayoutContext.FormatPrice = (value) => {
      try {
        if (window.SwymOverrideFormatMoneyFn) {
          return window.SwymOverrideFormatMoneyFn(value);
        }
        if (window._swat.platform.formatMoney) {
          if (
              window._swat.platform.currentMoneyFormat &&
              window._swat.platform.currentMoneyFormat()
          ) {
            return window._swat.platform.formatMoney(
              value * 100,
              window._swat.platform.currentMoneyFormat()
            );
          }
        }
      } catch (err) {
        window._swat?.utils.error("Error formatting price - " + value + err);
      }
      const currency = window._swat.currency;
      return currency + window._swat.utils.padDecimal(value);
    }
    
    
    /**
     * Retrieves the selected variant from a given item based on the provided variant ID.
     *
     * @param {Object} item - The item containing product data and variants.
     * @param {string | number} variantId - The ID of the variant to find.
     * @returns {Object | null} - The matching variant object if found, otherwise null.
     */
    SwymStorefrontLayoutContext.getSelectedVariant = (item, variantId) => {
      return variantId? item?.productData?.variants?.find((variant) => variant?.id === variantId) || null:null;
    }
    
    /**
     * Applies a transform function to listcontents across all context list references
     * (DefaultList, collections, lists, allLists) to keep them in sync.
     * @param {Function} transformFn - (listcontents: Array) => Array
     */
    SwymStorefrontLayoutContext.updateAllListContents = (transformFn) => {
      if (SwymStorefrontLayoutContext.DefaultList) {
        SwymStorefrontLayoutContext.DefaultList = {
          ...SwymStorefrontLayoutContext.DefaultList,
          listcontents: transformFn(SwymStorefrontLayoutContext.DefaultList.listcontents)
        };
      }
      ['collections', 'lists', 'allLists'].forEach(key => {
        if (SwymStorefrontLayoutContext[key]) {
          SwymStorefrontLayoutContext[key] = SwymStorefrontLayoutContext[key].map(list => ({
            ...list,
            listcontents: transformFn(list.listcontents)
          }));
        }
      });
    };
    
    /**
     * Calculates the difference in hours between the current time and a given date-time string.
     * @param {number} hours - The threshold hours to compare.
     * @param {string} dateTimeString - The stored date-time string.
     * @returns {boolean} - Returns true if the time difference exceeds the given hours, otherwise false.
     */
    SwymStorefrontLayoutExtensions.calcDifferenceInHours = (hours, dateTimeString) => {
      try {
        if (!dateTimeString) {
          window._swat?.utils.warn("[WARNING] Date time string empty");
          return;
        }
        const storedDateTime = new Date(dateTimeString?.trim());
        const currentDateTime = new Date();
    
        const differenceInMs = Math.abs(currentDateTime - storedDateTime);
        const differenceInHours = differenceInMs / (1000 * 60 * 60);
        return differenceInHours > hours;
      } catch (error) {
        window._swat?.utils.warn("[Error/Warning] while performing health check", error);
        return false;
      }
    }
    
    
    /**
     * Checks if a given container has a scrollbar and applies/removes a CSS class accordingly.
     * @param {HTMLElement} container - The container element to check.
     */
    SwymStorefrontLayoutExtensions.checkContainerScrollbar = (container) => {
      try{
        if(!container){
          window._swat?.utils.warn("container not available for scrollbar check");
          return;
        }
        if (container.scrollHeight > container.clientHeight) {
          container.classList.add("swym-storefront-layout-container-has-scroll");
        } else {
          container.classList.remove("swym-storefront-layout-container-has-scroll");
        }
      }catch(error){
        window._swat?.utils.warn("invalid container for scrollbar check");
      }
    }
    
    /**
     * Extracts computed font styles from heading elements (h1, h2, h3) with fallback to body.
     * @returns {Object} - An object containing font family and other relevant font properties.
     */
    SwymStorefrontLayoutExtensions.getHeadingFontStyles = () => {
      try {
        // Find the first available heading element (h1, h2, or h3)
        const headingEl = document.querySelector('h1, h2, h3') || document.body;
        const computedStyles = window.getComputedStyle(headingEl);
        
        return {
          fontFamily: computedStyles.fontFamily,
          fontWeight: computedStyles.fontWeight,
          letterSpacing: computedStyles.letterSpacing
        };
      } catch (error) {
        window._swat?.utils.warn("Error extracting heading font styles", error);
        // Fallback to body styles if heading extraction fails
        try {
          const bodyStyles = window.getComputedStyle(document.body);
          return {
            fontFamily: bodyStyles.fontFamily,
            fontWeight: bodyStyles.fontWeight,
            letterSpacing: bodyStyles.letterSpacing
          };
        } catch (fallbackError) {
          window._swat?.utils.warn("Error extracting body font styles", fallbackError);
          return {};
        }
      }
    }
    
    /**
     * Applies heading font styles to a given title element.
     * @param {HTMLElement} titleElement - The title element to apply styles to.
     */
    SwymStorefrontLayoutExtensions.applyHeadingFontStyles = (titleElement) => {
      try {
        const headingFontStyles = SwymStorefrontLayoutExtensions?.getHeadingFontStyles();
        // When theme CSS mapping is active, typography is handled via CSS variables.
        // Skip inline overrides for font-family, font-weight, and letter-spacing
        // to avoid clobbering the CSS variable values with computed page styles.
        const themeMappingActive = !!document.querySelector('[data-swym-theme-mapping]');
        
        if (titleElement && headingFontStyles) {
          if (!themeMappingActive) {
            // Apply font styles from heading elements to the title
            if (headingFontStyles.fontFamily) {
              titleElement.style.fontFamily = headingFontStyles.fontFamily;
            }
            if (headingFontStyles.fontWeight) {
              titleElement.style.fontWeight = headingFontStyles.fontWeight;
            }
            if (headingFontStyles.letterSpacing) {
              titleElement.style.letterSpacing = headingFontStyles.letterSpacing;
            }
          }
          // Note: We don't apply fontSize and lineHeight as the title should maintain its own sizing
        }
      } catch (error) {
        window._swat?.utils.warn(`Error applying heading font styles`, error);
      }
    }
    
    SwymStorefrontLayoutExtensions.refreshWishList = () => {
      try {
        SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.updateList();
      } catch (error) {
        window._swat?.utils.error('Failed to fetch wishlist', error);
      }
    }
    
    SwymStorefrontLayoutExtensions.getShareIconSvg = () => {
      return `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" focusable="false">
        <path d="M13.5 2.375C14.6669 2.375 15.625 3.33306 15.625 4.5C15.625 5.66694 14.6669 6.625 13.5 6.625C12.8556 6.625 12.2862 6.30928 11.8828 5.81445C11.7533 5.65562 11.5425 5.59393 11.3516 5.65137L11.2715 5.68359L6.77539 7.93262C6.5655 8.03762 6.45726 8.27438 6.51465 8.50195C6.58433 8.77824 6.625 8.86302 6.625 9C6.625 9.13698 6.58433 9.22176 6.51465 9.49805C6.45726 9.72562 6.5655 9.96238 6.77539 10.0674L11.2715 12.3164C11.4808 12.4211 11.7349 12.3669 11.8828 12.1855C12.2862 11.6907 12.8556 11.375 13.5 11.375C14.6669 11.375 15.625 12.3331 15.625 13.5C15.625 14.6669 14.6669 15.625 13.5 15.625C12.3331 15.625 11.375 14.6669 11.375 13.5C11.375 13.363 11.4157 13.2782 11.4854 13.002C11.5427 12.7744 11.4345 12.5376 11.2246 12.4326L6.72852 10.1836C6.54532 10.0919 6.32732 10.1214 6.17676 10.252L6.11719 10.3145C5.71385 10.8093 5.1444 11.125 4.5 11.125C3.33306 11.125 2.375 10.1669 2.375 9C2.375 7.83306 3.33306 6.875 4.5 6.875C5.1444 6.875 5.71385 7.19072 6.11719 7.68555C6.2651 7.86695 6.51918 7.92112 6.72852 7.81641L11.2246 5.56738C11.4345 5.46238 11.5427 5.22562 11.4854 4.99805C11.4157 4.72176 11.375 4.63698 11.375 4.5C11.375 3.33306 12.3331 2.375 13.5 2.375ZM13.5 11.5C12.3888 11.5 11.5 12.3888 11.5 13.5C11.5 14.6112 12.3888 15.5 13.5 15.5C14.6112 15.5 15.5 14.6112 15.5 13.5C15.5 12.3888 14.6112 11.5 13.5 11.5ZM4.5 7C3.38877 7 2.5 7.88877 2.5 9C2.5 10.1112 3.38877 11 4.5 11C5.61123 11 6.5 10.1112 6.5 9C6.5 7.88877 5.61123 7 4.5 7ZM13.5 2.5C12.3888 2.5 11.5 3.38877 11.5 4.5C11.5 5.61123 12.3888 6.5 13.5 6.5C14.6112 6.5 15.5 5.61123 15.5 4.5C15.5 3.38877 14.6112 2.5 13.5 2.5Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>`;
    }
    
    /**
     * Returns the wishlist icon SVG markup.
     * Currently uses a hardcoded heart icon. Dynamic icon support (heart/star/bookmark
     * based on retailer config) will be added later.
     * @param {'filled'|'unfilled'} state - Whether to return the filled or unfilled icon variant
     * @param {object} [opts] - Optional overrides
     * @param {string} [opts.color] - Icon stroke/fill color (default: 'currentColor')
     * @param {string} [opts.width] - SVG width attribute (default: '17')
     * @param {string} [opts.height] - SVG height attribute (default: '15')
     * @returns {string} SVG markup string
     */
    SwymStorefrontLayoutExtensions.getWishlistIconSvg = (state = 'filled', opts = {}) => {
      const color = opts.color || 'currentColor';
      const width = opts.width || '17';
      const height = opts.height || '15';
    
      if (state === 'unfilled') {
        return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 17 16" fill="none" aria-hidden="true" focusable="false">
          <path d="M3.94617 0.518585C4.71879 0.439587 5.46423 0.623711 6.12292 0.918976C7.09924 1.35664 7.94118 2.06375 8.495 2.66019C8.69022 2.42887 8.92463 2.21448 9.18054 2.02249C9.66446 1.65956 10.2568 1.35316 10.8905 1.14944C12.1427 0.746943 13.6652 0.716791 14.8436 1.60062C16.0064 2.47285 16.4537 3.64555 16.3866 4.90921C16.3211 6.14189 15.7705 7.444 14.993 8.66409C13.4387 11.1032 10.8538 13.404 8.76746 14.4473L8.53113 14.5655L8.30066 14.4375C5.98745 13.1524 3.46501 10.932 1.9364 8.58597C1.17217 7.41299 0.633191 6.17363 0.521362 4.97757C0.407722 3.76125 0.739132 2.59768 1.69031 1.64651C2.39175 0.945176 3.16373 0.598678 3.94617 0.518585Z" fill="white" stroke="${color}"/>
        </svg>`;
      }
      return `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="0 0 17 15" fill="none" aria-hidden="true" focusable="false">
        <path d="M2.04363 2.00013C4.54368 -0.499876 7.71029 2.33346 8.54363 3.50012C9.21029 2.00012 12.5437 0.500119 14.5437 2.00013C18.6166 5.05486 12.5437 12.0001 8.54363 14.0001C4.04367 11.5001 -1.29179 5.3355 2.04363 2.00013Z" fill="${color}"/>
      </svg>`;
    }
    
    SwymStorefrontLayoutExtensions.refreshSFLList = () => {
      try {
        SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.updateSflList();
      } catch (error) {
        window._swat?.utils.error('Failed to fetch sfl list', error);
      }
    }
    
    /**
     * Theme CSS variable mapping — maps Shopify theme CSS variables to Swym's
     * --swym-storefront-layout-* variables so the drawer inherits theme colors,
     * typography, button styles, and input styles automatically.
     *
     * Supports Dawn-family and Horizon-family themes. Unknown themes fall back
     * to the existing hardcoded :root values in storefront-layout.css.
     *
     * Runs once at init — injects a single <style> block, zero ongoing cost.
     */
    SwymStorefrontLayoutExtensions.ThemeCSSMapping = (() => {
      /**
       * Detects theme family using CSS variable feature detection.
       * Dawn-family themes define --font-heading-family on :root.
       * Horizon-family themes define --font-h2--family on :root.
       * This approach works with custom-named / forked themes that still use
       * the same CSS variable system as their parent theme.
       * Falls back to name-based matching as a secondary check.
       */
      const DAWN_THEMES = ['Dawn', 'Craft', 'Crave', 'Sense', 'Taste', 'Studio', 'Ride', 'Colorblock', 'Refresh', 'Origin', 'Publisher', 'Spotlight', 'Trade', 'Rise'];
      const HORIZON_THEMES = ['Horizon', 'Ritual', 'Heritage', 'Atelier', 'Pitch', 'Tinker', 'Dwell', 'Vessel', 'Savor', 'Fabric'];
    
      function getThemeFamily() {
        try {
          // Primary: CSS variable feature detection (works with custom-named themes)
          const rootStyles = getComputedStyle(document.documentElement);
          const hasDawnVars = rootStyles.getPropertyValue('--font-heading-family').trim();
          const hasHorizonVars = rootStyles.getPropertyValue('--font-h2--family').trim();
          if (hasDawnVars) return 'dawn';
          if (hasHorizonVars) return 'horizon';
    
          // Fallback: name-based matching
          const themeName = window.Shopify?.theme?.name;
          if (!themeName) return null;
          if (DAWN_THEMES.some(t => themeName.includes(t))) return 'dawn';
          if (HORIZON_THEMES.some(t => themeName.includes(t))) return 'horizon';
          return null;
        } catch (e) {
          return null;
        }
      }
    
      function getDawnThemeVariables() {
        return `
          :root {
            /* UI */
            --swym-theme-layout-ui-bg-color: rgb(var(--color-background));
            --swym-theme-layout-ui-text-color: rgba(var(--color-foreground), 0.75);
            --swym-theme-layout-color-bg: rgb(var(--color-background));
            --swym-theme-layout-color-text: rgb(var(--color-foreground));
            --swym-theme-layout-color-text-default: rgb(var(--color-foreground));
            --swym-theme-layout-color-text-sub: rgba(var(--color-foreground), 0.55);
            --swym-theme-layout-color-text-sub2: rgba(var(--color-foreground), 0.4);
            --swym-theme-layout-color-border: rgba(var(--color-foreground), 0.15);
            --swym-theme-layout-border-color: rgba(var(--color-foreground), 0.15);
    
            /* TYPOGRAPHY */
            --swym-theme-layout-font-family-heading: var(--font-heading-family);
            --swym-theme-layout-font-weight-heading: var(--font-heading-weight);
            --swym-theme-layout-font-style-heading: var(--font-heading-style);
            --swym-theme-layout-text-transform-heading: none;
            --swym-theme-layout-letter-spacing-heading: calc(var(--font-heading-scale) * 0.06rem);
            --swym-theme-layout-text-color-heading: rgb(var(--color-foreground));
            --swym-theme-layout-font-family-body: var(--font-body-family);
            --swym-theme-layout-font-weight-body: var(--font-body-weight);
            --swym-theme-layout-font-weight-body-bold: var(--font-body-weight-bold);
            --swym-theme-layout-font-style-body: var(--font-body-style);
            --swym-theme-layout-letter-spacing-body: 0.06rem;
            --swym-theme-layout-text-transform-body: none;
    
            /* BUTTONS — primary */
            --swym-theme-layout-button-border-color-primary: rgba(var(--color-button-text), calc(1 - var(--buttons-border-opacity, 1)));
            --swym-theme-layout-button-border-radius: var(--buttons-radius, 0px);
            --swym-theme-layout-button-border-radius-primary: var(--buttons-radius, 0px);
            --swym-theme-layout-button-border-style-primary: solid;
            --swym-theme-layout-button-border-width-primary: var(--buttons-border-width, 0px);
            --swym-theme-layout-button-box-shadow-primary: var(--buttons-shadow-horizontal-offset, 0px) var(--buttons-shadow-vertical-offset, 0px) var(--buttons-shadow-blur-radius, 0px) rgba(var(--color-shadow, 0, 0, 0), var(--buttons-shadow-opacity, 0));
            --swym-theme-layout-button-color-bg-primary: rgba(var(--color-button), var(--alpha-button-background));
            --swym-theme-layout-button-color-text-primary: rgb(var(--color-button-text));
            --swym-theme-layout-button-font-family-primary: var(--font-body-family);
            --swym-theme-layout-button-font-size-primary: 1.5rem;
            --swym-theme-layout-button-font-style-primary: ;
            --swym-theme-layout-button-font-weight-primary: var(--font-body-weight);
            --swym-theme-layout-button-letter-spacing-primary: 0.1rem;
            --swym-theme-layout-button-text-transform-primary: none;
    
            /* BUTTONS — secondary */
            --swym-theme-layout-button-border-color-secondary: rgba(var(--color-secondary-button-text), var(--buttons-border-opacity, 1));
            --swym-theme-layout-button-border-radius-secondary: var(--buttons-radius, 0px);
            --swym-theme-layout-button-border-style-secondary: solid;
            --swym-theme-layout-button-border-width-secondary: var(--buttons-border-width, 0px);
            --swym-theme-layout-button-box-shadow-secondary: var(--buttons-shadow-horizontal-offset, 0px) var(--buttons-shadow-vertical-offset, 0px) var(--buttons-shadow-blur-radius, 0px) rgba(var(--color-shadow, 0, 0, 0), var(--buttons-shadow-opacity, 0));
            --swym-theme-layout-button-color-bg-secondary: rgb(var(--color-secondary-button));
            --swym-theme-layout-button-color-text-secondary: rgb(var(--color-secondary-button-text));
            --swym-theme-layout-button-font-family-secondary: var(--font-body-family);
            --swym-theme-layout-button-font-size-secondary: 1.5rem;
            --swym-theme-layout-button-font-style-secondary: ;
            --swym-theme-layout-button-font-weight-secondary: var(--font-body-weight);
            --swym-theme-layout-button-letter-spacing-secondary: 0.1rem;
            --swym-theme-layout-button-text-transform-secondary: none;
    
            /* INPUTS */
            --swym-theme-layout-input-color-bg: rgb(var(--color-background));
            --swym-theme-layout-input-color-text: rgb(var(--color-foreground));
            --swym-theme-layout-input-border-color: rgba(var(--color-foreground), var(--inputs-border-opacity, 0.55));
            --swym-theme-layout-input-border-radius: var(--inputs-radius, 0px);
            --swym-theme-layout-input-border-style: solid;
            --swym-theme-layout-input-border-width: var(--inputs-border-width, 1px);
            --swym-theme-layout-input-box-shadow: 0;
            --swym-theme-layout-input-box-shadow-hover: 0 0 0 var(--inputs-border-width, 1px) rgba(var(--color-foreground), var(--inputs-border-opacity, 0.55));
            --swym-theme-layout-input-box-shadow-focus: 0 0 0 var(--inputs-border-width, 1px) rgba(var(--color-foreground), 1);
            --swym-theme-layout-input-focus-border-color: rgba(var(--color-foreground), 1);
            --swym-theme-layout-input-focus-outline-color: transparent;
            --swym-theme-layout-input-focus-outline-offset: 0;
            --swym-theme-layout-input-focus-outline-style: solid;
            --swym-theme-layout-input-focus-outline-width: 0;
            --swym-theme-layout-input-transition: box-shadow var(--duration-short, 100ms) ease;
          }
        `;
      }
    
      function getHorizonThemeVariables() {
        return `
          :root {
            /* UI */
            --swym-theme-layout-ui-bg-color: var(--color-background);
            --swym-theme-layout-ui-text-color: var(--color-foreground);
            --swym-theme-layout-color-bg: var(--color-background);
            --swym-theme-layout-color-text: var(--color-foreground);
            --swym-theme-layout-color-text-default: var(--color-foreground);
            --swym-theme-layout-color-text-sub: color-mix(in srgb, var(--color-foreground) 55%, transparent);
            --swym-theme-layout-color-text-sub2: color-mix(in srgb, var(--color-foreground) 40%, transparent);
            --swym-theme-layout-color-border: color-mix(in srgb, var(--color-foreground) 15%, transparent);
            --swym-theme-layout-border-color: color-mix(in srgb, var(--color-foreground) 15%, transparent);
    
            /* TYPOGRAPHY */
            --swym-theme-layout-font-family-heading: var(--font-h2--family);
            --swym-theme-layout-font-weight-heading: var(--font-h2--weight);
            --swym-theme-layout-font-style-heading: var(--font-h2--style);
            --swym-theme-layout-text-transform-heading: var(--font-h2--case);
            --swym-theme-layout-letter-spacing-heading: var(--font-h2--letter-spacing);
            --swym-theme-layout-text-color-heading: var(--font-h2--color);
            --swym-theme-layout-font-family-body: var(--font-paragraph--family);
            --swym-theme-layout-font-weight-body: var(--font-paragraph--weight);
            --swym-theme-layout-font-weight-body-bold: bold;
            --swym-theme-layout-font-style-body: var(--font-paragraph--style);
            --swym-theme-layout-letter-spacing-body: var(--font-paragraph--letter-spacing);
            --swym-theme-layout-text-transform-body: var(--font-paragraph--case);
    
            /* BUTTONS — primary */
            --swym-theme-layout-button-border-color-primary: var(--color-primary-button-background);
            --swym-theme-layout-button-border-radius: var(--style-border-radius-buttons-primary);
            --swym-theme-layout-button-border-radius-primary: var(--style-border-radius-buttons-primary);
            --swym-theme-layout-button-border-style-primary: solid;
            --swym-theme-layout-button-border-width-primary: 0;
            --swym-theme-layout-button-box-shadow-primary: inset 0 0 0 var(--style-border-width-primary) var(--color-primary-button-border);
            --swym-theme-layout-button-color-bg-primary: var(--color-primary-button-background);
            --swym-theme-layout-button-color-text-primary: var(--color-primary-button-text);
            --swym-theme-layout-button-font-family-primary: var(--button-font-family-primary);
            --swym-theme-layout-button-font-size-primary: var(--font-paragraph--size);
            --swym-theme-layout-button-font-style-primary: var(--font-paragraph--style);
            --swym-theme-layout-button-font-weight-primary: var(--font-paragraph--weight);
            --swym-theme-layout-button-letter-spacing-primary: var(--font-paragraph--letter-spacing);
            --swym-theme-layout-button-text-transform-primary: var(--button-text-case-primary);
    
            /* BUTTONS — secondary */
            --swym-theme-layout-button-border-color-secondary: var(--color-secondary-button-background);
            --swym-theme-layout-button-border-radius-secondary: var(--style-border-radius-buttons-secondary);
            --swym-theme-layout-button-border-style-secondary: solid;
            --swym-theme-layout-button-border-width-secondary: 0;
            --swym-theme-layout-button-box-shadow-secondary: inset 0 0 0 var(--style-border-width-secondary) var(--color-secondary-button-border);
            --swym-theme-layout-button-color-bg-secondary: var(--color-secondary-button-background);
            --swym-theme-layout-button-color-text-secondary: var(--color-secondary-button-text);
            --swym-theme-layout-button-font-family-secondary: var(--button-font-family-secondary);
            --swym-theme-layout-button-font-size-secondary: var(--font-paragraph--size);
            --swym-theme-layout-button-font-style-secondary: var(--font-paragraph--style);
            --swym-theme-layout-button-font-weight-secondary: var(--font-paragraph--weight);
            --swym-theme-layout-button-letter-spacing-secondary: var(--font-paragraph--letter-spacing);
            --swym-theme-layout-button-text-transform-secondary: var(--button-text-case-secondary);
    
            /* INPUTS */
            --swym-theme-layout-input-color-bg: var(--color-input-background);
            --swym-theme-layout-input-color-text: var(--color-input-text);
            --swym-theme-layout-input-border-color: var(--color-input-border);
            --swym-theme-layout-input-border-radius: var(--style-border-radius-inputs);
            --swym-theme-layout-input-border-style: solid;
            --swym-theme-layout-input-border-width: var(--style-border-width-inputs);
            --swym-theme-layout-input-box-shadow: 0;
            --swym-theme-layout-input-box-shadow-hover: 0;
            --swym-theme-layout-input-box-shadow-focus: 0;
            --swym-theme-layout-input-focus-border-color: var(--color-input-border);
            --swym-theme-layout-input-focus-outline-color: currentColor;
            --swym-theme-layout-input-focus-outline-offset: var(--focus-outline-offset);
            --swym-theme-layout-input-focus-outline-style: solid;
            --swym-theme-layout-input-focus-outline-width: var(--focus-outline-width);
            --swym-theme-layout-input-transition: none;
          }
        `;
      }
    
      function getBridgeVariables() {
        return `
          #swym-storefront-layout-container {
            /* UI */
            --swym-storefront-layout-ui-bg-color: var(--swym-theme-layout-ui-bg-color);
            --swym-storefront-layout-ui-text-color: var(--swym-theme-layout-ui-text-color);
            --swym-storefront-layout-color-bg: var(--swym-theme-layout-color-bg);
            --swym-storefront-layout-color-text: var(--swym-theme-layout-color-text);
            --swym-storefront-layout-color-text-default: var(--swym-theme-layout-color-text-default);
            --swym-storefront-layout-color-text-sub: var(--swym-theme-layout-color-text-sub);
            --swym-storefront-layout-color-text-sub2: var(--swym-theme-layout-color-text-sub2);
            --swym-storefront-layout-color-border: var(--swym-theme-layout-color-border);
            --swym-storefront-layout-border-color: var(--swym-theme-layout-border-color);
    
            /* TYPOGRAPHY */
            --swym-storefront-layout-font-family-heading: var(--swym-theme-layout-font-family-heading);
            --swym-storefront-layout-font-weight-heading: var(--swym-theme-layout-font-weight-heading);
            --swym-storefront-layout-font-style-heading: var(--swym-theme-layout-font-style-heading);
            --swym-storefront-layout-text-transform-heading: var(--swym-theme-layout-text-transform-heading);
            --swym-storefront-layout-letter-spacing-heading: var(--swym-theme-layout-letter-spacing-heading);
            --swym-storefront-layout-text-color-heading: var(--swym-theme-layout-text-color-heading);
            --swym-storefront-layout-font-family-body: var(--swym-theme-layout-font-family-body);
            --swym-storefront-layout-font-weight-body: var(--swym-theme-layout-font-weight-body);
            --swym-storefront-layout-font-weight-body-bold: var(--swym-theme-layout-font-weight-body-bold);
            --swym-storefront-layout-font-style-body: var(--swym-theme-layout-font-style-body);
            --swym-storefront-layout-letter-spacing-body: var(--swym-theme-layout-letter-spacing-body);
    
            /* BUTTONS — primary */
            --swym-storefront-layout-button-color-bg-primary: var(--swym-theme-layout-button-color-bg-primary);
            --swym-storefront-layout-button-color-text-primary: var(--swym-theme-layout-button-color-text-primary);
            --swym-storefront-layout-button-color-bg-secondary: var(--swym-theme-layout-button-color-bg-secondary);
            --swym-storefront-layout-button-color-text-secondary: var(--swym-theme-layout-button-color-text-secondary);
            --swym-storefront-layout-button-border-color-primary: var(--swym-theme-layout-button-border-color-primary);
            --swym-storefront-layout-button-border-radius: var(--swym-theme-layout-button-border-radius);
            --swym-storefront-layout-button-border-radius-primary: var(--swym-theme-layout-button-border-radius-primary);
            --swym-storefront-layout-button-border-style-primary: var(--swym-theme-layout-button-border-style-primary);
            --swym-storefront-layout-button-border-width-primary: var(--swym-theme-layout-button-border-width-primary);
            --swym-storefront-layout-button-box-shadow-primary: var(--swym-theme-layout-button-box-shadow-primary);
            --swym-storefront-layout-button-font-family-primary: var(--swym-theme-layout-button-font-family-primary);
            --swym-storefront-layout-button-font-weight-primary: var(--swym-theme-layout-button-font-weight-primary);
            --swym-storefront-layout-button-font-size-primary: var(--swym-theme-layout-button-font-size-primary);
            --swym-storefront-layout-button-font-style-primary: var(--swym-theme-layout-button-font-style-primary);
            --swym-storefront-layout-button-text-transform-primary: var(--swym-theme-layout-button-text-transform-primary);
            --swym-storefront-layout-button-letter-spacing-primary: var(--swym-theme-layout-button-letter-spacing-primary);
    
            /* BUTTONS — secondary */
            --swym-storefront-layout-button-border-color-secondary: var(--swym-theme-layout-button-border-color-secondary);
            --swym-storefront-layout-button-border-radius-secondary: var(--swym-theme-layout-button-border-radius-secondary);
            --swym-storefront-layout-button-border-style-secondary: var(--swym-theme-layout-button-border-style-secondary);
            --swym-storefront-layout-button-border-width-secondary: var(--swym-theme-layout-button-border-width-secondary);
            --swym-storefront-layout-button-box-shadow-secondary: var(--swym-theme-layout-button-box-shadow-secondary);
            --swym-storefront-layout-button-font-family-secondary: var(--swym-theme-layout-button-font-family-secondary);
            --swym-storefront-layout-button-font-weight-secondary: var(--swym-theme-layout-button-font-weight-secondary);
            --swym-storefront-layout-button-font-style-secondary: var(--swym-theme-layout-button-font-style-secondary);
            --swym-storefront-layout-button-text-transform-secondary: var(--swym-theme-layout-button-text-transform-secondary);
            --swym-storefront-layout-button-letter-spacing-secondary: var(--swym-theme-layout-button-letter-spacing-secondary);
            --swym-storefront-layout-button-font-size-secondary: var(--swym-theme-layout-button-font-size-secondary);
    
            /* INPUTS */
            --swym-storefront-layout-input-color-bg: var(--swym-theme-layout-input-color-bg);
            --swym-storefront-layout-input-color-text: var(--swym-theme-layout-input-color-text);
            --swym-storefront-layout-input-border-color: var(--swym-theme-layout-input-border-color);
            --swym-storefront-layout-input-border-radius: var(--swym-theme-layout-input-border-radius);
            --swym-storefront-layout-input-border-style: var(--swym-theme-layout-input-border-style);
            --swym-storefront-layout-input-border-width: var(--swym-theme-layout-input-border-width);
            --swym-storefront-layout-input-box-shadow: var(--swym-theme-layout-input-box-shadow);
            --swym-storefront-layout-input-box-shadow-hover: var(--swym-theme-layout-input-box-shadow-hover);
            --swym-storefront-layout-input-box-shadow-focus: var(--swym-theme-layout-input-box-shadow-focus);
            --swym-storefront-layout-input-focus-border-color: var(--swym-theme-layout-input-focus-border-color);
            --swym-storefront-layout-input-focus-outline-color: var(--swym-theme-layout-input-focus-outline-color);
            --swym-storefront-layout-input-focus-outline-offset: var(--swym-theme-layout-input-focus-outline-offset);
            --swym-storefront-layout-input-focus-outline-style: var(--swym-theme-layout-input-focus-outline-style);
            --swym-storefront-layout-input-focus-outline-width: var(--swym-theme-layout-input-focus-outline-width);
            --swym-storefront-layout-input-transition: var(--swym-theme-layout-input-transition);
          }
        `;
      }
    
      function inject() {
        try {
          const family = getThemeFamily();
          if (!family) return; // Unknown theme — keep existing hardcoded :root values
    
          // When block settings are enabled, the merchant controls colors via the
          // theme editor. Skip the entire CSS mapping (theme vars + bridge) so
          // block settings and :root defaults are used — matching pre-mapping behavior.
          const blockSettingsEnabled = window.SwymStorefrontLayoutContext?.BlockSettingsEnabled || false;
          if (blockSettingsEnabled) return;
    
          const themeVars = family === 'dawn' ? getDawnThemeVariables() : getHorizonThemeVariables();
          const bridgeVars = getBridgeVariables();
    
          const style = document.createElement('style');
          style.setAttribute('data-swym-theme-mapping', family);
          style.textContent = themeVars + bridgeVars;
          document.head.appendChild(style);
        } catch (e) {
          // Silently fail — fallback to hardcoded :root values
        }
      }
    
      return { inject, getThemeFamily };
    })();
    
    /**
     * Defines action codes for various storefront layout events.
     */
    SwymStorefrontLayoutExtensions.InstrumentActionCodes = {
      StorefrontLayoutInitialized: 701,
      StorefrontLayoutOpened: 702,
      StorefrontLayoutClosed: 703,
      StorefrontLayoutUserLogIn: 704,
      StorefrontLayoutCollectionRendered: 705,
      StorefrontLayoutWishlistItemsRendered: 706,
      StorefrontLayoutVariantChanged: 707,
      StorefrontLayoutItemAddedToCart: 708,
      StorefrontLayoutItemAddedToList: 709,
      StorefrontLayoutItemRemovedFromList: 710,
      StorefrontLayoutCollectionCreated: 711,
      StorefrontLayoutCollectionOpened: 712,
      StorefrontLayoutCollectionRenamed: 713,
      StorefrontLayoutCollectionDeleted: 714,
      StorefrontLayoutCollectionGridViewOpened: 715,
      StorefrontLayoutSFLInitialized: 716,
      StorefrontLayoutSFLItemsRendered: 717,
      StorefrontLayoutSFLItemAddedToList: 718,
      StorefrontLayoutSFLItemRemovedFromList: 719,
      StorefrontLayoutSFLItemMovedToCart: 720,
      StorefrontLayoutPageRendered: 721,
      StorefrontLayoutModalRendered: 722,
      StorefrontLayoutSideDrawerRendered: 723,
      // Saved For You
      StorefrontLayoutSFYTabViewed: 724,
      StorefrontLayoutSFYItemAddedToCart: 725,
      StorefrontLayoutSFYItemRemoved: 726,
      StorefrontLayoutSFYItemMovedToWishlist: 727,
      // AW Login Nudge
      StorefrontLayoutAWNudge1Shown: 728,
      StorefrontLayoutAWNudge1LoginClicked: 729,
      StorefrontLayoutAWNudge1Dismissed: 730,
      StorefrontLayoutAWNudge2Shown: 731,
      StorefrontLayoutAWNudge2LoginClicked: 732,
      StorefrontLayoutAWNudge2Dismissed: 733,
      // Explicit WL Login Nudge
      StorefrontLayoutExplicitNudge1Shown: 734,
      StorefrontLayoutExplicitNudge1LoginClicked: 735,
      StorefrontLayoutExplicitNudge1Dismissed: 736,
      StorefrontLayoutExplicitNudge2Shown: 737,
      StorefrontLayoutExplicitNudge2LoginClicked: 738,
      StorefrontLayoutExplicitNudge2Dismissed: 739,
      // Sign in with Shop
      StorefrontLayoutLoginNudgeShopLoginShown: 740,
      StorefrontLayoutWishlistUiShopLoginShown: 741,
      // Education Layer
      EducationLayerToastShownCollections: 812,
      EducationLayerTooltipShownCollections: 813,
      EducationLayerTooltipDismissedCollections: 814,
      EducationLayerTooltipShownPDP: 815,
      EducationLayerTooltipDismissedPDP: 816,
      EducationLayerButtonTransitionShownPDP: 817,
      EducationLayerToastShownPDP: 818,
      EducationLayerToastCTAClicked: 819,
      EducationLayerSessionStopped: 820
    };
    
    /**
     * Defines UTM terms for tracking user engagement and interactions.
     */
    SwymStorefrontLayoutExtensions.InstrumentUtmTerms = {
      StorefrontLayoutUiEngagement: "storefront_layout_ui_engagement",
      StorefrontLayoutCollectionInteractions: "storefront_layout_collection_interactions",
      StorefrontLayoutItemInteractions: "storefront_layout_item_interactions",
      StorefrontLayoutCartConversion: "storefront_layout_cart_conversion",
      EducationLayerEngagement: "education",
      StorefrontLayoutAWLoginNudgeEngagement: "aw_login_nudge",
      StorefrontLayoutExplicitLoginNudgeEngagement: "explicit_login_nudge",
      StorefrontLayoutShopLoginNudgeEngagement: "nudge_shop_login_shown",
      StorefrontLayoutShopLoginWishlistUiEngagement: "wishlist_ui_shop_login_shown"
    };
    
    if (typeof window !== 'undefined') {
      if (!window.SwymCallbacks) {
        window.SwymCallbacks = [];
      }
      
      let vsClosedListenerRegistered = false;
      
      window.SwymCallbacks.push(function(swat) {
        if (vsClosedListenerRegistered) return;
        vsClosedListenerRegistered = true;
        
        if (!swat || !swat.evtLayer) return;
        
        swat.evtLayer.addEventListener('sw:vs:closed', (e) => {
          const detail = e?.detail || {};
          const empi = detail.empi;
          const listId = detail.listId;
          
          if (!empi || !listId) return;
          
          const gridItem = window.SwymStorefrontLayoutExtensions?._vsActiveItem;
          if (gridItem && gridItem.item?.empi === empi && gridItem.list?.lid === listId) {
            if (!gridItem._variantConfirmed) {
              gridItem._variantConfirmed = true;
              gridItem.renderItem();
              gridItem.initItemElements();
              gridItem.addEventListeners();
              gridItem.initDragAndDrop();
            }
          }
          
          if (window.SwymStorefrontLayoutExtensions) {
            window.SwymStorefrontLayoutExtensions._vsActiveItem = null;
          }
        });
      });
    }
    
    /**
     * SwymWishlistCore Component
     *
     * This component serves as the base class for Swym Wishlist Storefront Layout, 
     * providing the core functionality shared across different layout implementations:
     * - Drawer
     * - Page Section
     * - Modal
     *
     * Key Responsibilities:
     * - Initializes the UI and sets up event listeners for wishlist interactions.
     * - Handles fetching and rendering of wishlist items and collections.
     * - Monitors hash changes to update the UI accordingly.
     * - Integrates with Swym's API for wishlist actions and notifications.
     * - Provides a structured foundation for extending different storefront layout types.
     *
     * The component can be extended by specific layout implementations such as:
     * - `SwymStorefrontLayoutAsDrawer`
     * - `SwymStorefrontLayoutAsPageSection`
     * - `SwymStorefrontLayoutAsModal`
     */
    class SwymWishlistCore extends HTMLElement {
      constructor() {
        super();
        this.elements = {};
        this.initUi();
      }
    
      initUi(){
        this.setAttribute('id', 'swym-storefront-layout');
        // Inject theme-aware CSS variables (Dawn/Horizon) — runs once, no-op for unknown themes
        SwymStorefrontLayoutExtensions.ThemeCSSMapping.inject();
        window.addEventListener('hashchange', ()=>{
          this.checkForSwymDrawerHash();
        });
    
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.LayoutInitialized, () => {
          SwymStorefrontLayoutContext?.swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutInitialized, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
          this.checkForSwymDrawerHash();
          this.initElement();
          SwymStorefrontLayoutContext?.swat.evtLayer.addEventListener(SwymStorefrontLayoutContext?.swat.JSEvents.StringsLoaded, (event) => {
            this.loadStrings();
          });
    
          // Handle race condition: StringsLoaded may have fired before LayoutInitialized
          // (e.g. after login redirect when UI bundle is cached). Check if locale strings
          // are already present in retailerSettings and load them immediately if so.
          // setTimeout(0) defers the call until after all LayoutInitialized listeners have
          // fired, so the Tabs component's _layoutInitHandler can set up SwymStorefrontLayoutContext.Tabs
          // before reRenderStorefrontLayoutUI() recreates the DOM.
          const retailerStrings = window._swat?.retailerSettings?.Strings || {};
          const stringsAlreadyLoaded = retailerStrings.ThemeAppStorefrontLayoutTitle || retailerStrings.ThemeAppStorefrontLayoutEmptyWishlistTitle;
          if (stringsAlreadyLoaded) {
            setTimeout(() => this.loadStrings(), 0);
          }
    
          this.attachSwymEventListeners(SwymStorefrontLayoutContext.swat);
          this.instrumentLayoutType();
        });
    
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, () => {
          this.checkForSwymDrawerHash();
        })
      }
    
      instrumentLayoutType(){
        let StorefrontLayoutType = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType;
        if(StorefrontLayoutType === 'as-drawer'){
          SwymStorefrontLayoutContext?.swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSideDrawerRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
        }else if(StorefrontLayoutType === 'as-modal'){
          SwymStorefrontLayoutContext?.swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutModalRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
        }else if(StorefrontLayoutType === 'as-section'){
          SwymStorefrontLayoutContext?.swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutPageRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
        }
      }
    
      reRenderStorefrontLayoutUI() {
        this.reRenderUI();
        this.initElement();
      }
    
      initElement(){
    
        SwymStorefrontLayoutExtensions.SwymStorefrontLayout = document.querySelector('swym-storefront-layout #swym-storefront-layout');
        SwymStorefrontLayoutExtensions.SwymStorefrontLayoutActions = document.querySelector('#swym-storefront-layout-actions') || document.querySelector('#swym-storefront-layout-actions-target-page');
        SwymStorefrontLayoutExtensions.SwymStorefrontLayoutActionTooltip = document.querySelector('#swym-storefront-layout-action-tooltip') || document.querySelector('#swym-storefront-layout-action-tooltip-target-page');
        SwymStorefrontLayoutExtensions.Notification = document.querySelector('swym-storefront-layout-notification');
        SwymStorefrontLayoutExtensions.collectionsListComponent = document.querySelector('swym-storefront-layout-collection-list');
    
      }
    
      loadStrings() {
        try {
          const RetailerStrings = window._swat?.retailerSettings?.Strings || {};
          const {
            ThemeAppStorefrontLayoutTitle,
    
            ThemeAppStorefrontLayoutAddToCartCTA,
            ThemeAppStorefrontLayoutAddedToCartCTA,
            ThemeAppStorefrontLayoutAddingToCartCTA,
            ThemeAppStorefrontLayoutSoldoutCTA,
            ThemeAppStorefrontLayoutViewCartCTA,
            ThemeAppStorefrontLayoutMoveToCartCTA,
            ThemeAppStorefrontLayoutMoveingToCartCTA,
            ThemeAppStorefrontLayoutRemoveSFLItemCTA,
    
            ThemeAppStorefrontLayoutLoginHeading,
            ThemeAppStorefrontLayoutLoginModalTitle,
            ThemeAppStorefrontLayoutLoginMessage,
            ThemeAppStorefrontLayoutLoginButtonCTA,
            ThemeAppStorefrontLayoutLoggedUserWelcomeMessage,
    
            ThemeAppStorefrontLayoutWishlistTitle,
            ThemeAppStorefrontLayoutWishlistInfo,
            ThemeAppStorefrontLayoutEmptyWishlistTitle,
            ThemeAppStorefrontLayoutEmptyWishlistDescription,
    
            ThemeAppStorefrontLayoutCollectionsTitle,
            ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription,
            ThemeAppStorefrontLayoutEmptyCollectionsTitle,
            ThemeAppStorefrontLayoutEmptyCollectionsDescription,
    
            ThemeAppStorefrontLayoutAddToCollectionsTitle,
            ThemeAppStorefrontLayoutAddToCollectionCTA,
            ThemeAppStorefrontLayoutCreateCollectionCTA,
            ThemeAppStorefrontLayoutSaveNewCollectionCTA,
            ThemeAppStorefrontLayoutRemoveItemCTA,
            ThemeAppStorefrontLayoutRenameCollectionCTA,
            ThemeAppStorefrontLayoutDeleteCollectionCTA,
            ThemeAppStorefrontLayoutShareCollectionCTA,
            ThemeAppStorefrontLayoutSaveCollectionCTA,
            ThemeAppStorefrontLayoutEditCollectionCTA,
            ThemeAppStorefrontLayoutShareCollectionTitle,
            ThemeAppStorefrontLayoutShareCollectionMessage,
            ThemeAppStorefrontLayoutSharedCollectionMessage,
            ThemeAppStorefrontLayoutUpdateCollectionTitle,
    
            ThemeAppStorefrontLayoutErrorMessageListNameRequired,
            ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char,
            ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist,
    
            ThemeAppStorefrontLayoutNotificationMessageItemSaved,
            ThemeAppStorefrontLayoutNotificationMessageItemRemoved,
            ThemeAppStorefrontLayoutNotificationMessageAddedToCart,
            ThemeAppStorefrontLayoutNotificationMessageAddedToCollection,
            ThemeAppStorefrontLayoutNotificationMessageCollectionSaved,
            ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted,
            ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated,
            ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable,
            ThemeAppStorefrontLayoutNotificationMessageSFLItemSaved,
            ThemeAppStorefrontLayoutNotificationMessageSFLItemRemoved,
            ThemeAppStorefrontLayoutNotificationMessageMovedToCart,
    
            ThemeAppStorefrontLayoutNotificationActionAddToCollection,
            ThemeAppStorefrontLayoutNotificationActionView,
            ThemeAppStorefrontLayoutNotificationActionViewCollection,
            ThemeAppStorefrontLayoutNotificationActionGoToCart,
    
            ThemeAppStorefrontLayoutTextItem,
            ThemeAppStorefrontLayoutTextItems,
    
            ThemeAppStorefrontLayoutTabWishlist,
            ThemeAppStorefrontLayoutTabSavedForLater,
            ThemeAppStorefrontLayoutSaveForLaterTitle,
            ThemeAppStorefrontLayoutEmptySavedForLaterTitle,
            ThemeAppStorefrontLayoutEmptySavedForLaterDescription,
            VariantSelectorBtnText,
    
            ThemeAppStorefrontLayoutEmptySingleLoggedInTitle,
            ThemeAppStorefrontLayoutEmptySingleLoggedInDescription,
            ThemeAppStorefrontLayoutEmptySingleLoggedInBullet1,
            ThemeAppStorefrontLayoutEmptySingleLoggedInBullet2,
            ThemeAppStorefrontLayoutEmptySingleLoggedInBullet3,
            ThemeAppStorefrontLayoutEmptySingleLoggedInCTA,
    
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTitle,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInDescription,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateTitle,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateDescription,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInBrowseLabel,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInCTA,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTag1,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTag2,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTag3,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTag4,
            ThemeAppStorefrontLayoutEmptyMultiLoggedInTag5,
    
            ThemeAppStorefrontLayoutEmptyGuestTitle,
            ThemeAppStorefrontLayoutEmptyGuestDescription,
            ThemeAppStorefrontLayoutEmptyGuestSingleNotice,
            ThemeAppStorefrontLayoutEmptyGuestMultiNotice,
            ThemeAppStorefrontLayoutEmptyGuestLoginCTA,
            ThemeAppStorefrontLayoutEmptyGuestBrowseCTA,
            ThemeAppStorefrontLayoutEmptyGuestSignupText,
            ThemeAppStorefrontLayoutEmptyGuestSignupCTA,
    
            ThemeAppStorefrontLayoutEmptySflTitle,
            ThemeAppStorefrontLayoutEmptySflDescription,
            ThemeAppStorefrontLayoutEmptySflStep1Title,
            ThemeAppStorefrontLayoutEmptySflStep1Description,
            ThemeAppStorefrontLayoutEmptySflStep2Title,
            ThemeAppStorefrontLayoutEmptySflStep2Description,
            ThemeAppStorefrontLayoutEmptySflLoggedInNotice,
            ThemeAppStorefrontLayoutEmptySflGuestNotice,
            ThemeAppStorefrontLayoutEmptySflGoToCartCTA,
            ThemeAppStorefrontLayoutEmptySflLoginCTA,
            ThemeAppStorefrontLayoutEmptySflSignupText,
            ThemeAppStorefrontLayoutEmptySflSignupCTA,
    
            ThemeAppStorefrontLayoutTabSavedForYou,
    
            // Drawer UI Polish — personalized titles and share footer (single wishlist mode)
            ThemeAppStorefrontLayoutPersonalizedTitle,
            ThemeAppStorefrontLayoutPersonalizedSfyTitle,
            ThemeAppStorefrontLayoutShareCTA,
            ThemeAppStorefrontLayoutShareThisListCTA,
            ThemeAppStorefrontLayoutLoginToSaveCTA,
            ThemeAppStorefrontLayoutViewListCTA,
            ThemeAppStorefrontLayoutContinueShoppingCTA,
    
            // Auto-Wishlist login nudge strings (corner notification)
            ThemeAppStorefrontLayoutAwNudgeMessage,
            ThemeAppStorefrontLayoutAwNudgeMessageSub,
            ThemeAppStorefrontLayoutAwNudgeLoginCTA,
            ThemeAppStorefrontLayoutAwNudgeDismiss,
          } = RetailerStrings;
    
          SwymStorefrontLayoutContext.Strings = {
            ...SwymStorefrontLayoutContext?.Strings,
            ...(ThemeAppStorefrontLayoutTitle ? { 'title': ThemeAppStorefrontLayoutTitle } : {}),
            ...(VariantSelectorBtnText ? { 'VariantSelectorBtnText': VariantSelectorBtnText } : {}),
            ...(ThemeAppStorefrontLayoutAddToCartCTA ? { 'addToCart': ThemeAppStorefrontLayoutAddToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutAddedToCartCTA ? { 'addedToCart': ThemeAppStorefrontLayoutAddedToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutAddingToCartCTA ? { 'addingToCart': ThemeAppStorefrontLayoutAddingToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutSoldoutCTA ? { 'soldOut': ThemeAppStorefrontLayoutSoldoutCTA } : {}),
            ...(ThemeAppStorefrontLayoutViewCartCTA ? { 'viewCartCta': ThemeAppStorefrontLayoutViewCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutMoveToCartCTA ? { 'moveToCartCta': ThemeAppStorefrontLayoutMoveToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutMoveingToCartCTA ? { 'movingToCartCta': ThemeAppStorefrontLayoutMoveingToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutRemoveSFLItemCTA ? { 'removeSflItemCta': ThemeAppStorefrontLayoutRemoveSFLItemCTA } : {}),
    
            ...(ThemeAppStorefrontLayoutLoginHeading ? { 'loginHeading': ThemeAppStorefrontLayoutLoginHeading } : {}),
            ...(ThemeAppStorefrontLayoutLoginModalTitle ? { 'loginModalTitle': ThemeAppStorefrontLayoutLoginModalTitle } : {}),
            ...(ThemeAppStorefrontLayoutLoginMessage ? { 'loginText': ThemeAppStorefrontLayoutLoginMessage } : {}),
            ...(ThemeAppStorefrontLayoutLoginButtonCTA ? { 'loginButtonText': ThemeAppStorefrontLayoutLoginButtonCTA } : {}),
            ...(ThemeAppStorefrontLayoutLoggedUserWelcomeMessage ? { 'loggedUserWelcomeMessage': ThemeAppStorefrontLayoutLoggedUserWelcomeMessage } : {}),
    
            ...(ThemeAppStorefrontLayoutWishlistTitle ? { 'wishlistTitle': ThemeAppStorefrontLayoutWishlistTitle } : {}),
            ...(ThemeAppStorefrontLayoutWishlistInfo ? { 'wishlistInfo': ThemeAppStorefrontLayoutWishlistInfo } : {}),
            ...(ThemeAppStorefrontLayoutEmptyWishlistTitle ? { 'emptyWishlistTitle': ThemeAppStorefrontLayoutEmptyWishlistTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyWishlistDescription ? { 'emptyWishlistDescription': ThemeAppStorefrontLayoutEmptyWishlistDescription } : {}),
    
            ...(ThemeAppStorefrontLayoutCollectionsTitle ? { 'collectionTitle': ThemeAppStorefrontLayoutCollectionsTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription ? { 'emptyCarouselCollectionText': ThemeAppStorefrontLayoutEmptyCarouselCollectionsDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptyCollectionsTitle ? { 'emptyCollectionText': ThemeAppStorefrontLayoutEmptyCollectionsTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyCollectionsDescription ? { 'emptyCollectionDescription': ThemeAppStorefrontLayoutEmptyCollectionsDescription } : {}),
    
            ...(ThemeAppStorefrontLayoutAddToCollectionsTitle ? { 'addToCollectionTitle': ThemeAppStorefrontLayoutAddToCollectionsTitle } : {}),
            ...(ThemeAppStorefrontLayoutAddToCollectionCTA ? { 'addToCollectionCta': ThemeAppStorefrontLayoutAddToCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutCreateCollectionCTA ? { 'createCollectionCta': ThemeAppStorefrontLayoutCreateCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutSaveNewCollectionCTA ? { 'saveNewCollectionCta': ThemeAppStorefrontLayoutSaveNewCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutRemoveItemCTA ? { 'removeItemCta': ThemeAppStorefrontLayoutRemoveItemCTA } : {}),
            ...(ThemeAppStorefrontLayoutRenameCollectionCTA ? { 'renameCollectionCta': ThemeAppStorefrontLayoutRenameCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutDeleteCollectionCTA ? { 'deleteCollectionCta': ThemeAppStorefrontLayoutDeleteCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutShareCollectionCTA ? { 'shareCollectionCta': ThemeAppStorefrontLayoutShareCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutSaveCollectionCTA ? { 'saveCollectionCta': ThemeAppStorefrontLayoutSaveCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutEditCollectionCTA ? { 'editCollectionCta': ThemeAppStorefrontLayoutEditCollectionCTA } : {}),
            ...(ThemeAppStorefrontLayoutShareCollectionTitle ? { 'shareCollectionTitle': ThemeAppStorefrontLayoutShareCollectionTitle } : {}),
            ...(ThemeAppStorefrontLayoutShareCollectionMessage ? { 'shareCollectionMessage': ThemeAppStorefrontLayoutShareCollectionMessage } : {}),
            ...(ThemeAppStorefrontLayoutSharedCollectionMessage ? { 'sharedCollectionMessage': ThemeAppStorefrontLayoutSharedCollectionMessage } : {}),
            ...(ThemeAppStorefrontLayoutUpdateCollectionTitle ? { 'updateCollectionTitle': ThemeAppStorefrontLayoutUpdateCollectionTitle } : {}),
    
            ...(ThemeAppStorefrontLayoutErrorMessageListNameRequired ? { 'errorMessageListNameRequired': ThemeAppStorefrontLayoutErrorMessageListNameRequired } : {}),
            ...(ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char ? { 'errorMessageListNameRequire3Char': ThemeAppStorefrontLayoutErrorMessageListNameRequired3Char } : {}),
            ...(ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist ? { 'errorMessageListNameAlreadyExist': ThemeAppStorefrontLayoutErrorMessageListNameAlreadyExist } : {}),
    
            ...(ThemeAppStorefrontLayoutNotificationMessageItemSaved ? { 'notificationMessageItemSaved': ThemeAppStorefrontLayoutNotificationMessageItemSaved } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageItemRemoved ? { 'notificationMessageItemRemoved': ThemeAppStorefrontLayoutNotificationMessageItemRemoved } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageAddedToCart ? { 'notificationMessageAddedToCart': ThemeAppStorefrontLayoutNotificationMessageAddedToCart } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageAddedToCollection ? { 'notificationMessageAddedToCollection': ThemeAppStorefrontLayoutNotificationMessageAddedToCollection } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageCollectionSaved ? { 'notificationMessageCollectionSaved': ThemeAppStorefrontLayoutNotificationMessageCollectionSaved } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted ? { 'notificationMessageCollectionDeleted': ThemeAppStorefrontLayoutNotificationMessageCollectionDeleted } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated ? { 'notificationMessageCollectionUpdated': ThemeAppStorefrontLayoutNotificationMessageCollectionUpdated } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable ? { 'notificationMessageCollectionUnavailable': ThemeAppStorefrontLayoutNotificationMessageCollectionUnavailable } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageSFLItemSaved ? { 'notificationMessageSFLItemSaved': ThemeAppStorefrontLayoutNotificationMessageSFLItemSaved } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageSFLItemRemoved ? { 'notificationMessageSFLItemRemoved': ThemeAppStorefrontLayoutNotificationMessageSFLItemRemoved } : {}),
            ...(ThemeAppStorefrontLayoutNotificationMessageMovedToCart ? { 'notificationMessageMovedToCart': ThemeAppStorefrontLayoutNotificationMessageMovedToCart } : {}),
            
            ...(ThemeAppStorefrontLayoutNotificationActionAddToCollection ? { 'notificationActionAddToCollection': ThemeAppStorefrontLayoutNotificationActionAddToCollection } : {}),
            ...(ThemeAppStorefrontLayoutNotificationActionView ? { 'notificationActionView': ThemeAppStorefrontLayoutNotificationActionView } : {}),
            ...(ThemeAppStorefrontLayoutNotificationActionViewCollection ? { 'notificationActionViewCollection': ThemeAppStorefrontLayoutNotificationActionViewCollection } : {}),
            ...(ThemeAppStorefrontLayoutNotificationActionGoToCart ? { 'notificationActionGoToCart': ThemeAppStorefrontLayoutNotificationActionGoToCart } : {}),
    
            ...(ThemeAppStorefrontLayoutTextItem ? { 'item': ThemeAppStorefrontLayoutTextItem } : {}),
            ...(ThemeAppStorefrontLayoutTextItems ? { 'items': ThemeAppStorefrontLayoutTextItems } : {}),
            
            ...(ThemeAppStorefrontLayoutTabWishlist ? { 'tabWishlist': ThemeAppStorefrontLayoutTabWishlist } : {}),
            ...(ThemeAppStorefrontLayoutTabSavedForLater ? { 'tabSavedForLater': ThemeAppStorefrontLayoutTabSavedForLater } : {}),
            tabSavedForYou: ThemeAppStorefrontLayoutTabSavedForYou || RetailerStrings?.AutoWishlistedTabText || 'Saved For You',
            ...(ThemeAppStorefrontLayoutSaveForLaterTitle ? { 'savedForLaterTitle': ThemeAppStorefrontLayoutSaveForLaterTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptySavedForLaterTitle ? { 'emptySavedForLaterTitle': ThemeAppStorefrontLayoutEmptySavedForLaterTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptySavedForLaterDescription ? { 'emptySavedForLaterDescription': ThemeAppStorefrontLayoutEmptySavedForLaterDescription } : {}),
    
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInTitle ? { 'emptySingleLoggedInTitle': ThemeAppStorefrontLayoutEmptySingleLoggedInTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInDescription ? { 'emptySingleLoggedInDescription': ThemeAppStorefrontLayoutEmptySingleLoggedInDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInBullet1 ? { 'emptySingleLoggedInBullet1': ThemeAppStorefrontLayoutEmptySingleLoggedInBullet1 } : {}),
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInBullet2 ? { 'emptySingleLoggedInBullet2': ThemeAppStorefrontLayoutEmptySingleLoggedInBullet2 } : {}),
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInBullet3 ? { 'emptySingleLoggedInBullet3': ThemeAppStorefrontLayoutEmptySingleLoggedInBullet3 } : {}),
            ...(ThemeAppStorefrontLayoutEmptySingleLoggedInCTA ? { 'emptySingleLoggedInCTA': ThemeAppStorefrontLayoutEmptySingleLoggedInCTA } : {}),
    
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTitle ? { 'emptyMultiLoggedInTitle': ThemeAppStorefrontLayoutEmptyMultiLoggedInTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInDescription ? { 'emptyMultiLoggedInDescription': ThemeAppStorefrontLayoutEmptyMultiLoggedInDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateTitle ? { 'emptyMultiLoggedInCreateTitle': ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateDescription ? { 'emptyMultiLoggedInCreateDescription': ThemeAppStorefrontLayoutEmptyMultiLoggedInCreateDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInBrowseLabel ? { 'emptyMultiLoggedInBrowseLabel': ThemeAppStorefrontLayoutEmptyMultiLoggedInBrowseLabel } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInCTA ? { 'emptyMultiLoggedInCTA': ThemeAppStorefrontLayoutEmptyMultiLoggedInCTA } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTag1 ? { 'emptyMultiLoggedInTag1': ThemeAppStorefrontLayoutEmptyMultiLoggedInTag1 } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTag2 ? { 'emptyMultiLoggedInTag2': ThemeAppStorefrontLayoutEmptyMultiLoggedInTag2 } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTag3 ? { 'emptyMultiLoggedInTag3': ThemeAppStorefrontLayoutEmptyMultiLoggedInTag3 } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTag4 ? { 'emptyMultiLoggedInTag4': ThemeAppStorefrontLayoutEmptyMultiLoggedInTag4 } : {}),
            ...(ThemeAppStorefrontLayoutEmptyMultiLoggedInTag5 ? { 'emptyMultiLoggedInTag5': ThemeAppStorefrontLayoutEmptyMultiLoggedInTag5 } : {}),
    
            ...(ThemeAppStorefrontLayoutEmptyGuestTitle ? { 'emptyGuestTitle': ThemeAppStorefrontLayoutEmptyGuestTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestDescription ? { 'emptyGuestDescription': ThemeAppStorefrontLayoutEmptyGuestDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestSingleNotice ? { 'emptyGuestSingleNotice': ThemeAppStorefrontLayoutEmptyGuestSingleNotice } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestMultiNotice ? { 'emptyGuestMultiNotice': ThemeAppStorefrontLayoutEmptyGuestMultiNotice } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestLoginCTA ? { 'emptyGuestLoginCTA': ThemeAppStorefrontLayoutEmptyGuestLoginCTA } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestBrowseCTA ? { 'emptyGuestBrowseCTA': ThemeAppStorefrontLayoutEmptyGuestBrowseCTA } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestSignupText ? { 'emptyGuestSignupText': ThemeAppStorefrontLayoutEmptyGuestSignupText } : {}),
            ...(ThemeAppStorefrontLayoutEmptyGuestSignupCTA ? { 'emptyGuestSignupCTA': ThemeAppStorefrontLayoutEmptyGuestSignupCTA } : {}),
    
            ...(ThemeAppStorefrontLayoutEmptySflTitle ? { 'emptySflTitle': ThemeAppStorefrontLayoutEmptySflTitle } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflDescription ? { 'emptySflDescription': ThemeAppStorefrontLayoutEmptySflDescription } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflStep1Title ? { 'emptySflStep1Title': ThemeAppStorefrontLayoutEmptySflStep1Title } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflStep1Description ? { 'emptySflStep1Description': ThemeAppStorefrontLayoutEmptySflStep1Description } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflStep2Title ? { 'emptySflStep2Title': ThemeAppStorefrontLayoutEmptySflStep2Title } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflStep2Description ? { 'emptySflStep2Description': ThemeAppStorefrontLayoutEmptySflStep2Description } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflLoggedInNotice ? { 'emptySflLoggedInNotice': ThemeAppStorefrontLayoutEmptySflLoggedInNotice } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflGuestNotice ? { 'emptySflGuestNotice': ThemeAppStorefrontLayoutEmptySflGuestNotice } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflGoToCartCTA ? { 'emptySflGoToCartCTA': ThemeAppStorefrontLayoutEmptySflGoToCartCTA } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflLoginCTA ? { 'emptySflLoginCTA': ThemeAppStorefrontLayoutEmptySflLoginCTA } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflSignupText ? { 'emptySflSignupText': ThemeAppStorefrontLayoutEmptySflSignupText } : {}),
            ...(ThemeAppStorefrontLayoutEmptySflSignupCTA ? { 'emptySflSignupCTA': ThemeAppStorefrontLayoutEmptySflSignupCTA } : {}),
    
            // Auto-Wishlist login nudge strings
            // Fallback chain: merchant Liquid override → SDK locale strings (strings/*.js via retailerSettings) → empty string
            awNudgeMessage: ThemeAppStorefrontLayoutAwNudgeMessage || RetailerStrings?.ThemeAppStorefrontLayoutAwNudgeMessage || '',
            awNudgeMessageSub: ThemeAppStorefrontLayoutAwNudgeMessageSub || RetailerStrings?.ThemeAppStorefrontLayoutAwNudgeMessageSub || '',
            awNudgeLoginCTA: ThemeAppStorefrontLayoutAwNudgeLoginCTA || RetailerStrings?.ThemeAppStorefrontLayoutAwNudgeLoginCTA || '',
            awNudgeDismiss: ThemeAppStorefrontLayoutAwNudgeDismiss || RetailerStrings?.ThemeAppStorefrontLayoutAwNudgeDismiss || '',
            // Explicit WL login nudge — only bold message differs; sub-message, CTA and dismiss reuse AW strings
            explicitNudgeMessage: RetailerStrings?.ThemeAppStorefrontLayoutExplicitNudgeMessage || '',
    
            // Drawer UI Polish — personalized titles and share footer
            personalizedTitle: ThemeAppStorefrontLayoutPersonalizedTitle || RetailerStrings?.ThemeAppStorefrontLayoutPersonalizedTitle || "{{name}}'s Wishlist",
            personalizedSfyTitle: ThemeAppStorefrontLayoutPersonalizedSfyTitle || RetailerStrings?.ThemeAppStorefrontLayoutPersonalizedSfyTitle || 'Saved For {{name}}',
            shareCta: ThemeAppStorefrontLayoutShareCTA || RetailerStrings?.ThemeAppStorefrontLayoutShareCTA || 'Share',
            shareThisListCta: ThemeAppStorefrontLayoutShareThisListCTA || RetailerStrings?.ThemeAppStorefrontLayoutShareThisListCTA || 'Share This List',
            loginToSaveCta: ThemeAppStorefrontLayoutLoginToSaveCTA || RetailerStrings?.ThemeAppStorefrontLayoutLoginToSaveCTA || 'Login to Save',
            viewListCta: ThemeAppStorefrontLayoutViewListCTA || RetailerStrings?.ThemeAppStorefrontLayoutViewListCTA || 'View list',
            continueShoppingCta: ThemeAppStorefrontLayoutContinueShoppingCTA || RetailerStrings?.ThemeAppStorefrontLayoutContinueShoppingCTA || 'Continue shopping',
    
          }
          SwymStorefrontLayoutContext.stringsLoaded = true;
          this.reRenderStorefrontLayoutUI();
        } catch (error) {
          window._swat?.utils.error(error);
        }
      }
    
      async checkForSwymDrawerHash() {
        const { StorefrontLayoutType, StorefrontLayoutAsSectionPageURL } = SwymStorefrontLayoutContext?.Settings;
        const currentHash = window.location.hash;
        const swymOpenParam = new URLSearchParams(window.location.search).get('swymOpen');
        const shouldOpenFromQuery = swymOpenParam === 'wishlist';
    
        if(!SwymStorefrontLayoutExtensions.SwymStorefrontLayout){
          SwymStorefrontLayoutExtensions.SwymStorefrontLayout = document.querySelector('swym-storefront-layout #swym-storefront-layout');
        }
    
        if(!currentHash && !shouldOpenFromQuery && SwymStorefrontLayoutExtensions.SwymStorefrontLayout?.isOpen){
          SwymStorefrontLayoutExtensions.SwymStorefrontLayout?.close?.();
          return;
        }
    
        const openWishlistPage = () => {
            if (StorefrontLayoutType === 'as-drawer' || StorefrontLayoutType === 'as-modal') {
                SwymStorefrontLayoutExtensions?.SwymStorefrontLayout?.open();
            } else if (StorefrontLayoutType === 'as-section') {
              const normalize = s => s.replace(/\/+$/, '');
              const ensureLeadingSlash = s => (s?.startsWith('/') ? s : `/${s || ''}`);
              const localeRoot = window.Shopify?.routes?.root || '/';
              const formattedLocale = localeRoot === '/' ? '' : localeRoot.replace(/\/$/, '');
              const sectionPath = ensureLeadingSlash(StorefrontLayoutAsSectionPageURL);
              const expected = normalize(`${formattedLocale}${sectionPath}`);
              const current = normalize(window.location.pathname);
              
              if (current !== expected) {
                const redirectUrl = `${window.location.origin}${formattedLocale}${sectionPath}${window.location.search}`;
                window.location.replace(redirectUrl);
              }
            }
        };
    
        if (currentHash === SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List || shouldOpenFromQuery) {
          SwymStorefrontLayoutExtensions?.collectionsListComponent?.closeCollectinListView();
            openWishlistPage();
        } else if (currentHash.startsWith(SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList)) {
            const collectionId = currentHash.slice(SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList.length);
    
            if (collectionId && SwymStorefrontLayoutContext?.collections) {
                const selectedCollection = SwymStorefrontLayoutContext?.collections?.find(collection => collection.lid === collectionId);
    
                if (selectedCollection) {
                  const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
                  SwymStorefrontLayoutExtensions?.collectionsListComponent?.setData({
                    list: selectedCollection,
                    collections: SwymStorefrontLayoutContext?.collections,
                    canCreateLists: canCreateLists,
                    shouldShowMultiple: shouldShowMultiple
                  });
                  SwymStorefrontLayoutExtensions?.collectionsListComponent?.openCollectionListView();
                } else {
                  try{
                    const sharedListDetails = await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.fetchListDetails(collectionId);
                    if(sharedListDetails?.list){
                      let [list] = await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.fetchProductDataForLists([sharedListDetails.list], true) || [];
                      if(list){
                        const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
                        SwymStorefrontLayoutExtensions?.collectionsListComponent?.setData({
                          list,
                          collections: SwymStorefrontLayoutContext?.collections,
                          canCreateLists: canCreateLists,
                          shouldShowMultiple: shouldShowMultiple
                        });
                        SwymStorefrontLayoutExtensions?.collectionsListComponent?.openCollectionListView();
                      }else{
                        throw 'Failed to get product data for shared list';
                      }
                    }else{
                      throw 'Collection Not Available';
                    }
                  }catch(e){
                    SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                      message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionUnavailable,
                      status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Error,
                      duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration
                    });
                    window._swat?.utils.error(`Collection detail not found for ID: ${collectionId}. It may have been deleted or is unavailable.`,e);
                  }
                }
    
                openWishlistPage();
            }
        }
      }
    
        /**
       * Attaches event listeners to Swym's event layer for handling various storefront layout interactions.
       * 
       * Key Features:
       * - Refreshes the wishlist and save-for-later (SFL) lists when customer information is updated.
       * - Handles events for adding and removing items from the wishlist and SFL.
       * - Displays notifications for user actions such as adding to wishlist, removing items, or moving items to the cart.
       * - Tracks user interactions using Swym's instrumentation for analytics.
       * - Supports multi-list and collection features based on retailer settings.
       * 
       * Events Handled:
       * - `customerInfoRefreshed`: Refreshes wishlist and SFL lists.
       * - `addedToWishlist`: Updates the wishlist and displays a notification when an item is added.
       * - `removedFromWishlist`: Updates the wishlist and displays a notification when an item is removed.
       * - `addedToSFL`: Updates the SFL list and displays a notification when an item is added.
       * - `removedFromSFL`: Updates the SFL list and displays a notification when an item is removed.
       * - `movedToCartFromSFL`: Refreshes the SFL list when an item is moved to the cart.
       * 
       * Dependencies:
       * - SwymStorefrontLayoutExtensions: Provides methods for refreshing lists and managing notifications.
       * - SwymStorefrontLayoutContext: Provides context for settings, strings, and instrumentation codes.
       * - Swym's event layer (`swat.evtLayer`): Listens for and triggers events.
       */
      
      attachSwymEventListeners(swat) {
    
        swat?.evtLayer?.addEventListener(swat?.JSEvents?.customerInfoRefreshed, ()=>{
          SwymStorefrontLayoutExtensions?.refreshWishList();
          if(window._swat?.retailerSettings?.SFL?.SFLFeatureEnabled){
            SwymStorefrontLayoutExtensions?.refreshSFLList();
          }
        })
    
        //Wishlist Events 
        swat?.evtLayer?.addEventListener(swat?.JSEvents?.addedToWishlist, (event) => {
          if (SwymStorefrontLayoutContext._sfyMoveToWishlist || SwymStorefrontLayoutContext.dragMovingEpis?.has(String(event?.detail?.d?.epi))) return;
          SwymStorefrontLayoutExtensions?.refreshWishList();
    
          let image = event?.detail?.d?.iu || null;
          let { epi, empi } = event?.detail?.d || {};
          let product = event?.detail.d;
          
          const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          
          swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemAddedToList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
            if(SwymStorefrontLayoutContext?.swat?.ui?.uiRef?.settings?.UI?.WishlistShowNotification && !SwymStorefrontLayoutContext.CommonAddtoWL){
              SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemSaved,
                status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
                duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                product,
                image
              },{
                showImage: true,
                showProgress: true
              });
        
              setTimeout(()=>{
                    if(SwymStorefrontLayoutExtensions?.Notification?.notificationData?.actionType === SwymStorefrontLayoutContext?.NotificationActionTypes?.AddedToWishlist){
                      SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                        status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                        actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
                        duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                        product,
                        image,
                        action: {
                            label: canCreateLists ? SwymStorefrontLayoutContext?.Strings?.notificationActionAddToCollection : SwymStorefrontLayoutContext?.Strings?.notificationActionView,
                            onClick: () => {
                              if(canCreateLists){
                                SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutPageActions?.setData({
                                  listId: SwymStorefrontLayoutContext?.DefaultList?.lid,
                                  list: SwymStorefrontLayoutContext?.DefaultList,
                                  item: product,
                                  collections: SwymStorefrontLayoutContext?.collections,
                                  actionType: SwymStorefrontLayoutContext?.ActionTypes.AddToCollection
                                });
                                SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutPageActions?.openDrawer();
                              }else{
                                window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List; 
                              }
                            }
                        }
                      },{
                        showImage: true,
                        showActionButton: true,
                        showTitle: true
                      });
                    }
              },3000);
            }
          if(SwymStorefrontLayoutContext.CommonAddtoWL && !SwymStorefrontLayoutContext.CommonRemovefromWL) {
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemSaved,
                status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
                duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                product,
                image
              },{
                showImage: true,
                showProgress: true
              });
            SwymStorefrontLayoutContext.CommonAddtoWL = false  
    
            setTimeout(() => {
              SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                        status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                        actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
                        duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                        product,
                        image,
                        action: {
                            label: SwymStorefrontLayoutContext?.Strings?.notificationActionView,
                            onClick: () => {
                             _swat.ui.open();
                            }
                        }
                      },{
                        showImage: true,
                        showActionButton: true,
                        showTitle: true
                      });
            }, 3000)
          }
        });
    
        swat?.evtLayer?.addEventListener(swat?.JSEvents?.removedFromWishlist, (event) => {
          if (SwymStorefrontLayoutContext._sfyMoveToWishlist || SwymStorefrontLayoutContext.dragMovingEpis?.has(String(event?.detail?.d?.epi))) return;

          let image = event?.detail?.d?.iu || null;
          let { epi, empi } = event?.detail?.d || {};
          const product = event?.detail.d;
          if( epi && empi){
            // Use the new helper to determine behavior
            const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
            
            // If showing multiple lists (either feature enabled OR multiple lists exist), do a full refresh
            if (shouldShowMultiple) {
              SwymStorefrontLayoutExtensions?.refreshWishList();
            } else {
              // Single wishlist: Update local state instead of refetching to avoid price double-formatting issue
              if (SwymStorefrontLayoutContext.DefaultList) {
                SwymStorefrontLayoutContext.DefaultList.listcontents = 
                  (SwymStorefrontLayoutContext.DefaultList.listcontents || []).filter(item => item.epi !== epi);
              }
              if (SwymStorefrontLayoutContext.collections) {
                SwymStorefrontLayoutContext.collections = (SwymStorefrontLayoutContext.collections || []).map(list => ({
                  ...list,
                  listcontents: (list.listcontents || []).filter(item => item.epi !== epi)
                }));
              }
              if (SwymStorefrontLayoutContext.lists) {
                SwymStorefrontLayoutContext.lists = (SwymStorefrontLayoutContext.lists || []).map(list => ({
                  ...list,
                  listcontents: (list.listcontents || []).filter(item => item.epi !== epi)
                }));
              }
              
              // Dispatch WishlistFetched event to update UI components
              if(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched){
                var wishlistFetchedEvent = new CustomEvent(SwymStorefrontLayoutContext.CustomEvents.WishlistFetched, {
                  detail: { 
                    defaultList: SwymStorefrontLayoutContext.DefaultList, 
                    collections: SwymStorefrontLayoutContext.collections, 
                    lists: SwymStorefrontLayoutContext.lists 
                  }
                });
                document.dispatchEvent(wishlistFetchedEvent);
              }
            }
            
            swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemRemovedFromList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi }); 
          }
          if((SwymStorefrontLayoutContext.CommonRemovefromWL && SwymStorefrontLayoutContext.CommonAddtoWL) || SwymStorefrontLayoutContext.CommonRemovefromWL) {
              if(SwymStorefrontLayoutContext.CommonRemovefromWL && !SwymStorefrontLayoutContext.CommonAddtoWL) {
                SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                  message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemRemoved,
                  status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
                  duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                  image
                });        
                SwymStorefrontLayoutContext.CommonRemovefromWL = false;
                setTimeout(() => {
                  SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                    status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                    actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToWishlist,
                    duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                    product,
                    image,
                    action: {
                        label: SwymStorefrontLayoutContext?.Strings?.notificationActionView,
                        onClick: () => {
                        _swat.ui.open();
                        }
                    }
                  },{
                    showImage: true,
                    showActionButton: true,
                    showTitle: true
                  });
                }, 3000)
            }
            return
          }
          SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemRemoved,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              image
            });
        });
    
        //SFL Events 
        if(window._swat?.retailerSettings?.SFL?.SFLFeatureEnabled){
          swat.evtLayer.addEventListener(swat.JSEvents.addedToSFL, (event) => {
            let image = event?.detail?.d?.iu || null;
            let title = event?.detail?.d?.dt || null;
            let { epi, empi } = event?.detail?.d || {};
            window._swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFLItemAddedToList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
            
            SwymStorefrontLayoutExtensions?.refreshSFLList();
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageSFLItemSaved,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              image,
              title
            },{
              showProgress: true,
              showTitle: true
            });
          });
    
          swat.evtLayer.addEventListener(swat.JSEvents.removedFromSFL, (event) => {
            let image = event?.detail?.d?.iu || null;
            let title = event?.detail?.d?.dt || null;
            let { epi, empi } = event?.detail?.d || {};
            window._swat.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFLItemRemovedFromList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
            SwymStorefrontLayoutExtensions?.refreshSFLList();
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageSFLItemRemoved,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              image,
              title
            },{
              showProgress: true,
              showTitle: true
            });
          });
    
          swat.evtLayer.addEventListener(swat.JSEvents.movedToCartFromSFL, (event) => {
            swat.utils.debounce(()=>{
              SwymStorefrontLayoutExtensions?.refreshSFLList();
            }, 1000)();
          });
    
        }
      }
    
    }
    
    /**
     * SwymStorefrontLayoutAsModal
     * 
     * This class extends SwymWishlistCore to render a modal-based storefront layout for the Swym wishlist.
     * It manages UI rendering, event listeners, and open/close interactions.
     * 
     * Features:
     * - Displays a modal layout for wishlist functionality.
     * - Supports collection carousel based on SwymStorefrontLayoutContext settings.
     * - Provides a close button and backdrop click handling to close the modal.
     * - Tracks UI engagement using Swym's instrumentation.
     * 
     * Methods:
     * - renderUI(): Generates the modal's HTML structure.
     * - initUIElement(): Initializes UI elements and event listeners.
     * - attachDrawerEventListner(): Binds click events to close the modal.
     * - open(): Opens the modal and updates the UI state.
     * - close(): Closes the modal, removes body scroll lock, and updates history state.
     * - reRenderUI(): Re-renders the UI while preserving the open state.
     * 
     * Usage:
     * <swym-storefront-layout-as-modal></swym-storefront-layout-as-modal>
     */
      class SwymStorefrontLayoutAsModal extends SwymWishlistCore {
        constructor() {
          super();
          this.renderUI();
        }
    
        renderUI() {
          this.innerHTML = `
          <div id="swym-storefront-layout-container" class="swym-storefront-layout-drawer swym-storefront-layout-hide-view" tabindex="-1" role="dialog" aria-modal="true" aria-labelledby="swym-wishlist-title">
            <div class="swym-storefront-layout-backdrop"></div>
            <div class="swym-storefront-layout-layout">
              <swym-storefront-layout-tabs></swym-storefront-layout-tabs>
              <button id="swym-storefront-layout-close-drawer-button" aria-label="${SwymStorefrontLayoutContext?.Strings?.closeDrawer || 'Close'}" class="swym-storefront-layout-close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none" aria-hidden="true">
                  <path d="M0 13.5C0 6.04416 6.04416 0 13.5 0C20.9558 0 27 6.04416 27 13.5C27 20.9558 20.9558 27 13.5 27C6.04416 27 0 20.9558 0 13.5Z" fill="none" fill-opacity="0.5"/>
                  <path d="M16.0245 17.8326C16.2477 18.0558 16.6095 18.0558 16.8326 17.8326C17.0558 17.6095 17.0558 17.2477 16.8326 17.0245L13.8081 14L16.8326 10.9755C17.0558 10.7523 17.0558 10.3905 16.8326 10.1674C16.6095 9.94421 16.2477 9.94421 16.0245 10.1674L13 13.1919L9.97549 10.1674C9.75233 9.94421 9.39052 9.94421 9.16737 10.1674C8.94421 10.3905 8.94421 10.7523 9.16737 10.9755L12.1919 14L9.16737 17.0245C8.94421 17.2477 8.94421 17.6095 9.16737 17.8326C9.39052 18.0558 9.75233 18.0558 9.97549 17.8326L13 14.8081L16.0245 17.8326Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <swym-storefront-layout-tab-content class="swym-storefront-layout-container swym-storefront-layout-scrollable"></swym-storefront-layout-tab-content>
              <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
            </div>
          </div>
        `;
    
          this.initUIElement();
        }
    
      initUIElement() {
        this.elements = {
          drawer: this.querySelector('.swym-storefront-layout-drawer'),
          drawerCloseButton: this.querySelector('#swym-storefront-layout-close-drawer-button'),
          drawerbackdrop: this.querySelector('.swym-storefront-layout-backdrop'),
          collectionList: this.querySelector('#swym-storefront-layout-collection-list'),
        }
    
    
        // Strengthen notification accessibility with polite live region
        try {
          const notificationEl = document.querySelector('swym-storefront-layout-notification');
          if (notificationEl) {
            notificationEl.setAttribute('aria-live', 'polite');
          }
        } catch (e) {
          window._swat?.utils.warn('Unable to set notification aria-live', e);
        }
    
        // Announce list updates for screen readers
        try {
          const itemsCountEl = document.getElementById('swym-storefront-layout-total-list-items-count');
          if (itemsCountEl) {
            itemsCountEl.setAttribute('aria-live', 'polite');
          }
        } catch (e) {
          window._swat?.utils.warn('Unable to set items count aria-live', e);
        }
        this.attachDrawerEventListner();
    
      }
    
        getDeepFocusableElements(root) {
          const focusableSelector =
            'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
          let elements = Array.from(root.querySelectorAll(focusableSelector));
          for (const el of elements) {
            if (el.shadowRoot) {
              elements = elements.concat(
                this.getDeepFocusableElements(el.shadowRoot)
              );
            }
          }
          return elements;
        }
    
        trapFocus = (e) => {
          const isTabPressed = e.key === "Tab" || e.keyCode === 9;
          if (!isTabPressed) return;
    
          const modal = this.elements.drawer;
          const focusableElements = this.getDeepFocusableElements(modal);
    
          if (focusableElements.length === 0) return;
    
          const first = focusableElements[0];
          const last = focusableElements[focusableElements.length - 1];
    
          if (e.shiftKey) {
            if (
              document.activeElement === first ||
              !modal.contains(document.activeElement)
            ) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (
              document.activeElement === last ||
              !modal.contains(document.activeElement)
            ) {
              e.preventDefault();
              first.focus();
            }
          }
        };
    
        attachDrawerEventListner() {
          this.elements.drawerCloseButton.addEventListener('click', this.close.bind(this));
          this.elements.drawerbackdrop.addEventListener('click', this.close.bind(this));
    
          // Close on ESC (focus trap is handled in open/close methods)
          const keydownHandler = (e) => {
            const isOpen = this.elements?.drawer && !this.elements.drawer.classList.contains('swym-storefront-layout-hide-view');
            if (!isOpen) return;
            if (e.key === 'Escape') {
              e.preventDefault();
              this.close();
            }
          };
          document.addEventListener('keydown', keydownHandler);
        }
    
        open() {
          this.isOpen = true;
          this.previouslyFocused = document.activeElement;
    
          if (this.elements?.drawer) {
            this.elements.drawer.classList.remove(
              "swym-storefront-layout-hide-view"
            );
            document.body.classList.add("swym-storefront-layout-body-no-scroll");
    
            this.elements.drawer.focus();
            document.addEventListener("keydown", this.trapFocus, true);
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutOpened, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
          }
        }
    
        close() {
          this.isOpen = false;
    
          if (this.elements?.drawer) {
            this.elements.drawer.classList.add("swym-storefront-layout-hide-view");
            document.body.classList.remove("swym-storefront-layout-body-no-scroll");
    
            document.removeEventListener("keydown", this.trapFocus, true);
    
            if (this.previouslyFocused && typeof this.previouslyFocused.focus === "function") {
              this.previouslyFocused.focus();
            }
    
            history.replaceState(null, '', window.location.pathname + window.location.search);
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutClosed, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
          }
        }
    
        reRenderUI() {
          this.renderUI();
          if (this.isOpen) this.open();
        }
      }
    
    /**
     * SwymStorefrontLayoutAsSection
     * 
     * This class extends SwymWishlistCore to render a storefront wishlist layout as a section within a specified container.
     * It dynamically injects the wishlist UI into the provided container element.
     * 
     * Features:
     * - Renders the wishlist section inside a container specified by the `container-id` attribute.
     * - Supports collection carousel based on SwymStorefrontLayoutContext settings.
     * - Displays wishlist items and user login UI.
     * - Handles rendering errors gracefully and logs warnings if an invalid container ID is provided.
     * 
     * Methods:
     * - renderUI(): Generates the section-based wishlist UI and injects it into the specified container.
     * - reRenderUI(): Re-renders the UI to reflect any updates.
     * 
     * Usage:
     * <swym-storefront-layout-as-section container-id="your-container-id"></swym-storefront-layout-as-section>
     */
    
    class SwymStorefrontLayoutAsSection extends SwymWishlistCore {
      constructor() {
        super();
        this.containerId = this.getAttribute('container-id');
        this.renderUI();
      }
    
      renderUI() {
        let { StorefrontLayoutType } = SwymStorefrontLayoutContext?.Settings;
        if(StorefrontLayoutType === 'as-section'){
          this.listContainerToRender = null;
          try {
            this.listContainerToRender = document.getElementById(this.containerId);
    
            // Only proceed if the container exists in the DOM
            if (!this.listContainerToRender) {
              // Container doesn't exist yet - this can happen during page transitions or layout changes
              // We'll skip rendering for now and wait for the container to be available
              return;
            }
    
            this.listContainerToRender.innerHTML = `
            <div id="swym-storefront-layout-container">
              <div id="swym-storefront-layout-section-container" class="swym-storefront-layout-layout">
                <swym-storefront-layout-tabs></swym-storefront-layout-tabs>
                <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
                <swym-storefront-layout-tab-content class="swym-storefront-layout-container"></swym-storefront-layout-tab-content>
              </div>
            </div>
            `
    
            this.listContainerToRender.classList.add('swym-storefront-layout-root-component');
    
          } catch (error) {
            window._swat?.utils.warn('Invalid List Container Selector ', this.containerId);
          }
        }
      }
    
      reRenderUI() {
        this.renderUI();
      }
    
      close() {
        if (document.referrer && history.length > 1) {
          try {
            const referrerOrigin = new URL(document.referrer).origin;
            if (referrerOrigin === window.location.origin) {
              history.back();
              return;
            }
          } catch (e) { /* invalid referrer URL, fall through */ }
        }
        window.location.href = window.Shopify?.routes?.root || '/';
      }
    
    }
    
    /**
     * SwymStorefrontLayoutAsDrawer
     * 
     * This class extends SwymWishlistCore to implement a drawer-style storefront wishlist layout.
     * It provides an interactive UI for users to view and manage their wishlist within a side drawer.
     * 
     * Features:
     * - Renders a wishlist drawer that slides in/out based on user interaction.
     * - Supports collection carousel display based on SwymStorefrontLayoutContext settings.
     * - Includes login UI for authentication-related actions.
     * - Implements event listeners for closing the drawer via a close button or backdrop click.
     * - Triggers instrumentation events for UI engagement tracking.
     * 
     * Methods:
     * - renderUI(): Generates the wishlist drawer UI and injects it into the component.
     * - initUIElement(): Caches DOM elements required for interactions.
     * - attachDrawerEventListner(): Attaches event listeners for closing the drawer.
     * - open(): Opens the drawer and prevents background scrolling.
     * - close(): Closes the drawer, restores scrolling, and updates browser history.
     * - reRenderUI(): Re-renders the UI and retains the open state if applicable.
     * 
     * Usage:
     * <swym-storefront-layout-as-drawer></swym-storefront-layout-as-drawer>
     */
      class SwymStorefrontLayoutAsDrawer extends SwymWishlistCore {
        constructor() {
          super();
          this.renderUI();
        }
    
        renderUI() {
          this.innerHTML = `
          <div id="swym-storefront-layout-container" class="swym-storefront-layout-drawer swym-storefront-layout-hide-view swym-storefront-layout-drawer-position-${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutDrawerPosition}" role="dialog" aria-modal="true" aria-labelledby="swym-wishlist-title" tabindex="-1">
            <div class="swym-storefront-layout-backdrop"></div>
            <div class="swym-storefront-layout-layout">
              <button id="swym-storefront-layout-close-drawer-button" aria-label="${SwymStorefrontLayoutContext?.Strings?.closeDrawer || 'Close'}" class="swym-storefront-layout-close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" viewBox="0 0 27 27" fill="none" aria-hidden="true">
                  <path d="M0 13.5C0 6.04416 6.04416 0 13.5 0C20.9558 0 27 6.04416 27 13.5C27 20.9558 20.9558 27 13.5 27C6.04416 27 0 20.9558 0 13.5Z" fill="none" fill-opacity="0.5"/>
                  <path d="M16.0245 17.8326C16.2477 18.0558 16.6095 18.0558 16.8326 17.8326C17.0558 17.6095 17.0558 17.2477 16.8326 17.0245L13.8081 14L16.8326 10.9755C17.0558 10.7523 17.0558 10.3905 16.8326 10.1674C16.6095 9.94421 16.2477 9.94421 16.0245 10.1674L13 13.1919L9.97549 10.1674C9.75233 9.94421 9.39052 9.94421 9.16737 10.1674C8.94421 10.3905 8.94421 10.7523 9.16737 10.9755L12.1919 14L9.16737 17.0245C8.94421 17.2477 8.94421 17.6095 9.16737 17.8326C9.39052 18.0558 9.75233 18.0558 9.97549 17.8326L13 14.8081L16.0245 17.8326Z" fill="currentColor" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <swym-storefront-layout-tab-content class="swym-storefront-layout-container swym-storefront-layout-scrollable"></swym-storefront-layout-tab-content>
              <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
              <swym-storefront-layout-actions id="swym-storefront-layout-actions"></swym-storefront-layout-actions>
              <swym-storefront-layout-tabs></swym-storefront-layout-tabs>
            </div>
          </div>
        `;
          this.initUIElement();
        }
    
        initUIElement() {
          this.elements = {
            drawer: this.querySelector('.swym-storefront-layout-drawer'),
            drawerCloseButton: this.querySelector('#swym-storefront-layout-close-drawer-button'),
            drawerbackdrop: this.querySelector('.swym-storefront-layout-backdrop'),
            collectionList: this.querySelector('#swym-storefront-layout-collection-list')
          }
          this.attachDrawerEventListner();
        }
    
        attachDrawerEventListner() {
          this.elements.drawerCloseButton.addEventListener('click', this.close.bind(this));
          this.elements.drawerbackdrop.addEventListener('click', this.close.bind(this));
    
          // Close on ESC (focus trap is handled in open/close methods)
          const keydownHandler = (e) => {
            const isOpen = this.elements?.drawer && !this.elements.drawer.classList.contains('swym-storefront-layout-hide-view');
            if (!isOpen) return;
            if (e.key === 'Escape') {
              e.preventDefault();
              this.close();
            }
          };
          document.addEventListener('keydown', keydownHandler);
        }
    
        getFocusableElements(root) {
          const selectors =
            'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';
          const elements = Array.from(root.querySelectorAll(selectors));
    
          return elements.filter(
            (el) => el.offsetParent !== null || el instanceof SVGElement
          );
        }
    
        trapFocus = (e) => {
          if (e.key !== "Tab") return;
    
          const focusableEls = this.getFocusableElements(this.elements.drawer);
          if (focusableEls.length === 0) return;
    
          const first = focusableEls[0];
          const last = focusableEls[focusableEls.length - 1];
    
          if (e.shiftKey) {
            if (document.activeElement === first || !this.elements.drawer.contains(document.activeElement)) {
              e.preventDefault();
              last.focus();
            }
          } else {
            if (document.activeElement === last || !this.elements.drawer.contains(document.activeElement)) {
              e.preventDefault();
              first.focus();
            }
          }
        };
    
        open() {
          this.isOpen = true;
          this.previouslyFocused = document.activeElement;
    
          if (this.elements?.drawer) {
            this.elements.drawer.classList.remove("swym-storefront-layout-hide-view");
            document.body.classList.add("swym-storefront-layout-body-no-scroll");
    
            // Set focus to the drawer itself
            this.elements.drawer.focus();
    
            // Trap focus inside the drawer
            document.addEventListener("keydown", this.trapFocus, true);
    
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutOpened, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
          }
        }
    
        close() {
          this.isOpen = false;
    
          if (this.elements?.drawer) {
            this.elements.drawer.classList.add("swym-storefront-layout-hide-view");
            document.body.classList.remove("swym-storefront-layout-body-no-scroll");
    
            document.removeEventListener("keydown", this.trapFocus, true);
    
            // Return focus to the previously focused element
            if (this.previouslyFocused && typeof this.previouslyFocused.focus === "function") {
              this.previouslyFocused.focus();
            }
    
            history.replaceState(null, '', window.location.pathname + window.location.search);
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutClosed, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
          }
        }
    
        reRenderUI() {
          this.renderUI();
          if (this.isOpen) this.open();
        }
      }
    
    /**
     * SwymStorefrontLayoutCollectionCarousel
     * 
     * This custom Web Component is responsible for rendering a carousel of collection lists 
     * within the storefront layout. It dynamically updates based on the provided collection 
     * data and offers smooth scrolling functionality with navigation buttons.
     * 
     * Features:
     * - Dynamically renders collections with images and item counts.
     * - Implements smooth scrolling with previous/next buttons.
     * - Updates button visibility based on scroll position.
     * - Tracks user interactions using Swym's instrumentation.
     * - Provides an action button for each collection with a tooltip menu.
     * - Supports localization via `SwymStorefrontLayoutContext?.Strings`.
     * 
     * Usage:
     * - Call `setData({ collections })` to populate the carousel with collection data.
     * 
     * Dependencies:
     * - `window.SwymStorefrontLayoutContext` for localized strings and configurations.
     * - `window._swat?.instrumentV3` for tracking user interactions.
     * - `SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip` for managing action tooltips.
     * 
     */
    class SwymStorefrontLayoutCollectionCarousel extends HTMLElement {
      constructor() {
        super();
        this.collections = [];
        
        // Check multi-wishlist config to determine initial visibility
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        this.shouldShowMultiple = shouldShowMultiple;
        
        this.renderUI();
        this.elements = {
          title: this.querySelector('.swym-storefront-layout-collection-carousel-title'),
          carouselContainer: this.querySelector('.swym-storefront-layout-carousel-container'),
          carousel: this.querySelector('#swym-storefront-layout-collection-carousel-items-container'),
          carouselPrevButton: this.querySelector('.swym-storefront-layout-carousel-prev-btn'),
          carouselNextButton: this.querySelector('.swym-storefront-layout-carousel-next-btn')
        }
        
        // Hide carousel initially if multi-wishlist should not be shown
        if (!this.shouldShowMultiple) {
          this.style.display = 'none';
        }
        
        this.attachEventListner();
      }
    
      setData({ collections, canCreateLists = true, shouldShowMultiple = false }) {
        this.collections = collections;
        this.canCreateLists = canCreateLists;
        this.shouldShowMultiple = shouldShowMultiple;
        this.renderCollections();
      }
    
      renderUI() {
        this.innerHTML = `
        <div class="swym-storefront-layout-collection-carousel-container">
          <div class="swym-storefront-layout-collection-carousel-title" role="heading" aria-level="2">${SwymStorefrontLayoutContext?.Strings?.collectionTitle}</div>
          <div class="swym-storefront-layout-carousel-container" role="region" aria-label="${SwymStorefrontLayoutContext?.Strings?.collectionTitle}">
            <button class="swym-storefront-layout-carousel-btn swym-storefront-layout-carousel-prev-btn" aria-label="${SwymStorefrontLayoutContext?.Strings?.scrollLeft || 'Scroll Left'}">
              <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="swym-storefront-layout-scroll-button-icon" aria-hidden="true"><path d="m13.333 8 8 8-8 8" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
            <div id="swym-storefront-layout-collection-carousel-items-container" class="swym-storefront-layout-carousel swym-storefront-layout-scrollable" role="list" aria-label="${SwymStorefrontLayoutContext?.Strings?.collectionTitle || 'Collections'}">
              <swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType.CarouselListItem}" width="100%" height="100px"></swym-storefront-layout-loader>
            </div>
            <button class="swym-storefront-layout-carousel-btn swym-storefront-layout-carousel-next-btn" aria-label="${SwymStorefrontLayoutContext?.Strings?.scrollRight || 'Scroll Right'}">
              <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="swym-storefront-layout-scroll-button-icon" aria-hidden="true"><path d="m13.333 8 8 8-8 8" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"></path></svg>
            </button>
          </div>
        </div>
        `
      }
    
      attachEventListner() {
    
        this.elements.carouselPrevButton.addEventListener("click", () => {
          this.elements.carousel.scrollBy({
            left: -320,
            behavior: "smooth",
          });
        });
    
        this.elements.carouselNextButton.addEventListener("click", () => {
          this.elements.carousel.scrollBy({
            left: 320,
            behavior: "smooth",
          });
        });
    
        this.elements.carousel.addEventListener("scroll", () => this.updateCarouselButtonVisibility());

        this.elements.carousel.addEventListener("dragover", (event) => {
          if (!SwymStorefrontLayoutContext?.DragDrop?.isDragging()) return;
          const bounds = this.elements.carousel.getBoundingClientRect();
          const edgeSize = 60;
          if (event.clientX < bounds.left + edgeSize) {
            this.elements.carousel.scrollBy({ left: -12 });
          } else if (event.clientX > bounds.right - edgeSize) {
            this.elements.carousel.scrollBy({ left: 12 });
          }
        });

      }
    
      renderCollections() {
        const collectionsContainer = this.querySelector('#swym-storefront-layout-collection-carousel-items-container');
        if (collectionsContainer) {
    
          window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutCollectionRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
    
          // Show carousel if shouldShowMultiple is true (feature enabled or multiple lists exist)
          if (!this.shouldShowMultiple) {
            this.style.display = 'none';
            return;
          }
    
          // Show the carousel
          this.style.display = '';

          const rootUrl = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');

          if (this.collections && this.collections.length) {
            this.elements.carouselContainer.classList.add('swym-storefront-layout-has-items');
            collectionsContainer.innerHTML = this.collections
              .map(
                (collection) => {
                  let { lname, listcontents, lid } = collection;
    
                  const count = listcontents.length;

                  const listImagesHtml = count === 0
                    ? `<div class="swym-storefront-layout-collection-grid-item-no-products">This list doesn't have any products yet!</div>`
                    : Array.from({ length: 3 })
                      .map((_, i) => {
                        let item = listcontents[i];
                        return `
                        <div class="swym-storefront-layout-collection-grid-item-secondary-image">
                          ${item?.iu ? `<img src="${item ? item.iu : null}" alt="${item?.dt ? swymEscAttr(item?.dt) : 'product Image'}" class="swym-storefront-layout-collection-grid-item-image" />` : `<div class="swym-storefront-layout-collection-grid-item-image" ></div>`}
                        </div>
                      `;
                      })
                      .join("");
    
                  return `
                  <div class="swym-storefront-layout-collection-grid-item" data-lid="${lid}" role="listitem" aria-label="${lname}">
                    <div class="swym-storefront-layout-collection-grid-item-info-container">
                      <div class="swym-storefront-layout-collection-grid-item-name">${lname}</div>
                      <div class="swym-storefront-layout-collection-grid-item-count">${count} ${count === 1 ? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items}</div>
                    </div>
                    <div class="swym-storefront-layout-collection-grid-item-image-container">
                      ${listImagesHtml}
                    </div>
                    <div class="swym-storefront-layout-collection-grid-item-view-button-container">
                      ${count === 0
                        ? `<a href="${rootUrl}/collections/all" class="swym-storefront-layout-collection-grid-item-view-button">${SwymStorefrontLayoutContext?.Strings?.continueShoppingCta}</a>`
                        : `<div class="swym-storefront-layout-collection-grid-item-view-button" aria-hidden="true">${SwymStorefrontLayoutContext?.Strings?.viewListCta}</div>`
                      }
                    </div>
                    <div id="swym-storefront-layout-collection-grid-item-option-button" class="swym-storefront-layout-collection-grid-item-option-button" role="button" tabindex="0" aria-haspopup="dialog" aria-expanded="false" aria-label="More options for ${lname}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="none" aria-hidden="true" focusable="false">
                        <circle cx="1.5" cy="1.50014" r="1.5" fill="#1C3C35"/>
                        <circle cx="1.5" cy="6.50014" r="1.5" fill="#1C3C35"/>
                        <circle cx="1.5" cy="11.5001" r="1.5" fill="#1C3C35"/>
                      </svg>
                    </div>
                  </div>
                `
                }
              )
              .join('') + `
                <div class="swym-storefront-layout-collection-grid-item swym-storefront-layout-collection-grid-item-new-list">
                  <div class="swym-storefront-layout-collection-grid-item-view-button">New List</div>
                </div>
              `;
            this.updateCarouselButtonVisibility();
            this.attachEventListnerToCollectionGrid();
          } else {
            // Show empty state when shouldShowMultiple is true but no collections
            this.elements.carouselContainer.classList.remove('swym-storefront-layout-has-items');
            collectionsContainer.innerHTML = `
              <div class="swym-storefront-layout-collection-grid-item swym-storefront-layout-collection-grid-item-new-list swym-storefront-layout-collection-grid-item-empty">
                <div class="swym-storefront-layout-collection-grid-item-empty-text">${SwymStorefrontLayoutContext?.Strings?.emptyCarouselCollectionText}</div>
                <div class="swym-storefront-layout-collection-grid-item-view-button">New List</div>
              </div>
            `;
            this.attachEventListnerToCollectionGrid();
          }
    
          let collectionCount = this.collections?.length;
          if(this.elements.title){
            this.elements.title.innerHTML = `${SwymStorefrontLayoutContext?.Strings?.collectionTitle} ${collectionCount?`(${collectionCount})`:''}`;
          }
        }
      }
    
    
      updateCarouselButtonVisibility() {
        const scrollLeft = this.elements.carousel.scrollLeft;
        const maxScrollLeft = this.elements.carousel.scrollWidth - this.elements.carousel.clientWidth;
    
        this.elements.carouselPrevButton.style.display = scrollLeft > 0 ? "flex" : "none";
        this.elements.carouselNextButton.style.display = scrollLeft < maxScrollLeft ? "flex" : "none";
      }
    
      attachEventListnerToCollectionGrid() {
        (this.collections || []).forEach((collection) => {
          const collectionItem = this.elements.carousel.querySelector(
            `[data-lid="${collection.lid}"]`
          );
          collectionItem?.addEventListener("click", (event) => {
            if (event.target.closest('a.swym-storefront-layout-collection-grid-item-view-button')) return;
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutCollectionOpened, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
            window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList + collection.lid;
          });

          let collectionItemActionButton =  collectionItem.querySelector('#swym-storefront-layout-collection-grid-item-option-button');
          collectionItemActionButton?.addEventListener("click", (event) => {
            event.preventDefault();
            event.stopPropagation();
            if(SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.closeTooltip();
              collectionItemActionButton?.setAttribute('aria-expanded', 'false');
            }else{
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: collection.lid,
                list: collection,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.EditCollection
              });
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
              collectionItemActionButton?.setAttribute('aria-expanded', 'true');
            }
          })
    
          // Keyboard support for option button
          collectionItemActionButton?.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              collectionItemActionButton.click();
            }
          });

          // No preventDefault on excluded lists: the browser then refuses the drop.
          collectionItem?.addEventListener("dragover", (event) => {
            const dragDrop = SwymStorefrontLayoutContext?.DragDrop;
            if (!dragDrop?.canDropOn(collection.lid)) return;
            event.preventDefault();
            event.dataTransfer.dropEffect = 'move';
            dragDrop.setDropTarget(collectionItem);
          });

          collectionItem?.addEventListener("dragleave", (event) => {
            if (collectionItem.contains(event.relatedTarget)) return;
            SwymStorefrontLayoutContext?.DragDrop?.clearDropTarget();
          });

          collectionItem?.addEventListener("drop", (event) => {
            event.preventDefault();
            SwymStorefrontLayoutContext?.DragDrop?.commitDrop(collection.lid);
          });

        })

        const newListCard = this.elements.carousel.querySelector('.swym-storefront-layout-collection-grid-item-new-list');
        newListCard?.addEventListener("click", () => {
          SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.setData({
            listId: SwymStorefrontLayoutContext?.DefaultList?.lid,
            list: SwymStorefrontLayoutContext?.DefaultList,
            item: null,
            collections: this.collections || [],
            actionType: SwymStorefrontLayoutContext?.ActionTypes.CreateCollection,
            canCreateLists: true
          });
          SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.openDrawer();
        });
      }
}
    
    /**
     * SwymStorefrontLayoutWishlistItem
     *
     * This custom web component represents an item in the Swym Storefront Layout Wishlist.
     * It dynamically renders product details, pricing, and actions such as adding to cart
     * or managing wishlist options. It also handles variant selection and user interactions
     * based on the store's configuration settings.
     *
     * Key Features:
     * - Displays product title, image, price, and compare-at price.
     * - Supports multiple product variants and allows selection.
     * - Handles "Add to Cart" functionality with visual feedback.
     * - Manages user interactions for wishlist options and collections.
     * - Ensures compatibility with store localization settings.
     *
     * Dependencies:
     * - SwymStorefrontLayoutContext: Provides store settings, strings, and utilities.
     * - SwymStorefrontLayoutExtensions: Handles tooltips and notifications.
     * - _swat.platform: Manages cart operations.
     *
     * Usage:
     * This component should be used within the Swym Storefront Layout to display 
     * wishlist items effectively while maintaining a seamless user experience.
     */
    class SwymStorefrontLayoutWishlistItem extends HTMLElement{
      constructor() {
        super();
        this.item = null;
        this.list = null;
        this.sflList = null;
        this.selectedVariant = null;
        this.collections = null;
        this.listItemType = SwymStorefrontLayoutContext?.ListItemType?.WishlistItem;
        this.quantityUpdateTimeout = null;
      }
    
      setData({ item, list, sflList, listItemType, collections, canCreateLists = true }) {
        this.item = item;
        this.listItemType = listItemType;
        this.list = list;
        this.sflList = sflList;
        this.collections = collections;
        this.canCreateLists = canCreateLists;
    
        this.selectedVariantId = this.item?.cprops?.selectedVariantId || this.item?.epi;
        this.selectedVariant = SwymStorefrontLayoutContext?.getSelectedVariant(this.item, this.selectedVariantId);
    
        this.dataset.epi = this.selectedVariant?.id || this.item?.epi;
        this.dataset.empi = this.item?.empi;
        this.dataset.du = this.item?.['du-mkt'] || this.item?.du;
    
        this.renderItem();
        this.initItemElements();
        this.addEventListeners();
        this.initDragAndDrop();
      }

      initDragAndDrop() {
        const dragDrop = SwymStorefrontLayoutContext?.DragDrop;
        const isDefaultListItem =
          this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.WishlistItem;

        // A refresh from an earlier move can land mid-move and re-render this card
        // from list contents that predate its removal, so re-hide it on every render.
        if (SwymStorefrontLayoutContext.dragMovingEpis?.has(String(this.item?.epi))) {
          this.classList.add('swym-storefront-layout-item-moving');
        }

        if (!dragDrop || !isDefaultListItem) {
          this.draggable = false;
          return;
        }

        this.draggable = true;

        // Otherwise the browser drags the link or image instead of the card.
        this.querySelectorAll('a, img, input').forEach((element) => {
          element.draggable = false;
        });

        if (this._dragListenersBound) return;
        this._dragListenersBound = true;

        this.addEventListener('dragstart', (event) => {
          if (!dragDrop.beginDrag(this)) {
            event.preventDefault();
            return;
          }
          event.dataTransfer.effectAllowed = 'move';
          event.dataTransfer.setData('text/plain', this.dataset.epi);
        });

        this.addEventListener('dragend', () => {
          dragDrop.endDrag();
        });
      }
    
      getProductImage() {
        const productImage = this.selectedVariant?.featured_image;
        const imageUrl = typeof productImage === 'string' ? productImage : productImage?.src;
        return (
          imageUrl ||
          this.item?.productData?.featured_image ||
          this.item?.iu
        );
      }
    
      getFormattedPrice() {
        let price = this.selectedVariant?.price ?? this.item?.productData?.price;  
        if (price === undefined || price === null) {
          price = this.item?.pr;
        }
        return price !== undefined && price !== null
        ? SwymStorefrontLayoutContext?.FormatPrice(price)
        : '';
      }
      getFormattedComparePrice() {
        let price = this.selectedVariant?.compare_at_price ?? this.item?.productData?.compare_at_price;
        if (price === undefined || price === null) {
          price = this.item?.op;
        }
        return price !== undefined && price !== null
        ? SwymStorefrontLayoutContext?.FormatPrice(price)
        : '';
      }
    
      getButtonState() {
        const isInCart = _swat.platform.isInDeviceCart(this.selectedVariant?.id);
        if(this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem){
          return this.selectedVariant?.available
          ? SwymStorefrontLayoutContext?.Strings?.moveToCartCta
          : SwymStorefrontLayoutContext?.Strings?.soldOut;
        }else{
          return this.selectedVariant?.available
          ? isInCart
            ? SwymStorefrontLayoutContext?.Strings?.addedToCart
            : SwymStorefrontLayoutContext?.Strings?.addToCart
          : SwymStorefrontLayoutContext?.Strings?.soldOut;
        }
      }
    
      renderVariants() {
        if (SwymStorefrontLayoutContext?.Settings?.EnableStorefrontLayoutVariantSelector && this.item?.productData?.variants?.length > 1) {
          return `
            <span class="swym-storefront-layout-price-devider">|</span>
            <div class="swym-storefront-layout-grid-item-variants-container">
              ${this.item.productData.options
                .map(
                  (option, index) => `
                      ${index==0?'':'<span class="swym-storefront-layout-variant-devider"></span>'}
                      <div id="variant-selector-${this.item.empi}" class="swym-storefront-layout-variant">
                        ${option.values
                          .map(
                            (value) =>
                            this.selectedVariant?.[`option${index + 1}`] === value?value:''
                          )
                          .join('')}
                      </div>
                    `
                )
                .join('')}
            </div>
          `;
        }
        return '';
      }
    
      renderVariantSelector() {
        if (SwymStorefrontLayoutContext?.Settings?.EnableStorefrontLayoutVariantSelector && this.item?.productData?.variants?.length > 1) {
          return `
            <div class="swym-storefront-layout-grid-item-variant-selector-container">
              ${this.item.productData.options
                .map(
                  (option, index) => `
                    ${option.values && option.values.length>1 ? `
                      <select id="variant-selector-${this.item.empi}" class="swym-storefront-layout-variant-selector">
                        <option value="${option.name}" disabled>${option.name}</option>
                        ${option.values
                          .map(
                            (value) =>
                              `<option value="${value}" ${
                                this.selectedVariant[`option${index + 1}`] === value ? 'selected' : ''
                              }>${value}</option>`
                          )
                          .join('')}
                      </select>
                    `:''}
                  `
                )
                .join('')}
            </div>
          `;
        }
        return '';
      }
        renderOptionButton() {
          // Get multi-wishlist configuration
          const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
    
          // Drawer UI Polish: In drawer + single wishlist mode, show trash icon instead of 3-dot menu
          // Clicking opens tooltip with "Remove from wishlist" confirmation (no direct delete)
          if (isDrawer && !shouldShowMultiple) {
            if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem ||
                SwymStorefrontLayoutContext?.checkUserCanEditList(this.list || this.sflList)) {
              const ariaLabel = this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem
                ? (SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove from Saved For You')
                : (SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove item');
              return `
          <button class="swym-storefront-layout-grid-item-option-button swym-storefront-layout-delete-btn" tabindex="0" role="button" aria-label="${ariaLabel}" aria-haspopup="dialog" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false">
              <path d="M11.5 9V13.25M8.5 9V13.25M5.75 12.2V6H14.25C14.25 8.421 14.25 9.779 14.25 12.2C14.25 13.053 14.25 13.647 14.212 14.11C14.175 14.563 14.106 14.824 14.005 15.021C13.7822 15.4476 13.4408 15.8008 13.022 16.038C12.825 16.138 12.564 16.208 12.111 16.245C11.648 16.282 11.054 16.283 10.201 16.283H9.801C8.948 16.283 8.354 16.283 7.891 16.245C7.438 16.208 7.177 16.139 6.98 16.038C6.56083 15.8009 6.21911 15.4478 5.996 15.021C5.896 14.824 5.826 14.563 5.789 14.11C5.75 13.647 5.75 13.053 5.75 12.2Z" stroke="currentColor" stroke-linecap="round"/>
              <path d="M4.25 6H15.75M8 5.25C8 4.71957 8.21071 4.21086 8.58579 3.83579C8.96086 3.46071 9.46957 3.25 10 3.25C10.5304 3.25 11.0391 3.46071 11.4142 3.83579C11.7893 4.21086 12 4.71957 12 5.25" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        `;
            }
            return '';
          }
    
          // SavedForYouItem only supports remove — show option button for that
          if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem) {
            return `
          <button class="swym-storefront-layout-grid-item-option-button" tabindex="0" role="button" aria-label="Remove from Saved For You">
            <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor" aria-hidden="true" focusable="false">
              <circle cx="1.5" cy="1.50014" r="1.5" fill="#1C3C35"/>
              <circle cx="1.5" cy="6.50014" r="1.5" fill="#1C3C35"/>
              <circle cx="1.5" cy="11.5001" r="1.5" fill="#1C3C35"/>
            </svg>
          </button>
        `;
          }
    
          // Show options button if:
          // 1. Multiple lists should be shown (feature enabled OR multiple lists exist), OR
          // 2. User can edit the list (for delete/rename options)
          if (
            shouldShowMultiple ||
            SwymStorefrontLayoutContext?.checkUserCanEditList(
              this.list || this.sflList
            )
          ) {
            return `
          <button class="swym-storefront-layout-grid-item-option-button" tabindex="0" role="button" aria-label="Open item options" aria-haspopup="dialog" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor" aria-hidden="true" focusable="false">
              <circle cx="1.5" cy="1.50014" r="1.5" fill="#1C3C35"/>
              <circle cx="1.5" cy="6.50014" r="1.5" fill="#1C3C35"/>
              <circle cx="1.5" cy="11.5001" r="1.5" fill="#1C3C35"/>
            </svg>
          </button>
        `;
          }
          return "";
        }
      isTagAvailable(tag, product) {
        return window._swat && window._swat.platform?.isTagAvailable(
          tag,
          product
        );
      }
    
      getDefaultValue(val, defaultValue) {
        return val ? val : defaultValue;
      }
    
      getMinQuantity() {
        return window._swat?.retailerSettings?.UI?.MinimumQuantity || 1;
      }
    
      getMaxQuantity() {
        return window._swat?.retailerSettings?.UI?.MaximumQuantity;
      }
      
      renderItem() {
        if(_swat.marketsEnabled && this.item?.['du-mkt'] === null ){
          return;
        }
        const settings = window._swat.retailerSettings;
        const IsTagBasedActionEnabled = settings?.Wishlist?.TagBasedActionEnabled;
    
        const hideAddtoCartTag = this.getDefaultValue(settings?.UI?.HideAddToCartTag, "swym-hide-addtocart");
        const disabledAddtoCartTag = this.getDefaultValue(settings?.UI?.DisabledAddtoCartTag, "swym-disabled-addtocart-with-text");
        const hideProductPriceTag = this.getDefaultValue(settings?.UI?.HideProductPriceTag, "swym-hide-productprice");
        const productInfo = this.item?.productData;
    
        const isHidden = IsTagBasedActionEnabled && this.isTagAvailable(hideAddtoCartTag, productInfo);
        const isDisabled = IsTagBasedActionEnabled && this.isTagAvailable(disabledAddtoCartTag, productInfo);
        const hidePrice = IsTagBasedActionEnabled && this.isTagAvailable(hideProductPriceTag, productInfo);
        
        // Use du-mkt if available (market-specific URL), otherwise fall back to du
        let localizedUrl = this.item?.['du-mkt'] || this.item?.du || '';
        
        // Append variant parameter if not already present
        if (localizedUrl && this.item?.epi) {
          const urlObj = new URL(localizedUrl, window.location.origin);
          if (!urlObj.searchParams.has('variant')) {
            urlObj.searchParams.set('variant', this.item.epi);
            localizedUrl = urlObj.toString();
          }
        }
    
        const noVariant = this.selectedVariant?.title === "Default Title";
        const matchingItem = this.list?.listcontents.find(item => item.epi === this.selectedVariant?.id);
        const isAutoWishlist = this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem
          && matchingItem?.source === "auto-wishlist";
        const isFirstVariant = matchingItem?.productData?.variants?.[0]?.id === this.selectedVariant?.id;
    
        let price = this.getFormattedPrice();
        let comparePrice = this.getFormattedComparePrice();

        const fullTitle = this.item?.productData?.title || this.item?.dt || '';
        const titleSeparatorIndex = fullTitle.indexOf('|');
        const productTitle = titleSeparatorIndex === -1 ? fullTitle : fullTitle.slice(0, titleSeparatorIndex).trim();
        const variantInfo = titleSeparatorIndex === -1 ? '' : fullTitle.slice(titleSeparatorIndex + 1).trim().replace(/\s*\|\s*$/, '');

        this.innerHTML = `
          <div class="swym-storefront-layout-grid-item">
            <a href="${localizedUrl}" class="swym-storefront-layout-grid-item-image-container">
              <img src="${this.getProductImage()}" alt="${swymEscAttr(this.item?.productData?.title || this.item?.dt) || 'Product image'}" class="swym-storefront-layout-grid-item-image" />
            </a>
            <div class="swym-storefront-layout-grid-item-content">
              <a href="${localizedUrl}" class="swym-storefront-layout-grid-item-title">${productTitle}</a>
              ${variantInfo ? `<div class="swym-storefront-layout-grid-item-variant">${variantInfo}</div>` : ''}
              <div class="swym-storefront-layout-grid-item-price-variant">
               ${!hidePrice ? `<span class="swym-storefront-layout-grid-item-final-price">${price}</span>` : ''}
               ${comparePrice && comparePrice !== price && !hidePrice && this.selectedVariant?.compare_at_price ? `<span class="swym-storefront-layout-grid-item-compare-price">${comparePrice}</span>`: ''}
    ${this.renderVariants()}
              </div>
              <div class="swym-storefront-layout-grid-item-sku">SKU: ${this.selectedVariant?.sku || ''}</div>
              <div class="swym-storefront-layout-grid-item-action-container">
                ${!isHidden && this.isSfsQuantityFeatureEnabled() ? `<div class="swym-storefront-layout-quantity-container">
                  <div class="swym-storefront-layout-quantity-selector">
                    <button type="button" class="swym-storefront-layout-quantity-btn swym-storefront-layout-quantity-minus" data-action="quantity-decrease" aria-label="${SwymStorefrontLayoutContext?.Strings?.decreaseQuantity || 'Decrease quantity'}">−</button>
                    <input type="number" id="swym-quantity-${this.item.epi}" class="swym-storefront-layout-quantity-input" 
                           value="${this.item.qty || this.getMinQuantity()}" min="${this.getMinQuantity()}" ${this.getMaxQuantity() ? `max="${this.getMaxQuantity()}"` : ''} step="1" data-action="quantity-change">
                    <button type="button" class="swym-storefront-layout-quantity-btn swym-storefront-layout-quantity-plus" data-action="quantity-increase" aria-label="${SwymStorefrontLayoutContext?.Strings?.increaseQuantity || 'Increase quantity'}">+</button>
                  </div>
                </div>` : ''}
              ${isAutoWishlist && isFirstVariant && !noVariant && !isHidden && !this._variantConfirmed ?
                `<button class="swym-variant-selector" id="swym-variant-selector">
                  ${window.SwymStorefrontLayoutContext?.Strings?.VariantSelectorBtnText}
                  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
                                <path id="Vector 6" d="M1 9.5L5.44444 5.5L1 1.5" stroke="currentColor" stroke-width="1.5"/>
                              </svg>
                </button>` : ``}
                ${isAutoWishlist && !isHidden && (
                    !isFirstVariant || noVariant || (isFirstVariant && !noVariant && this._variantConfirmed)
                  ) ?
                  `<div class="swym-sfy-action-row">
                    <button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart"
                      ${!this.selectedVariant?.available || isDisabled ? 'disabled' : ''}>
                      ${this.getButtonState()}
                    </button>
                    <button class="swym-sfy-add-to-wishlist-btn ${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer' ? 'swym-sfy-heart-btn' : ''}" data-action="add-to-wishlist" aria-label="${SwymStorefrontLayoutContext?.Strings?.sfyAddToWishlistCta || 'Add to Wishlist'}">
                      ${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer' ? (SwymStorefrontLayoutExtensions?.getWishlistIconSvg?.('unfilled', { width: '17', height: '16' }) || '') : (SwymStorefrontLayoutContext?.Strings?.sfyAddToWishlistCta || 'Add to Wishlist')}
                    </button>
                  </div>` : ""
                }
                ${isAutoWishlist && !isHidden && isFirstVariant && !noVariant && !this._variantConfirmed ?
                  `<button class="swym-sfy-add-to-wishlist-btn ${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer' ? 'swym-sfy-heart-btn' : ''}" data-action="add-to-wishlist" aria-label="${SwymStorefrontLayoutContext?.Strings?.sfyAddToWishlistCta || 'Add to Wishlist'}">
                    ${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer' ? (SwymStorefrontLayoutExtensions?.getWishlistIconSvg?.('unfilled', { width: '17', height: '16' }) || '') : (SwymStorefrontLayoutContext?.Strings?.sfyAddToWishlistCta || 'Add to Wishlist')}
                  </button>` : ""
                }
                ${!isAutoWishlist && !isHidden ? 
                  `<button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart"
                  ${!this.selectedVariant?.available || isDisabled ? 'disabled' : ''}>
                  ${this.getButtonState()}
                </button>`: ""
                }
              </div>
            </div>
            ${this.renderOptionButton()}
          </div>
        `;
    
      }
    
      initItemElements(){
        this.elements = {
          AddToCartButton: this.querySelector('[data-action="add-to-cart"]'),
          AddToWishlistButton: this.querySelector('[data-action="add-to-wishlist"]'),
          Image: this.querySelector('.swym-storefront-layout-grid-item-image'),
          Price: this.querySelector('.swym-storefront-layout-grid-item-final-price'),
          ComparePrice: this.querySelector('.swym-storefront-layout-grid-item-compare-price'),
          OptionButton: this.querySelector('.swym-storefront-layout-grid-item-option-button'),
          sflItemsContainer : document.querySelector(`swym-storefront-layout-sfl-container .swym-storefront-layout-items-container`),
          swymVariantSelector: this.querySelector('#swym-variant-selector'),
          QuantityInput: this.querySelector('.swym-storefront-layout-quantity-input'),
          QuantityMinusBtn: this.querySelector('[data-action="quantity-decrease"]'),
          QuantityPlusBtn: this.querySelector('[data-action="quantity-increase"]')
        }
        
        // Initialize button states (only if SFS quantity feature is enabled)
        if (this.isSfsQuantityFeatureEnabled()) {
          this.updateQuantityButtonStates();
        }
      }
    
      addEventListeners() {
        this.elements.AddToCartButton?.addEventListener('click', (event) => {
          if(this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem){
            this.handleMoveToCart(event);
          }else{
            this.handleAddToCart(event);
          }
        });
        this.elements.OptionButton?.addEventListener('click', (event) => {
          if(SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.closeTooltip();
            this.elements.OptionButton?.setAttribute('aria-expanded', 'false');
          }else{
            if(this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.WishlistItem || this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.CollectionItem){
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: this.list.lid,
                list: this.list,
                item: this.item,
                selectedVariantId: this.selectedVariant?.id,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.ManageListItem,
                canCreateLists: this.canCreateLists
              });
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
            }else if(this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem){
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: this.sflList?.lid,
                list: this.sflList,
                item: this.item,
                selectedVariantId: this.selectedVariant?.id,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.ManageSflListItem,
                canCreateLists: this.canCreateLists
              });
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
            }else if(this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem){
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: this.list?.lid,
                list: this.list,
                item: this.item,
                selectedVariantId: this.selectedVariant?.id,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.ManageSfyListItem,
                canCreateLists: this.canCreateLists
              });
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
            }
            this.elements.OptionButton?.setAttribute('aria-expanded', 'true');
          }
        });
        // Keyboard support for options button
        this.elements.OptionButton?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.elements.OptionButton.click();
          }
        });
        this.elements.AddToWishlistButton?.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleMoveToWishlist();
        });
        this.elements.AddToWishlistButton?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.handleMoveToWishlist();
          }
        });
        const variantSelectors = this.querySelectorAll('.swym-storefront-layout-variant-selector');
        variantSelectors?.forEach((selector) =>
          selector.addEventListener('change', () => this.handleVariantSelectionChange())
        );
        this.elements.swymVariantSelector?.addEventListener('click', (event) => {
          if (!window.SwymStorefrontLayoutExtensions) {
            window.SwymStorefrontLayoutExtensions = {};
          }
          window.SwymStorefrontLayoutExtensions._vsActiveItem = this;
          
          window._swat.evtLayer.dispatchEvent(new CustomEvent("sw:renderVS", {
            detail: {
              variant: this.selectedVariant,
              lid: this.item.lid,
              product: {
                epi: this.item.epi,
                empi: this.item.empi, 
                dt: this.item.dt,
                variants: this.item.productData.variants,
                du: this.item?.['du-mkt'] || this.item.du,
                options: this.item.productData.options
              }
            }
          }))
        });
        
        // Add quantity input event listeners (only if SFS quantity feature is enabled)
        if (this.isSfsQuantityFeatureEnabled()) {
          this.elements.QuantityInput?.addEventListener('change', (event) => {
            this.handleQuantityChange(event);
          });
          
          this.elements.QuantityInput?.addEventListener('blur', (event) => {
            this.validateQuantityInput(event);
          });
    
          // Add plus/minus button event listeners
          this.elements.QuantityMinusBtn?.addEventListener('click', (event) => {
            this.handleQuantityDecrease(event);
          });
    
          this.elements.QuantityPlusBtn?.addEventListener('click', (event) => {
            this.handleQuantityIncrease(event);
          });
        }
      }
    
      async handleDirectRemove() {
        try {
          const { epi, empi, du } = this.item;
          const lid = (this.list || this.sflList)?.lid;
    
          if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem) {
            // SFY item: optimistic UI update + API call (same pattern as addSfyOptionEventListeners)
            SwymStorefrontLayoutContext.updateAllListContents((listcontents = []) =>
              listcontents.filter(item => String(item.epi) !== String(epi))
            );
            if (SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched) {
              document.dispatchEvent(new CustomEvent(SwymStorefrontLayoutContext.CustomEvents.WishlistFetched, {
                detail: {
                  defaultList: SwymStorefrontLayoutContext.DefaultList,
                  collections: SwymStorefrontLayoutContext.collections,
                  lists: SwymStorefrontLayoutContext.lists
                }
              }));
            }
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemRemoved,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              image: this.item?.iu
            });
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, lid);
            SwymStorefrontLayoutExtensions?.refreshWishList();
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYItemRemoved, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
          } else if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem) {
            // SFL item: use removeProductFromSFL (same pattern as addSflOptionEventListeners)
            let selectedEpi = this.selectedVariant?.id || epi;
            await SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.removeProductFromSFL({ epi: selectedEpi, empi, du }, SwymStorefrontLayoutContext?.sflListId);
            this.remove();
            window._swat?.triggerSwymEvent(window._swat?.JSEvents?.removedFromSFL, this.item);
          } else {
            // Regular wishlist item: use same pattern as removeFromListBtn in addOptionEventListeners
            let selectedEpi = this.selectedVariant?.id || epi;
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi: selectedEpi, empi, du }, lid);
            this.remove();
            SwymStorefrontLayoutExtensions?.refreshWishList();
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemRemovedFromList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi: selectedEpi, empi });
          }
        } catch (error) {
          window._swat?.utils.error('Failed to remove product:', error);
        }
      }
    
      async handleMoveToWishlist() {
        try {
          const { empi, du } = this.item;
          const epi = this.selectedVariant?.id || this.item.epi;
          const lid = this.list?.lid;
    
          // Check multi-wishlist config
          const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
    
          if (shouldShowMultiple) {
            // Multi-list: open AddToCollection drawer so user picks the target list
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.setData({
              listId: lid,
              list: this.list,
              item: this.item,
              collections: SwymStorefrontLayoutContext?.collections || [],
              actionType: SwymStorefrontLayoutContext?.ActionTypes.AddToCollection,
              canCreateLists: canCreateLists
            });
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.openDrawer();
            return;
          }
    
          // Single list: move to default wishlist directly
          const atwBtn = this.querySelector('[data-action="add-to-wishlist"]');
          if (atwBtn) {
            atwBtn.innerHTML = SwymStorefrontLayoutContext?.Strings?.addingToWishlist || 'Adding...';
            atwBtn.setAttribute('disabled', 'true');
          }
    
          // Instant local state update across ALL context references
          SwymStorefrontLayoutContext.updateAllListContents((listcontents = []) =>
            listcontents.map(item =>
              String(item.epi) === String(epi) ? { ...item, source: undefined } : item
            )
          );
    
          // Switch to Wishlist tab and update UI immediately
          SwymStorefrontLayoutContext.SelectedLayoutView = SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist;
          if (SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched) {
            document.dispatchEvent(new CustomEvent(SwymStorefrontLayoutContext.CustomEvents.WishlistFetched, {
              detail: {
                defaultList: SwymStorefrontLayoutContext.DefaultList,
                collections: SwymStorefrontLayoutContext.collections,
                lists: SwymStorefrontLayoutContext.lists
              }
            }));
          }
    
          SwymStorefrontLayoutExtensions?.Notification?.setMessage({
            message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemSaved,
            status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
            iconType: SwymStorefrontLayoutContext?.NotificationIconType?.SuccessIcon
          });
    
          // Fire API calls THEN refresh; suppress duplicate notifications from SDK event listeners
          SwymStorefrontLayoutContext._sfyMoveToWishlist = true;
          try {
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, lid);
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.addProductToLists({ epi, empi, du }, [lid]);
          } finally {
            SwymStorefrontLayoutContext._sfyMoveToWishlist = false;
            SwymStorefrontLayoutExtensions?.refreshWishList();
          }
    
          window._swat?.instrumentV3(
            SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYItemMovedToWishlist,
            { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi }
          );
        } catch (err) {
          window._swat?.utils.error('[SFY] Move to wishlist failed', err);
        }
      }
    
      handleAddToCart(event) {
        event.preventDefault();
        let button = event.target;
    
        let { empi, epi, du } = this.dataset;
        let quantity = this.getCurrentQuantity();
    
        let originalButtonState = button.innerHTML;
        button.innerHTML = SwymStorefrontLayoutContext?.Strings?.addingToCart;
        button.setAttribute('disabled', true);
    
        _swat.api.replayAddToCart(
          { empi: +empi, du: du, qty: quantity },
          +epi,
          (success) => {
            button.innerHTML = SwymStorefrontLayoutContext?.Strings?.addedToCart;
            button.removeAttribute('disabled');
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageAddedToCart,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
              actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToCart,
              image: this.item.iu,
              product: this.item,
              title: this.item?.productData?.title || this.item?.dt,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              action: {
                label: SwymStorefrontLayoutContext?.Strings?.notificationActionGoToCart,
                onClick: () => {
                  window.location.href = `${window.Shopify.routes.root}cart`;
                }
              }
            }, {
              showActionButton: true,
              showTitle: true
            });
    
            if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem) {
              window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYItemAddedToCart, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCartConversion, epi, empi });
            } else {
              window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemAddedToCart, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCartConversion, epi, empi });
            }
            window?._SwymAJAXCart();
          },
          (error) => {
            button.innerHTML = originalButtonState;
            button.removeAttribute('disabled');
            window._swat?.utils.warn('Error :', error.description);
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              title: error.description,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Error
            },{
              showTitle: true,
              showImage: false
            });
          }
        );
      }
    
      handleMoveToCart(event) {
        event.preventDefault();
        let button = event.target;
    
        let { empi, epi, du } = this.dataset;
        let quantity = this.getCurrentQuantity();
    
        let originalButtonState = button.innerHTML;
        button.innerHTML = SwymStorefrontLayoutContext?.Strings?.movingToCartCta;
        button.setAttribute('disabled', true);
        
        window._swat?.api.replayAddToCart(
          { empi: +empi, du: du, qty: quantity },
          +epi,
          async (success) => {
            try{
              await SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.removeProductFromSFL({ epi, empi, du }, SwymStorefrontLayoutContext.sflListId);
              let elementDeleted = this.elements.sflItemsContainer?.querySelector(`[data-epi="${epi}"]`);
              elementDeleted?.remove();
              window._swat?.triggerSwymEvent(window._swat?.JSEvents?.movedToCartFromSFL, this.item);
    
              SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                message: SwymStorefrontLayoutContext?.Strings?.notificationMessageMovedToCart,
                status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToCart,
                image: this.item.iu,
                product: this.item,
                title: this.item?.productData?.title || this.item?.dt,
                duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                action: {
                  label: SwymStorefrontLayoutContext?.Strings?.notificationActionGoToCart,
                  onClick: () => {
                    window.location.href = `${window.Shopify.routes.root}cart`;
                  }
                }
              }, {
                showActionButton: true,
                showTitle: true
              });
      
              window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFLItemMovedToCart, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCartConversion, epi, empi });
              window?._SwymAJAXCart();
            }catch(error){
              button.innerHTML = originalButtonState;
              button.removeAttribute('disabled');
              window._swat?.utils.warn('Error removing SFL Items:', error);
            }
    
          },
          (error) => {
            button.innerHTML = originalButtonState;
            button.removeAttribute('disabled');
            window._swat?.utils.warn('Error :', error.description);
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              title: error.description,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Error
            },{
              showTitle: true,
              showImage: false
            });
          }
        );
      }
    
      async handleVariantSelectionChange() {
    
        let selectedOptions = {};
        const variantSelectors = this.querySelectorAll(".swym-storefront-layout-variant-selector");
        
        variantSelectors.forEach((selector) => {
          const selectedValue = selector.value?.trim();
          const optionIndex = selector.dataset.optionindex;
        
          if (selectedValue && optionIndex) {
            selectedOptions[`option${optionIndex}`] = selectedValue;
          }
        });
        
        const selectedVariant = this.item.productData.variants.find((variant) =>
          Object.entries(selectedOptions).every(([key, value]) => variant[key] === value)
        );
    
        this.selectedVariant = selectedVariant;
        this.dataset.epi = selectedVariant.id;
        this.item.cprops = this.item.cprops ?? {};
        this.item.cprops.selectedVariantId = selectedVariant.id;
    
        if (selectedVariant) {
          const buttonText = this.getButtonState();
          this.elements.AddToCartButton.textContent = buttonText;
          // The button relies on its text content for its accessible name
          if (selectedVariant.available) {
            this.elements.AddToCartButton.removeAttribute('disabled');
          } else {
            this.elements.AddToCartButton.setAttribute('disabled', true);
          }
    
          this.elements.Price.textContent =this.getFormattedPrice();
          this.elements.ComparePrice.textContent = this.getFormattedComparePrice();
    
          const productImage = selectedVariant?.featured_image?.src || this.item.productData?.featured_image || item.iu;
          this.elements.Image.src = productImage;
    
          let canEdit = (this.list?.userinfo?.em === SwymStorefrontLayoutContext?.SwymCustomerData?.email) || this.list?.canEdit;
    
          if(SwymStorefrontLayoutContext?.checkUserCanEditList(this.list)){
            let { epi, empi, du } = this.item;
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutVariantChanged, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.updateProductFromList({ epi, empi, du, cprops: { selectedVariantId: selectedVariant.id } }, this.list.lid);
          }
        } else {
          window._swat?.utils.warn("No matching variant found for the selected options:", selectedOptions);
        }
      }
    
      validateQuantityInput(event) {
        if (!this.isSfsQuantityFeatureEnabled()) return;
        
        const input = event.target;
        let value = parseInt(input.value);
        const minQty = this.getMinQuantity();
        const maxQty = this.getMaxQuantity();
        const quantitySelector = input.closest('.swym-storefront-layout-quantity-selector');
        
        let hasError = false;
        
        // Check if value is within bounds
        if (isNaN(value) || value < minQty || (maxQty && value > maxQty)) {
          hasError = true;
        }
        
        // Add or remove error styling
        if (quantitySelector) {
          if (hasError) {
            quantitySelector.classList.add('swym-quantity-error');
            // Don't auto-correct the value, keep the invalid value visible
            
            // Show error toast notification
            const minQty = this.getMinQuantity();
            const maxQty = this.getMaxQuantity();
            let errorMessage = '';
            
            if (isNaN(value) || value < minQty) {
              errorMessage = `Minimum allowed quantity is ${minQty}`;
            } else if (maxQty && value > maxQty) {
              errorMessage = `Maximum allowed quantity is ${maxQty}`;
            }
            
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              title: errorMessage,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Error,
              duration: 3000
            }, {
              showTitle: true,
              showImage: false
            });
          } else {
            quantitySelector.classList.remove('swym-quantity-error');
            // Only update the item quantity if it's valid
            this.item.qty = value;
            // Debounce the backend update for valid values
            this.debouncedUpdateItemQuantity(value);
          }
        }
        
        // Update button states
        this.updateQuantityButtonStates();
      }
    
      handleQuantityChange(event) {
        if (!this.isSfsQuantityFeatureEnabled()) return;
        
        const input = event.target;
        const newQuantity = parseInt(input.value);
        const minQty = this.getMinQuantity();
        const maxQty = this.getMaxQuantity();
        
        // Only update if the quantity is valid
        if (!isNaN(newQuantity) && newQuantity >= minQty && (!maxQty || newQuantity <= maxQty)) {
          // Update the item's quantity
          this.item.qty = newQuantity;
          
          // Debounce the backend update
          this.debouncedUpdateItemQuantity(newQuantity);
        }
        
        // Always update button states
        this.updateQuantityButtonStates();
      }
    
      async updateItemQuantity(quantity) {
        try {
          const minQty = this.getMinQuantity();
          const maxQty = this.getMaxQuantity();
          
          // Validate quantity before updating
          if (quantity < minQty || (maxQty && quantity > maxQty)) {
            window._swat?.utils.warn(`Quantity ${quantity} is outside allowed range (${minQty}${maxQty ? `-${maxQty}` : '+'})`);
            return;
          }
          
          if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.WishlistItem || 
              this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.CollectionItem) {
            
            // Update wishlist item quantity
            const updatedItem = { epi: this.item?.epi, empi: this.item?.empi, du: this.item?.du, qty: quantity };
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.updateProductFromList(updatedItem, this.list.lid);
            
          } else if (this.listItemType === SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem) {
            
            // Update SFL item quantity
            const updatedItem = { epi: this.item?.epi, empi: this.item?.empi, du: this.item?.du, qty: quantity };
            await SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.updateProductInSFL(updatedItem, SwymStorefrontLayoutContext.sflListId);
            
          }
        } catch (error) {
          window._swat?.utils.warn('Error updating item quantity:', error);
          // Revert the input value on error
          if (this.elements.QuantityInput) {
            this.elements.QuantityInput.value = this.item.qty || this.getMinQuantity();
          }
        }
      }
    
      getCurrentQuantity() {
        if (!this.isSfsQuantityFeatureEnabled()) {
          return this.item.qty || 1;
        }
        return parseInt(this.elements.QuantityInput?.value) || this.item.qty || 1;
      }
    
      debouncedUpdateItemQuantity(quantity) {
        // Clear any existing timeout
        if (this.quantityUpdateTimeout) {
          clearTimeout(this.quantityUpdateTimeout);
        }
        
        // Set a new timeout for 500ms
        this.quantityUpdateTimeout = setTimeout(() => {
          this.updateItemQuantity(quantity);
        }, 500);
      }
    
      isSfsQuantityFeatureEnabled() {
        try {
          const retailerSettings = window._swat?.retailerSettings;
          if (!retailerSettings) return false;
          
          // Check if WishlistPlusPDPButtonAPI is available and use its SFS check
          if (typeof window.WishlistPlusPDPButtonAPI?.isSfsFeatureEnabled === 'function') {
            return window.WishlistPlusPDPButtonAPI.isSfsFeatureEnabled('WishlistQuantity', retailerSettings);
          }
          
            // Fallback: Check if SFS/EngageUI is enabled
            const SFSEnabled = retailerSettings?.General?.EngageUI?.Enabled;
            const features = retailerSettings?.General?.EngageUI?.Features;
          const quantityFeatureEnabled = features?.some(
            (feature) => feature?.featureName === 'WishlistQuantity' && feature?.enabled === true
          );
          
          return SFSEnabled && quantityFeatureEnabled;
        } catch (error) {
          window._swat?.utils.warn('Error checking SFS quantity feature:', error);
          return false;
        }
      }
    
      updateQuantityButtonStates() {
        if (!this.isSfsQuantityFeatureEnabled()) return;
        
        const currentQty = this.getCurrentQuantity();
        const minQty = this.getMinQuantity();
        const maxQty = this.getMaxQuantity();
        const quantitySelector = this.elements.QuantityInput?.closest('.swym-storefront-layout-quantity-selector');
        const hasError = quantitySelector?.classList.contains('swym-quantity-error');
        
        // Update minus button state
        if (this.elements.QuantityMinusBtn) {
          if (hasError || currentQty <= minQty) {
            this.elements.QuantityMinusBtn.disabled = true;
          } else {
            this.elements.QuantityMinusBtn.disabled = false;
          }
        }
        
        // Update plus button state
        if (this.elements.QuantityPlusBtn) {
          if (hasError || (maxQty && currentQty >= maxQty)) {
            this.elements.QuantityPlusBtn.disabled = true;
          } else {
            this.elements.QuantityPlusBtn.disabled = false;
          }
        }
      }
    
      handleQuantityDecrease(event) {
        if (!this.isSfsQuantityFeatureEnabled()) return;
        
        event.preventDefault();
        const currentQty = this.getCurrentQuantity();
        const minQty = this.getMinQuantity();
        if (currentQty > minQty) {
          const newQty = currentQty - 1;
          this.elements.QuantityInput.value = newQty;
          
          // Update the item's quantity immediately for UI responsiveness
          this.item.qty = newQty;
          
          // Update button states immediately
          this.updateQuantityButtonStates();
          
          // Debounce the backend update
          this.debouncedUpdateItemQuantity(newQty);
        }
      }
    
      handleQuantityIncrease(event) {
        if (!this.isSfsQuantityFeatureEnabled()) return;
        
        event.preventDefault();
        const currentQty = this.getCurrentQuantity();
        const maxQty = this.getMaxQuantity();
        if (!maxQty || currentQty < maxQty) {
          const newQty = currentQty + 1;
          this.elements.QuantityInput.value = newQty;
          
          // Update the item's quantity immediately for UI responsiveness
          this.item.qty = newQty;
          
          // Update button states immediately
          this.updateQuantityButtonStates();
          
          // Debounce the backend update
          this.debouncedUpdateItemQuantity(newQty);
        }
      }
    
    }
    
    /**
     * SwymStorefrontLayoutDefaultWishList
     * 
     * This custom HTML element represents the default wishlist layout in the storefront.
     * It handles rendering wishlist items dynamically and updating the UI when new wishlist data is set.
     * 
     * Features:
     * - Initializes with a loading state until wishlist data is available.
     * - Fetches product details for wishlist items and updates the UI.
     * - Displays an empty state when no wishlist items exist.
     * - Uses Swym API and instrumentation to track interactions.
     * 
     * Usage:
     * <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
     */
    class SwymStorefrontLayoutDefaultWishList extends HTMLElement {
      constructor() {
        super();
        this.wishlist = null;
        this.collections = null;
        this.renderUI();
        this.elements = {
          title: this.querySelector('.swym-storefront-layout-default-list-title'),
          itemsContainer: this.querySelector('#swym-storefront-layout-items-container')
        }
      }
    
      handleAddToCart(event, productDetail) {
        event.preventDefault();
        let button = event.target;
    
        let empi = productDetail.empi; //8445423517851;
        let epi = productDetail.epi; //46212304076955;
        let du = productDetail.du; //"https://swym-test-onboarding-2-0.myshopify.com/products/the-collection-snowboard-hydrogen"
    
        let originalButtonState = button.innerHTML;
        button.innerHTML = SwymStorefrontLayoutContext?.Strings?.addingToCart;
        button.setAttribute('disabled', true);
    
        _swat.api.replayAddToCart(
          { empi: +empi, du: du, qty: 1 },
          +epi,
          (success) => {
            button.innerHTML = SwymStorefrontLayoutContext?.Strings?.addedToCart;
            button.removeAttribute('disabled');
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageAddedToCart,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
              actionType: SwymStorefrontLayoutContext?.NotificationActionTypes.AddedToCart,
              image: "",
              product: "",
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              action: {
                label: SwymStorefrontLayoutContext?.Strings?.notificationActionGoToCart,
                onClick: () => {
                  window.location.href = `${window.Shopify.routes.root}cart`;
                }
              }
            }, {
              showActionButton: true,
              showTitle: true
            });
          },
          (error) => {
            button.innerHTML = originalButtonState;
            button.removeAttribute('disabled');
            window._swat?.utils.warn('Error :', error.description);
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              title: error.description,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Error
            },{
              showTitle: true,
              showImage: false
            });
          }
        );
      }
    
      renderUI() {
        if(window.Shopify.designMode && !window.SwymCurrentStorePath) {
          const swymMockProductData = window.SwymSampleProduct;
          
          // Extract and clean up the IDs
          const swymMockProductId = swymMockProductData?.id?.replace('gid://shopify/Product/', '');
          const swymMockVariantId = swymMockProductData?.variants?.edges?.[0]?.node?.id?.replace('gid://shopify/ProductVariant/', '');
          
          // Construct the product URL using Shopify.shop
          const swymMockProductUrl = `https://${window.Shopify.shop}/products/${swymMockProductData?.handle}`;
          
          window.SwymParsedSampleProduct = {
            image: swymMockProductData?.variants?.edges?.[0]?.node?.image,
            empi: swymMockProductId,
            epi: swymMockVariantId,
            du: swymMockProductUrl,
            title: swymMockProductData?.variants?.edges?.[0]?.node?.title,
            price: `$${swymMockProductData?.variants?.edges?.[0]?.node?.price}`
          };
    
          const sampleFullTitle = window.SwymParsedSampleProduct.title || '';
          const sampleTitleSeparatorIndex = sampleFullTitle.indexOf('|');
          const sampleProductTitle = sampleTitleSeparatorIndex === -1 ? sampleFullTitle : sampleFullTitle.slice(0, sampleTitleSeparatorIndex).trim();
          const sampleVariantInfo = sampleTitleSeparatorIndex === -1 ? '' : sampleFullTitle.slice(sampleTitleSeparatorIndex + 1).trim().replace(/\s*\|\s*$/, '');

          this.innerHTML = `<div id="swym-storefront-layout-items-container" class="swym-storefront-layout-items-container"><div class="swym-storefront-layout-grid-item">
              <a href="#" class="swym-storefront-layout-grid-item-image-container">
                <img src="${window.SwymParsedSampleProduct?.image}" alt="${window.SwymParsedSampleProduct?.title ? window.SwymParsedSampleProduct.title : 'Product image'}" class="swym-storefront-layout-grid-item-image" />
              </a>
              <div class="swym-storefront-layout-grid-item-content">
                <a href="${window.SwymParsedSampleProduct?.du}" class="swym-storefront-layout-grid-item-title">${sampleProductTitle}</a>
                ${sampleVariantInfo ? `<div class="swym-storefront-layout-grid-item-variant">${sampleVariantInfo}</div>` : ''}
                <div class="swym-storefront-layout-grid-item-price-variant">
                  <span class="swym-storefront-layout-grid-item-final-price">${window.SwymParsedSampleProduct?.price}</span>
                </div>
                <div class="swym-storefront-layout-grid-item-action-container">
                  <button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart">
                    ${SwymStorefrontLayoutContext?.Strings?.addToCart || 'Add to cart'}
                  </button>
                </div>
              </div>
            </div></div>`
    
            const addToCartBtn = this.querySelector(".swym-storefront-layout-grid-item-add-to-cart-button");
            if (addToCartBtn) {
              addToCartBtn.addEventListener("click", (e) => {
                this.handleAddToCart(e, window.SwymParsedSampleProduct)
              });
            }
            return;
        }
        
        const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
    
        this.innerHTML = `
          <div class="swym-storefront-layout-default-list-container">
          ${shouldShowMultiple ? `
              <div class="swym-storefront-layout-default-list-title-container"> 
                <div class="swym-storefront-layout-default-list-title">${SwymStorefrontLayoutContext?.Strings?.wishlistTitle}</div>
                <div class="swym-storefront-layout-default-list-info">${SwymStorefrontLayoutContext?.Strings?.wishlistInfo}</div>
              </div>
            ` : ''}
            <div id="swym-storefront-layout-items-container" class="swym-storefront-layout-items-container">
              <swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType.WishlistListItem}" buttonCta="${SwymStorefrontLayoutContext?.Strings?.addToCart}" height="100px"></swym-storefront-layout-loader>
            </div>
          </div>
        `
      }
    
      setData({ wishlist, collections, canCreateLists = true }) {
        this.wishlist = wishlist;
        this.collections = collections;
        this.canCreateLists = canCreateLists;
        if (this.elements?.itemsContainer?.dataset && this.wishlist?.lid) {
          this.elements.itemsContainer.dataset.lid = this.wishlist.lid;
        }
        this.renderWishlist();
      }
    
      async renderWishlist() {
        if (this.wishlist?.listcontents?.length && this.elements.itemsContainer) {
          
          window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutWishlistItemsRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
    
          const wishlistedProducts = this.wishlist?.listcontents;
          const fragment = document.createDocumentFragment();
    
          wishlistedProducts.forEach((item) => {
            const wishlistItem = document.createElement('template');
            wishlistItem.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-item-${item.empi}-${item.epi}" class="${SwymStorefrontLayoutContext?.getSelectedVariant(item, item?.cprops?.selectedVariantId || item?.epi)?.available === false ? 'swym-storefront-layout-item-sold-out' : ''}"></swym-storefront-layout-item>`;
            fragment.appendChild(wishlistItem.content);
          });
          
          this.elements.itemsContainer.innerHTML = '';
          this.elements.itemsContainer.appendChild(fragment);
    
          wishlistedProducts.forEach((item) => {
            let wishlistItemElement = document.querySelector(`#swym-storefront-layout-item-${item.empi}-${item.epi}`);
            wishlistItemElement?.setData({
              item,
              listItemType: SwymStorefrontLayoutContext?.ListItemType?.WishlistItem,
              list: this.wishlist,
              collections: this.collections,
              canCreateLists: this.canCreateLists
            })
          });
          this.elements.itemsContainer.classList.remove('swym-storefront-layout-items-has-empty');
        }else{
          const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
          const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          const rootUrl = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
          const accountUrl = `${rootUrl}/account`;
          const homeUrl = window.Shopify?.routes?.root || '/';
    
          let emptyStateHtml = '';
          let noticeText = '';
    
          if (!shouldShowMultiple && isLoggedIn) {
            // State 1: Single wishlist – Logged in (new rich design)
            emptyStateHtml = `
              <div class="swym-storefront-layout-empty-container swym-storefront-layout-empty-state-single-logged">
                <div class="swym-storefront-layout-empty-wishlist-container">
                  <div class="swym-storefront-layout-empty-wishlist-content">
                    <div class="swym-storefront-layout-empty-state-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="#F5F5F5"/>
                        <path d="M20 18H18C17.4696 18 16.9609 18.2107 16.5858 18.5858C16.2107 18.9609 16 19.4696 16 20V32C16 32.5304 16.2107 33.0391 16.5858 33.4142C16.9609 33.7893 17.4696 34 18 34H30C30.5304 34 31.0391 33.7893 31.4142 33.4142C31.7893 33.0391 32 32.5304 32 32V20C32 19.4696 31.7893 18.9609 31.4142 18.5858C31.0391 18.2107 30.5304 18 30 18H28M20 18V16C20 15.4696 20.2107 14.9609 20.5858 14.5858C20.9609 14.2107 21.4696 14 22 14H26C26.5304 14 27.0391 14.2107 27.4142 14.5858C27.7893 14.9609 28 15.4696 28 16V18M20 18H28M24 24V28M22 26H26" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-state-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <circle cx="7" cy="7" r="7" fill="#E8A0BF"/>
                          <path d="M7 4V10M4 7H10" stroke="white" stroke-width="1.5" stroke-linecap="round"/>
                        </svg>
                      </span>
                    </div>
                    <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInTitle || ''}</div>
                    <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInDescription || ''}</div>
                    <div class="swym-storefront-layout-empty-state-card">
                      <ul class="swym-storefront-layout-empty-state-bullet-list">
                        <li>${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInBullet1 || ''}</li>
                        <li>${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInBullet2 || ''}</li>
                        <li>${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInBullet3 || ''}</li>
                      </ul>
                    </div>
                    <hr class="swym-storefront-layout-empty-state-divider" />
                    <a href="${homeUrl}" class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-state-start-browsing">
                      ${SwymStorefrontLayoutContext?.Strings?.emptySingleLoggedInCTA || ''}
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none"><path d="M13.8536 4.85368C14.0488 4.65841 14.0488 4.34183 13.8536 4.14657L10.6716 0.964589C10.4763 0.769327 10.1597 0.769327 9.96447 0.964589C9.7692 1.15985 9.7692 1.47643 9.96447 1.6717L12.7929 4.50012L9.96447 7.32855C9.7692 7.52381 9.7692 7.84039 9.96447 8.03566C10.1597 8.23092 10.4763 8.23092 10.6716 8.03566L13.8536 4.85368ZM0.5 5.00012L13.5 5.00012L13.5 4.00012L0.5 4.00012L0.5 5.00012Z" fill="currentColor"/></svg>
                    </a>
                  </div>
                </div>
              </div>
            `;
          } else if (!shouldShowMultiple && !isLoggedIn) {
            // State 2: Single wishlist – Guest (new rich design)
            noticeText = SwymStorefrontLayoutContext?.Strings?.emptyGuestSingleNotice || '';
    
            emptyStateHtml = `
              <div class="swym-storefront-layout-empty-container swym-storefront-layout-empty-state-guest">
                <div class="swym-storefront-layout-empty-wishlist-container">
                  <div class="swym-storefront-layout-empty-wishlist-content">
                    <div class="swym-storefront-layout-empty-state-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                        <circle cx="28" cy="28" r="28" fill="#F5F3FF"/>
                        <path d="M28 38L17.55 28.03C16.6264 27.0846 16.0453 25.8579 15.8955 24.5427C15.7457 23.2275 16.0356 21.8986 16.72 20.766C17.4045 19.6334 18.4445 18.7606 19.6772 18.2842C20.9099 17.8079 22.2674 17.7551 23.533 18.134C24.468 18.4101 25.3178 18.916 26.005 19.604L28 21.6L29.995 19.604C30.6822 18.916 31.532 18.4101 32.467 18.134C33.7326 17.7551 35.0901 17.8079 36.3228 18.2842C37.5555 18.7606 38.5955 19.6334 39.28 20.766C39.9644 21.8986 40.2543 23.2275 40.1045 24.5427C39.9547 25.8579 39.3736 27.0846 38.45 28.03L28 38Z" stroke="#8B7EC8" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="#C8B8F0"/>
                      </svg>
                    </div>
                    <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptyGuestTitle || ''}</div>
                    <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptyGuestDescription || ''}</div>
                    <div class="swym-storefront-layout-empty-state-notice">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8" stroke="#B45309" stroke-width="1.2"/>
                        <path d="M9 5V9L11 11" stroke="#B45309" stroke-width="1.2" stroke-linecap="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-state-notice-text"></span>
                    </div>
                    <hr class="swym-storefront-layout-empty-state-divider" />
                    <a href="${accountUrl}" class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-state-login-cta">
                      ${SwymStorefrontLayoutContext?.Strings?.emptyGuestLoginCTA || ''}
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none"><path d="M13.8536 4.85368C14.0488 4.65841 14.0488 4.34183 13.8536 4.14657L10.6716 0.964589C10.4763 0.769327 10.1597 0.769327 9.96447 0.964589C9.7692 1.15985 9.7692 1.47643 9.96447 1.6717L12.7929 4.50012L9.96447 7.32855C9.7692 7.52381 9.7692 7.84039 9.96447 8.03566C10.1597 8.23092 10.4763 8.23092 10.6716 8.03566L13.8536 4.85368ZM0.5 5.00012L13.5 5.00012L13.5 4.00012L0.5 4.00012L0.5 5.00012Z" fill="currentColor"/></svg>
                    </a>
                    <button class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-state-browse-cta" data-action="close-drawer">
                      ${SwymStorefrontLayoutContext?.Strings?.emptyGuestBrowseCTA || ''}
                    </button>
                    <div class="swym-storefront-layout-empty-state-signup-text">
                      ${SwymStorefrontLayoutContext?.Strings?.emptyGuestSignupText || ''} <a href="${accountUrl}" class="swym-storefront-layout-empty-state-signup-link">${SwymStorefrontLayoutContext?.Strings?.emptyGuestSignupCTA || ''}</a>
                    </div>
                  </div>
                </div>
              </div>
            `;
          } else {
            // Multi wishlist – old simple empty state (logged in or guest)
            emptyStateHtml = `
              <div class="swym-storefront-layout-empty-container">
                <div class="swym-storefront-layout-empty-wishlist-container">
                  <div class="swym-storefront-layout-empty-wishlist-content">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="86" height="85" viewBox="0 0 86 85" fill="none">
                    <rect width="59.5441" height="78.6833" transform="translate(0.710449 6.1748) rotate(-5.46887)" fill="white"/>
                    <rect x="0.710938" y="6.1748" width="59.5441" height="78.6833" rx="1.21519" transform="rotate(-5.46887 0.710938 6.1748)" fill="#FDFDFD"/>
                    <rect x="0.983626" y="6.39984" width="59.0441" height="78.1833" rx="0.965186" transform="rotate(-5.46887 0.983626 6.39984)" stroke="black" stroke-opacity="0.1" stroke-width="0.5"/>
                    <rect x="5.57364" y="10.7446" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 5.57364 10.7446)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="13.0841" y="11.0938" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.0841 11.0938)" fill="#D0D0D0"/>
                    <rect x="6.44223" y="19.8169" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 6.44223 19.8169)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="13.9527" y="20.166" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.9527 20.166)" fill="#D0D0D0"/>
                    <rect x="7.31107" y="28.8892" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 7.31107 28.8892)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="14.8214" y="29.2383" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 14.8214 29.2383)" fill="#D0D0D0"/>
                    <rect x="8.17942" y="37.9619" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 8.17942 37.9619)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="15.6899" y="38.311" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 15.6899 38.311)" fill="#D0D0D0"/>
                    <rect x="9.04825" y="47.0342" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.04825 47.0342)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="16.5587" y="47.3833" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 16.5587 47.3833)" fill="#D0D0D0"/>
                    <rect x="9.91666" y="56.1069" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.91666 56.1069)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="17.4271" y="56.4561" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 17.4271 56.4561)" fill="#D0D0D0"/>
                    <rect x="10.7854" y="65.1792" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 10.7854 65.1792)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="18.2959" y="65.5283" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 18.2959 65.5283)" fill="#D0D0D0"/>
                    <rect x="11.6538" y="74.2515" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 11.6538 74.2515)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                    <rect x="19.1643" y="74.6006" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 19.1643 74.6006)" fill="#D0D0D0"/>
                    <rect x="55.0288" y="35.834" width="31.0853" height="31.0853" transform="rotate(13.2248 55.0288 35.834)" fill="url(#pattern0_489_1797)"/>
                    <defs>
                    <pattern id="pattern0_489_1797" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_489_1797" transform="scale(0.0104167)"/>
                    </pattern>
                    <image id="image0_489_1797" width="96" height="96" xlink:href="data:image/png;base64,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"/>
                    </defs>
                  </svg>
                    <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptyWishlistTitle}</div>
                    <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptyWishlistDescription}</div>
                    <a href="${rootUrl}/collections/all" class="swym-storefront-layout-empty-state-cta-button">${SwymStorefrontLayoutContext?.Strings?.continueShoppingCta}</a>
                  </div>
                </div>
              </div>
            `;
          }
    
          this.elements.itemsContainer.innerHTML = emptyStateHtml;
          this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
    
          // Safely set notice text as innerHTML (controlled locale string with <strong> tags)
          const noticeEl = this.elements.itemsContainer.querySelector('.swym-storefront-layout-empty-state-notice-text');
          if (noticeEl) {
            noticeEl.innerHTML = noticeText || '';
          }
    
          // Attach event listener for "Keep browsing first" button (closes the drawer)
          const browseBtn = this.elements.itemsContainer.querySelector('[data-action="close-drawer"]');
          if (browseBtn) {
            browseBtn.addEventListener('click', () => {
              const layout = SwymStorefrontLayoutExtensions.SwymStorefrontLayout
                || document.querySelector('swym-storefront-layout #swym-storefront-layout');
              layout?.close?.();
            });
          }
    
          // Attach event listener for multi-logged-in "+ Create a new list" card in items empty state
          const createCardItems = this.elements.itemsContainer.querySelector('[data-action="create-collection"]');
          if (createCardItems) {
            createCardItems.addEventListener('click', () => {
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.setData({
                listId: SwymStorefrontLayoutContext?.DefaultList?.lid,
                list: SwymStorefrontLayoutContext?.DefaultList,
                item: { iu: '', dt: '' },
                collections: SwymStorefrontLayoutContext?.collections || [],
                actionType: SwymStorefrontLayoutContext?.ActionTypes.AddToCollection,
                canCreateLists: true
              });
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.openDrawer();
            });
          }
        }
    
        let wishlistCount = (this.wishlist?.listcontents || []).filter(item => item.source !== 'auto-wishlist').length;
        if(this.elements.title){
          this.elements.title.innerHTML = `${SwymStorefrontLayoutContext?.Strings?.wishlistTitle} ${wishlistCount?`(${wishlistCount})`:''}`;
        }
      }
    
    
    }
    
    /**
     * SwymStorefrontLayoutCollectionList
     *
     * A custom HTML element representing a collection list within the Swym Storefront Layout.
     * This component is responsible for rendering a list of collections, displaying wishlist items, 
     * handling user interactions, and managing collection data.
     *
     * Features:
     * - Initializes and renders the UI dynamically.
     * - Fetches and displays wishlist items for a collection.
     * - Handles user permissions for editing or saving collections.
     * - Provides UI elements like back navigation, action buttons, and collection details.
     *
     * Usage:
     * ```html
     * <swym-storefront-layout-collection-list></swym-storefront-layout-collection-list>
     * ```
     * JavaScript:
     * ```js
     * const collectionListElement = document.createElement('swym-storefront-layout-collection-list');
     * collectionListElement.setData({ list: myList, collections: myCollections });
     * document.body.appendChild(collectionListElement);
     * ```
     */
    class SwymStorefrontLayoutCollectionList extends HTMLElement {
      constructor() {
        super();
        this.collectionList = null;
        this.collections = null;
      }
      initUI(){
        this.renderUI();
        this.elements = {
          backButton: this.querySelector('.swym-storefront-layout-collection-list-back-button'),
          itemsContainer: this.querySelector('#swym-storefront-layout-collection-list-items-container'),
          collectionCount: this.querySelector('.swym-storefront-layout-collection-items-count'),
          title: this.querySelector('.swym-storefront-layout-collection-title'),
          swymListActionButton: this.querySelector('#swym-storefront-layout-collection-option-button'),
          userAccessInfo: this.querySelector('#swym-storefront-layout-collection-list-access-info'),
          collectionImages: this.querySelector('#swym-storefront-layout-collection-list-images-container'),
          firstItemImage: this.querySelector('.swym-storefront-layout-collection-first-item-image'),
          shopperInfo: this.querySelector('.swym-storefront-layout-collection-list-shopper-info'),
          shopperInfoText: this.querySelector('.swym-storefront-layout-collection-list-shopper-info-text')
        }
        const onShopperInfoActivate = () => {
          if (!SwymStorefrontLayoutContext?.isShopperLoggedIn) return SwymStorefrontLayoutExtensions.openLoginModal();
          if (window.SWYM_ACCOUNT_OR_LOGIN_URL) window.location.href = window.SWYM_ACCOUNT_OR_LOGIN_URL;
        };
        this.elements.shopperInfo?.addEventListener('click', onShopperInfoActivate);
        this.elements.shopperInfo?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          onShopperInfoActivate();
        });
        this.addEventListenerToView();
      }
    
      setData({ list, collections, canCreateLists = true, shouldShowMultiple = true }) {
        this.initUI();
        this.renderLoader();
        this.collectionList = list;
        this.collections = collections;
        this.canCreateLists = canCreateLists;
        this.shouldShowMultiple = shouldShowMultiple;
        if(this.collectionList){
          this.elements.itemsContainer.dataset.lid = this.collectionList.lid;
          this.canEdit = SwymStorefrontLayoutContext?.checkUserCanEditList(this.collectionList);
          this.renderCollectionlist();
        }
      }
    
      renderUI() {
        this.innerHTML = `
        <div class="swym-storefront-layout-collection-list-container">
          <div class="swym-storefront-layout-default-list-title-container swym-storefront-layout-collection-list-my-wishlist-title-container">
            <div class="swym-storefront-layout-default-list-title swym-storefront-layout-collection-list-my-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.title}</div>
          </div>
          <div class="swym-storefront-layout-collection-list-header">
            <div id="swym-storefront-layout-collection-list-images-container">
            </div>
            <div class="swym-storefront-layout-collection-list-header-content">
              <div class="swym-storefront-layout-collection-title-container">
                <img class="swym-storefront-layout-collection-first-item-image" alt="" style="display:none;">
                <div class="swym-storefront-layout-collection-title-text">
                  <div class="swym-storefront-layout-collection-title"></div>
                  <div class="swym-storefront-layout-collection-items-count"></div>
                </div>
                <div class="swym-storefront-layout-collection-list-shopper-info" role="button" tabindex="0">
                  <img class="swym-storefront-layout-collection-list-shopper-info-icon" src="${window.SWYM_GUEST_SHOPPER_ICON_URL || ''}" width="18" height="18" alt="">

                  <span class="swym-storefront-layout-collection-list-shopper-info-text"></span>
                </div>
                <div id="swym-storefront-layout-collection-option-button" class="swym-storefront-layout-collection-option-button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
                    <circle cx="1.5" cy="1.50014" r="1.5" fill="currentColor"></circle>
                    <circle cx="1.5" cy="6.50014" r="1.5" fill="currentColor"></circle>
                    <circle cx="1.5" cy="11.5001" r="1.5" fill="currentColor"></circle>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="swym-storefront-layout-collection-list-content swym-storefront-layout-scrollable">
            <div class="swym-storefront-layout-collection-list-back-button">
              <svg data-v-bfb713a3="" data-v-326364ff="" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="base-icon back-icon" aria-hidden="true"><path d="M15.44 7a.96.96 0 0 0-.96-.96H3.951l3.903-3.638A.96.96 0 1 0 6.544 1L.856 6.297a.963.963 0 0 0 0 1.404L6.543 13a.96.96 0 1 0 1.31-1.404L3.952 7.96H14.48a.96.96 0 0 0 .96-.96Z" fill="currentColor"></path></svg>
              <span class="swym-storefront-layout-collection-list-back-button-text">Back</span>
            </div>
            <div id="swym-storefront-layout-collection-list-access-info"></div>
            <div id="swym-storefront-layout-collection-list-items-container" class="swym-storefront-layout-items-container">
            </div>
          </div>
          <swym-storefront-layout-login-user showLogin="true"></swym-storefront-layout-login-user>
        </div>
        `
      }
    
      addEventListenerToView() {
        this.elements.backButton.addEventListener('click', () => {
          window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List;
          this.closeCollectinListView()
        });
    
        this.elements.swymListActionButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if(SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.closeTooltip();
          }else{
            if(this.canEdit){
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: this.collectionList.lid,
                list: this.collectionList,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.EditCollection
              });
            }else{
              SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
                listId: this.collectionList.lid,
                list: this.collectionList,
                collections: this.collections,
                actionType: SwymStorefrontLayoutContext?.ActionTypes.SaveCollection
              });
            }
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
          }
        });
      }
    
      async renderCollectionlist() {
        if (this.collectionList && this.collectionList.listcontents && this.elements.itemsContainer) {
    
          this.elements.title.innerHTML = `<div class="swym-storefront-layout-collection-title">${this.collectionList.lname}</div>`;
    
          let itemsCount = this.collectionList?.listcontents?.length || 0;
          this.elements.collectionCount.innerHTML = itemsCount?`${itemsCount} ${itemsCount<=1? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items }`:'';

          if (this.elements.shopperInfoText) {
            const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
            const customerEmail = SwymStorefrontLayoutContext?.SwymCustomerData?.email;
            this.elements.shopperInfoText.textContent = (isLoggedIn && customerEmail) ? customerEmail : 'Guest Shopper';
          }

          const wishlistedProducts = this.collectionList.listcontents;

          if (this.elements.firstItemImage) {
            const firstItem = wishlistedProducts[0];
            if (firstItem?.iu) {
              this.elements.firstItemImage.src = firstItem.iu;
              this.elements.firstItemImage.alt = swymEscAttr(firstItem?.dt) || '';
              this.elements.firstItemImage.style.display = '';
            } else {
              this.elements.firstItemImage.removeAttribute('src');
              this.elements.firstItemImage.style.display = 'none';
            }
          }
          const fragment = document.createDocumentFragment();
    
          this.elements.collectionImages.innerHTML = `
            <div class="swym-storefront-layout-collection-list-images">
              ${wishlistedProducts.slice(0, 5).map((item, index) => 
                item 
                  ? `<img class="swym-storefront-layout-collection-list-image swym-storefront-layout-collection-list-image-${index}" src="${item.iu}" alt="Wishlist Image">`
                  : ``
              ).join('')}
            </div>
          `;
    
          
    
          if(itemsCount){
            wishlistedProducts.forEach((item) => {
              const wishlistItem = document.createElement('template');
              wishlistItem.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-collection-item-${item.empi}-${item.epi}" class="${SwymStorefrontLayoutContext?.getSelectedVariant(item, item?.cprops?.selectedVariantId || item?.epi)?.available === false ? 'swym-storefront-layout-item-sold-out' : ''}"></swym-storefront-layout-item>`;
              fragment.appendChild(wishlistItem.content);
            });
            
            this.elements.itemsContainer.innerHTML = '';
            this.elements.itemsContainer.appendChild(fragment);
      
            wishlistedProducts.forEach((item) => {
              let wishlistItemElement = document.querySelector(`#swym-storefront-layout-collection-item-${item.empi}-${item.epi}`);
              wishlistItemElement?.setData({
                item,
                listItemType: SwymStorefrontLayoutContext?.ListItemType?.CollectionItem,
                list: this.collectionList,
                collections: this.collections,
                canCreateLists: this.canCreateLists
              })
            });
          }else{
            this.renderEmptyView();
          }
    
          let isUserLogged = SwymStorefrontLayoutContext?.isShopperLoggedIn;
          if(isUserLogged && !!this.collectionList?.userinfo?.em && this.collectionList?.userinfo?.em != SwymStorefrontLayoutContext?.SwymCustomerData?.email){
            let email = this.collectionList?.userinfo?.em;
            this.elements.userAccessInfo.innerHTML = window._swat?.utils?.renderTemplateString( SwymStorefrontLayoutContext?.Strings?.sharedCollectionMessage, { email });
            this.elements.userAccessInfo.style.display = '';
          }else{
            this.elements.userAccessInfo.innerHTML = ``;
            this.elements.userAccessInfo.style.display = 'none';
          }
    
          this.openCollectionListView();
        }
      }
    
      renderEmptyView(){
        const rootUrl = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        this.elements.itemsContainer.innerHTML = `
          <div class="swym-storefront-layout-empty-container">
            <div class="swym-storefront-layout-empty-wishlist-container">
              <div class="swym-storefront-layout-empty-wishlist-content">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="86" height="85" viewBox="0 0 86 85" fill="none">
                  <rect width="59.5441" height="78.6833" transform="translate(0.710449 6.1748) rotate(-5.46887)" fill="white"/>
                  <rect x="0.710938" y="6.1748" width="59.5441" height="78.6833" rx="1.21519" transform="rotate(-5.46887 0.710938 6.1748)" fill="#FDFDFD"/>
                  <rect x="0.983626" y="6.39984" width="59.0441" height="78.1833" rx="0.965186" transform="rotate(-5.46887 0.983626 6.39984)" stroke="black" stroke-opacity="0.1" stroke-width="0.5"/>
                  <rect x="5.57364" y="10.7446" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 5.57364 10.7446)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="13.0841" y="11.0938" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.0841 11.0938)" fill="#D0D0D0"/>
                  <rect x="6.44223" y="19.8169" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 6.44223 19.8169)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="13.9527" y="20.166" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 13.9527 20.166)" fill="#D0D0D0"/>
                  <rect x="7.31107" y="28.8892" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 7.31107 28.8892)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="14.8214" y="29.2383" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 14.8214 29.2383)" fill="#D0D0D0"/>
                  <rect x="8.17942" y="37.9619" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 8.17942 37.9619)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="15.6899" y="38.311" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 15.6899 38.311)" fill="#D0D0D0"/>
                  <rect x="9.04825" y="47.0342" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.04825 47.0342)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="16.5587" y="47.3833" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 16.5587 47.3833)" fill="#D0D0D0"/>
                  <rect x="9.91666" y="56.1069" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 9.91666 56.1069)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="17.4271" y="56.4561" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 17.4271 56.4561)" fill="#D0D0D0"/>
                  <rect x="10.7854" y="65.1792" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 10.7854 65.1792)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="18.2959" y="65.5283" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 18.2959 65.5283)" fill="#D0D0D0"/>
                  <rect x="11.6538" y="74.2515" width="5.16454" height="5.16454" rx="0.455695" transform="rotate(-5.46887 11.6538 74.2515)" fill="#FBFBFB" stroke="#D0D0D0" stroke-width="0.303797"/>
                  <rect x="19.1643" y="74.6006" width="44.6581" height="3.03797" rx="0.607593" transform="rotate(-5.46887 19.1643 74.6006)" fill="#D0D0D0"/>
                  <rect x="55.0288" y="35.834" width="31.0853" height="31.0853" transform="rotate(13.2248 55.0288 35.834)" fill="url(#pattern0_489_1797)"/>
                  <defs>
                  <pattern id="pattern0_489_1797" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlink:href="#image0_489_1797" transform="scale(0.0104167)"/>
                  </pattern>
                  <image id="image0_489_1797" width="96" height="96" xlink:href="data:image/png;base64,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"/>
                  </defs>
                </svg>
                <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptyCollectionText}</div>
                <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptyCollectionDescription}</div>
                <a href="${rootUrl}/collections/all" class="swym-storefront-layout-empty-state-cta-button">${SwymStorefrontLayoutContext?.Strings?.continueShoppingCta}</a>
              </div>
            </div>
          </div>
        `;
        this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
      }
    
      renderLoader(){
        this.elements.collectionImages.innerHTML = `<swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType.CollectionImages}" height="80%"></swym-storefront-layout-loader>`;
        this.elements.itemsContainer.innerHTML = `<swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType.WishlistListItem}" height="80%"></swym-storefront-layout-loader>`;
      }
    
      clearUI(){
        this.innerHTML = '';
      }
    
      openCollectionListView() {
        this.classList.add('swym-storefront-layout-show-collection-list');
      }
    
      closeCollectinListView() {
        this.classList.remove('swym-storefront-layout-show-collection-list');
        setTimeout(()=>{
          this.clearUI();
        },100);
      }
    
    }
    
    
    /**
     * SwymStorefrontLayoutActions - Custom Web Component
     *
     * This class extends `HTMLElement` to create and manage the UI for wishlist-related actions 
     * in the Swym Storefront Layout. It handles functionalities such as:
     *
     * - Displaying a modal-like action panel for managing wishlist items.
     * - Supporting different action types (e.g., adding an item to a collection).
     * - Rendering the UI dynamically based on the selected list or collection.
     * - Managing event listeners to update UI interactions seamlessly.
     *
     * Key Features:
     * - Renders a structured UI layout with an image, title, options, and action buttons.
     * - Supports selecting collections and dynamically updates the UI upon selection.
     * - Implements event handling for collection management, including adding new collections.
     * - Uses `SwymStorefrontLayoutContext` for accessing relevant wishlist and collection data.
     *
     * Usage:
     * - This component is initialized automatically when added to the DOM.
     * - Data can be set via `setData({ listId, list, item, selectedVariantId, collections, actionType })`.
     * - Internal methods like `renderAddToCollection()` handle specific UI updates.
     *
     * Example:
     * ```html
     * <swym-storefront-layout-actions></swym-storefront-layout-actions>
     * ```
     *
     * Dependencies:
     * - Requires `SwymStorefrontLayoutContext` for accessing wishlist and collection data.
     * - Uses event listeners for handling user interactions.
     *
     * Notes:
     * - Ensures smooth UI updates with proper event handling and DOM manipulations.
     * - Uses query selectors to manage DOM elements efficiently.
     */
    class SwymStorefrontLayoutActions extends HTMLElement {
      constructor() {
        super();
    
        this.actionType = SwymStorefrontLayoutContext?.ActionTypes.ManageListItem;
    
        this.wishlistItem = null;
        this.collections = null;
        this.listId = null;
        this.list = null;
        this.selectedCollectionLid = null;
        this.selectedList = null;
        this.renderUI();
        this.elements = {
          container: this.querySelector('.swym-storefront-layout-actions-container'),
          backdrop: this.querySelector('.swym-storefront-layout-action-backdrop'),
          closeButton: this.querySelector('.swym-storefront-layout-action-close-button'),
          title: this.querySelector('.swym-storefront-layout-action-title-container'),
          optionsContainer: this.querySelector('#swym-storefront-layout-action-options'),
          actionContianer: this.querySelector('#swym-storefront-layout-action-container'),
          wishlistItemsContainer: document.querySelector('swym-storefront-layout-wishlist-container #swym-storefront-layout-items-container'),
          sflItemsContainer: document.querySelector('swym-storefront-layout-sfl-container #swym-storefront-layout-items-container'),
          imageContainer: this.querySelector('.swym-storefront-layout-action-image-container')
        }
        this.addEventListenerToView();
      }
    
      renderUI() {
        this.innerHTML = `
        <div class="swym-storefront-layout-actions-container">
          <div class="swym-storefront-layout-action-backdrop"></div>
          <div class="swym-storefront-layout-action-layout">
            <div class="swym-storefront-layout-action-image-container"></div>
            <div class="swym-storefront-layout-action-content">
              <div class="swym-storefront-layout-action-header">
                <div class="swym-storefront-layout-action-title-container"></div>
                <button type="button" aria-label="${SwymStorefrontLayoutContext?.Strings?.closeDrawer || 'Close'}" class="swym-storefront-layout-action-close-button">
                  <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
                    <path d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" fill="white"/>
                    <path d="M13.9697 15.0303C14.2626 15.3232 14.7374 15.3232 15.0303 15.0303C15.3232 14.7374 15.3232 14.2626 15.0303 13.9697L11.0607 10L15.0303 6.03033C15.3232 5.73744 15.3232 5.26256 15.0303 4.96967C14.7374 4.67678 14.2626 4.67678 13.9697 4.96967L10 8.93934L6.03033 4.96967C5.73744 4.67678 5.26256 4.67678 4.96967 4.96967C4.67678 5.26256 4.67678 5.73744 4.96967 6.03033L8.93934 10L4.96967 13.9697C4.67678 14.2626 4.67678 14.7374 4.96967 15.0303C5.26256 15.3232 5.73744 15.3232 6.03033 15.0303L10 11.0607L13.9697 15.0303Z" fill="currentColor"/>
                  </svg>
                </button>
              </div>
              <div id="swym-storefront-layout-action-options"></div>
              <div id="swym-storefront-layout-action-container"></div>
            </div>
          </div>
        </div>
        `
      }
    
      setData({ listId, list, item, selectedVariantId, collections, actionType = SwymStorefrontLayoutContext?.ActionTypes.ManageListItem, canCreateLists = true }) {
        this.listId = listId;
        this.list = list;
        this.wishlistItem = item;
        this.collections = SwymStorefrontLayoutContext?.collections;
        this.currentSlectedVariantId = selectedVariantId;
        this.selectedCollectionLid = this.collections[0]?.lid;
        this.selectedList = this.collections[0] || null;
        this.canCreateLists = canCreateLists;
        this.actionType = actionType;
        this.elements.wishlistItemsContainer = document.querySelector(`.swym-storefront-layout-items-container[data-lid="${listId}"]`);
        this.elements.actionContianer.innerHTML = '';
        if (actionType === SwymStorefrontLayoutContext?.ActionTypes.AddToCollection) {
          this.renderAddToCollection();
        } else if (actionType === SwymStorefrontLayoutContext?.ActionTypes.CreateCollection) {
          this.renderCreateCollectionOnly();
        }
        SwymStorefrontLayoutExtensions?.checkContainerScrollbar(this.elements.optionsContainer);
      }

      renderCreateCollectionOnly() {
        this.elements.imageContainer.innerHTML = '';
        this.elements.imageContainer.style.display = 'none';
        this.elements.title.innerHTML = `
          <div class="swym-storefront-layout-action-addtocollection-title">
            <div class="swym-storefront-layout-action-title">${SwymStorefrontLayoutContext?.Strings?.createCollectionCta}</div>
          </div>
        `;
        this.elements.optionsContainer.innerHTML = '';
        this.newlyCheckedLids = [];
        this.newlyUncheckedLids = [];
        this.selectedCollectionLid = null;
        this.renderCreteCollectionAction();
      }

      async renderAddToCollection() {
        this.collections = SwymStorefrontLayoutContext?.collections || [];
        if (this.collections && this.elements.optionsContainer) {
    
          if (this.wishlistItem.iu) {
            this.elements.imageContainer.innerHTML = `<img src="${this.wishlistItem.iu}" alt="${swymEscAttr(this.wishlistItem.dt) || 'Product image'}">`;
            this.elements.imageContainer.style.display = '';
          } else {
            this.elements.imageContainer.innerHTML = '';
            this.elements.imageContainer.style.display = 'none';
          }
          
          this.elements.title.innerHTML = `
            <div class="swym-storefront-layout-action-addtocollection-title">
              <div class="swym-storefront-layout-action-product-title">${this.wishlistItem.dt}</div>
              <div class="swym-storefront-layout-action-title">${SwymStorefrontLayoutContext?.Strings?.addToCollectionTitle}</div>
            </div>
          `
          this.renderCollectionOptions();
          this.renderCreteCollectionAction()
        }
      }
    
      renderCollectionOptions(){
        this.elements.optionsContainer.innerHTML = `
            ${this.collections.map((collection) => {
    
            let { lid, lname, listcontents } = collection;
            let item = listcontents[0];
            let count = listcontents.length;
    
            // Check if current product exists in this collection
            const productExists = listcontents.some(listItem => 
                listItem.epi === this.wishlistItem.epi
            );
    
            const primaryItem = listcontents[0];
            const listImagesHtml = `
                <div class="swym-storefront-layout-action-collection-item-image-primary">
                  ${primaryItem?.iu ? `<img src="${primaryItem.iu}" alt="${swymEscAttr(primaryItem?.dt) || ''}" class="swym-storefront-layout-action-collection-item-image" />` : `<div class="swym-storefront-layout-action-collection-item-image" ></div>`}
                </div>
              `;
    
            return `
                <div class="swym-storefront-layout-collection-action-btn add-item-to-collection swym-storefront-layout-action-collection-item-container" data-lid="${lid}">
                  <div class="swym-storefront-layout-action-collection-image-container">
                    ${listImagesHtml}
                  </div>
                  <div class="swym-storefront-layout-action-collection-content">
                    <div class="swym-storefront-layout-action-collection-item-name">${lname}</div>
                    <div class="swym-storefront-layout-action-collection-item-count">${count} ${count === 1 ? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items}</div>
                  </div>
                  <div class="swym-storefront-layout-checkbox-container">
                    <label class="swym-storefront-layout-checkbox">
                      <input type="checkbox" ${productExists ? 'checked' : ''} name="swym-storefront-layout-collections">
                      <span class="swym-storefront-layout-checkmark"></span>
                    </label>
                  </div>
                </div>
              `
          }).join('')}
          `;
    
          this.addMangeCollectionEventListeners();
      }
    
      addMangeCollectionEventListeners() {
        // Track initial checkbox states
        this.initialCheckStates = new Map();
        this.newlyCheckedLids = [];    // Declare at class level
        this.newlyUncheckedLids = [] // Array for newly unchecked lids
        
        this.collections.forEach((collection) => {
          const collectionItem = this.querySelector(`[data-lid="${collection.lid}"]`);
          const checkbox = collectionItem?.querySelector('input[type="checkbox"]');
          
          // Store initial checked state
          if (checkbox) {
            this.initialCheckStates.set(collection.lid, checkbox.checked);
          }
    
          // Add event listener specifically for the checkbox
          collectionItem?.addEventListener("click", async (event) => {
            event.preventDefault();
            event.stopPropagation();
    
            // Toggle checkbox
            if (checkbox) {
              checkbox.checked = !checkbox.checked;
            }
            
            const collectionSaveButton = this.querySelector('#swym-storefront-layout-save-collection-list-button');
            // Clear arrays on each click
            this.newlyCheckedLids = [];
            this.newlyUncheckedLids = [];
    
            const collectionNameInput = this.querySelector('#swym-storefront-layout-create-collection-name-input');
    
            this.collections.forEach(col => {
              const item = this.querySelector(`[data-lid="${col.lid}"]`);
              const cb = item?.querySelector('input[type="checkbox"]');
              if (cb) {
                const wasChecked = this.initialCheckStates.get(col.lid);
                const isNowChecked = cb.checked;
                
                if (!wasChecked && isNowChecked) {
                    this.newlyCheckedLids.push(col.lid);
                }
                if (wasChecked && !isNowChecked) {
                    this.newlyUncheckedLids.push(col.lid);
                }
              }
            });
    
            // Enable button if there are any changes
            if (collectionSaveButton) {
              const hasChanges = this.newlyCheckedLids.length > 0 || this.newlyUncheckedLids.length > 0;
              collectionSaveButton.disabled = !hasChanges;      
              // Update button text based on changes
              if (hasChanges) {
                if (this.newlyUncheckedLids.length > 0 && this.newlyCheckedLids.length === 0) {
                    // Only unchecking existing items
                 if (!collectionNameInput.value.trim()) {
                        collectionSaveButton.textContent = SwymStorefrontLayoutContext?.Strings?.removeItemCta;
                    } else {
                        collectionSaveButton.textContent = SwymStorefrontLayoutContext?.Strings?.updateCollectionCta || "Update List";
                    }
                  } else if (this.newlyCheckedLids.length > 0 && this.newlyUncheckedLids.length === 0) {
                    // Only adding new items
                    collectionSaveButton.textContent = SwymStorefrontLayoutContext?.Strings?.addToCollectionCta || "Add to Collection";
                } else {
                    // Both adding and removing
                    collectionSaveButton.textContent = SwymStorefrontLayoutContext?.Strings?.updateCollectionCta || "Update List";
                }
              } else {
                if (collectionNameInput.value.trim() && collectionNameInput.value.trim().length >= 3) {
                  collectionSaveButton.textContent = SwymStorefrontLayoutContext?.Strings?.addToCollectionCta || "Add to Collection";
                  collectionSaveButton.disabled = false;
                }
              }
            }
            // Toggle selected class on the parent container
            collectionItem.classList.toggle('swym-storefront-layout-checkbox-selected');
            // Your existing logic for handling checkbox state
          });
          // Prevent checkbox from triggering twice
          checkbox?.addEventListener('click', (event) => {
              event.stopPropagation();
          });
        });
      }
    
      renderCreteCollectionAction(){
        // Render save button always, but only show create collection input if user can create new lists
        this.elements.actionContianer.innerHTML = `
            <form id="swym-storefront-layout-create-collection-form">
              ${this.canCreateLists ? `
              <div class="swym-storefront-layout-create-collection-name-form-group">
                <input
                  type="text"
                  id="swym-storefront-layout-create-collection-name-input"
                  class="swym-storefront-layout-action-input create-collection-name-input"
                  placeholder="${SwymStorefrontLayoutContext?.Strings?.createCollectionCta}"
                />
                ${this.actionType !== SwymStorefrontLayoutContext?.ActionTypes.CreateCollection ? `
                <div class="swym-storefront-layout-checkbox-container">
                  <label class="swym-storefront-layout-checkbox">
                    <input type="checkbox" ${this.selectedCollectionLid === 'fromInput'?'checked':''} name="swym-storefront-layout-collections">
                    <span class="swym-storefront-layout-checkmark"></span>
                  </label>
                </div>
                ` : ''}
                <div id="swym-storefront-layout-create-collection-error-message-container" class="error-message" style="display: none;">
                  <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="base-icon error-icon" aria-hidden="true"><path d="M7 .7a6.3 6.3 0 1 0 0 12.6A6.3 6.3 0 0 0 7 .7Zm.7 9.8H6.3V9.1h1.4v1.4Zm0-2.1H6.3V3.5h1.4v4.9Z" fill="currentColor"></path></svg>
                  <span id="swym-storefront-layout-create-collection-error-message">Name is required</span>
                </div>
              </div>
              ` : ''}
              <button type="submit" id="swym-storefront-layout-save-collection-list-button" class="swym-storefront-layout-save-collection-list-button" disabled>${this.actionType === SwymStorefrontLayoutContext?.ActionTypes.CreateCollection ? SwymStorefrontLayoutContext?.Strings?.createCollectionCta : SwymStorefrontLayoutContext?.Strings?.addToCollectionCta}</button>
            </form>
          `;
          this.addCreateCollectionEventListeners();
      }
    
      addCreateCollectionEventListeners() {
        const createCollectionForm = this.querySelector('#swym-storefront-layout-create-collection-form');
        const collectionNameInputContainer = this.querySelector('.swym-storefront-layout-create-collection-name-form-group');
        const collectionNameInput = this.querySelector('#swym-storefront-layout-create-collection-name-input');
    
        // Only add input-specific listeners if the input exists (when canCreateLists is true)
        if (collectionNameInput) {
          collectionNameInput.addEventListener("focus", () => {
            this.selectedCollectionLid = 'fromInput';
            this.validateCollectionInputField(false);
          });
          
          collectionNameInput.addEventListener("blur", () => {
            if (!collectionNameInput.value.trim()) {
              const errorMessageContainer = this.querySelector('#swym-storefront-layout-create-collection-error-message-container');
              const errorMessage = this.querySelector('#swym-storefront-layout-create-collection-error-message');
              
              // Hide error message
              errorMessage.innerHTML = '';
              errorMessageContainer.style.display = 'none';
              collectionNameInput.classList.remove('swym-storefront-layout-input-has-error');
            }
          });
    
          collectionNameInput.addEventListener('input', () => {
            this.validateCollectionInputField();
          });
          
          // auto focus create collection input by default when no collection available
          // Small delay ensures the input is focusable after the dialog/DOM finishes rendering.
          const COLLECTION_INPUT_FOCUS_DELAY_MS = 50;
          if(!this.collections?.length){
            setTimeout(() => {
              collectionNameInput?.focus();
            }, COLLECTION_INPUT_FOCUS_DELAY_MS);
          }
        }
    
        // Always add form submit listener (works whether input exists or not)
        createCollectionForm?.addEventListener('submit', async (event) => {
          event.preventDefault();

          if (this.actionType === SwymStorefrontLayoutContext?.ActionTypes.CreateCollection) {
            try {
              const name = collectionNameInput.value.trim();
              if (name.length < 3) return;
              const newList = await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.createList(name);
              newList.listcontents = newList.listcontents || [];
              SwymStorefrontLayoutContext.collections = [...(SwymStorefrontLayoutContext.collections || []), newList];
              if (SwymStorefrontLayoutContext.allLists) {
                SwymStorefrontLayoutContext.allLists = [...SwymStorefrontLayoutContext.allLists, newList];
              }
              this.closeDrawer();
              if (SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched) {
                document.dispatchEvent(new CustomEvent(SwymStorefrontLayoutContext.CustomEvents.WishlistFetched, {
                  detail: {
                    defaultList: SwymStorefrontLayoutContext.DefaultList,
                    collections: SwymStorefrontLayoutContext.collections,
                    lists: SwymStorefrontLayoutContext.lists
                  }
                }));
              }
              SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionSaved,
                status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration
              });
            } catch (error) {
              window._swat?.utils.error('Error creating list', error);
            }
            return;
          }

          try {
            let listIdToAdd;
            if(this.selectedCollectionLid === 'fromInput' && collectionNameInput.value.length >= 3){
              let name = collectionNameInput.value.trim();
              let newList = await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.createList(name);
              listIdToAdd = newList.lid;
              this.newlyCheckedLids.push(listIdToAdd);
              this.selectedList = newList;
            } 
            let { epi, empi, du, iu } = this.wishlistItem;
    
             // Check if item is being moved from default list
            // Check if item exists in default list
            const isInDefaultList = SwymStorefrontLayoutContext?.DefaultList?.listcontents.some(
              item => item.epi === epi && item.empi === empi
            );
            // If item is from the SFY list, remove it from there when adding to a collection
            const sfyList = SwymStorefrontLayoutContext.getSfyList();
            if (sfyList && this.listId === sfyList.lid) {
              this.newlyUncheckedLids.push(sfyList.lid);
            }
            if(this.newlyCheckedLids.length >  0 && this.newlyUncheckedLids.length > 0) {
             SwymStorefrontLayoutContext.CommonAddtoWL = true; 
             SwymStorefrontLayoutContext.CommonRemovefromWL = true;
            }
            this.closeDrawer();
    
            if(this.newlyCheckedLids.length > 0) {
              // Add to new lists
              SwymStorefrontLayoutContext.CommonAddtoWL = true; 
               if(isInDefaultList) {
                SwymStorefrontLayoutContext.CommonRemovefromWL = true; 
                this.newlyUncheckedLids.push(SwymStorefrontLayoutContext?.DefaultList?.lid); 
              }
              await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.addProductToLists(
                { empi, epi, du }, 
                this.newlyCheckedLids
              );
            }
            // Handle unchecked lists (except default list)
            if(this.newlyUncheckedLids.length > 0) {
              SwymStorefrontLayoutContext.CommonRemovefromWL = true;
              await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromLists(
                { empi, epi, du },
                this.newlyUncheckedLids
              );
            }
            // Show notification
            if(this.newlyCheckedLids.length > 0 && this.newlyUncheckedLids.length > 0) {
              SwymStorefrontLayoutExtensions?.Notification?.setMessage({
                title: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionUpdated,
                message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionUpdated,
                status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
                actionType: "",
                duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
                product: this.wishlistItem,
                image: iu,
                action: {
                  label:  SwymStorefrontLayoutContext?.Strings?.notificationActionView,
                  onClick: () => {
                    _swat.ui.open();
                  },
                }
              },{
                showActionButton: true,
                showTitle: false,
                showProgress: true
              });   
              SwymStorefrontLayoutContext.CommonAddtoWL = false;
              SwymStorefrontLayoutContext.CommonRemovefromWL = false;  
            }
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutCollectionCreated, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCollectionInteractions });
          } catch (error) {
            window._swat?.utils.error('Error on create and add product to list', error);
          }
        }); 
      }
    
      validateCollectionInputField(showError = true){
    
        const collectionNameInput = this.querySelector('#swym-storefront-layout-create-collection-name-input');
        const collectionSaveButton = this.querySelector('#swym-storefront-layout-save-collection-list-button');
        const errorMessageContainer = this.querySelector('#swym-storefront-layout-create-collection-error-message-container');
        const errorMessage = this.querySelector('#swym-storefront-layout-create-collection-error-message');
        const checkbox = collectionNameInput.closest('.swym-storefront-layout-create-collection-name-form-group')?.querySelector('input[type="checkbox"]');
    
        let name = collectionNameInput.value.trim();
        let error;
    
        let isNameExist = this.collections.some(collection => collection.lname.toLowerCase() === name.toLowerCase());
    
        // Check if there are any newly checked or unchecked items
        const hasChanges = this.newlyCheckedLids.length > 0 || this.newlyUncheckedLids.length > 0;
    
        if (name === '') {
          error = SwymStorefrontLayoutContext?.Strings?.errorMessageListNameRequired;
          if (checkbox) checkbox.checked = false;
          if (this.selectedCollectionLid === 'fromInput') {
            this.selectedCollectionLid = null;
          }
        } else if (name.length < 3) {
          error = SwymStorefrontLayoutContext?.Strings?.errorMessageListNameRequire3Char;
          if (checkbox) checkbox.checked = false;
            if (this.selectedCollectionLid === 'fromInput') {
            this.selectedCollectionLid = null;
          }
        }else if(isNameExist){
          error = SwymStorefrontLayoutContext?.Strings?.errorMessageListNameAlreadyExist;
          if (checkbox) checkbox.checked = false;
          if (this.selectedCollectionLid === 'fromInput') {
            this.selectedCollectionLid = null;
          }
        }
    
        if (name.length > 0) {
          collectionNameInput.classList.add('swym-storefront-layout-input-has-value');
        } else {
          collectionNameInput.classList.remove('swym-storefront-layout-input-has-value');
        }
    
        if (error) {
          if(showError){
            errorMessage.innerHTML = error;
            errorMessageContainer.style.display = 'flex';
            collectionNameInput.classList.add('swym-storefront-layout-input-has-error');
          }
          // Only disable button if there are no other changes
          collectionSaveButton.disabled = !hasChanges;
        } else {
          errorMessage.innerHTML = '';
          errorMessageContainer.style.display = 'none';
          collectionSaveButton.disabled = false;
          collectionNameInput.classList.remove('swym-storefront-layout-input-has-error');
          // Auto check the checkbox when input is valid
          if (checkbox) checkbox.checked = true;
          this.selectedCollectionLid = 'fromInput';
          // Update button text
          collectionSaveButton.textContent = this.actionType === SwymStorefrontLayoutContext?.ActionTypes.CreateCollection ? SwymStorefrontLayoutContext?.Strings?.createCollectionCta : SwymStorefrontLayoutContext?.Strings?.addToCollectionCta;
        }
      }
    
      addEventListenerToView() {
        this.elements.backdrop.addEventListener('click', () => this.closeDrawer());
        this.elements.closeButton.addEventListener('click', () => this.closeDrawer());
      }
    
      openDrawer() {
        this.elements.container.classList.add('swym-storefront-layout-show-action-view');
      }
    
      closeDrawer() {
        this.elements.container.classList.remove('swym-storefront-layout-show-action-view');
      }
    
    }
    
    /**
     * SwymStorefrontLayoutActionTooltip
     * 
     * This custom Web Component manages the action tooltip for storefront layout interactions.
     * It provides UI options for managing wishlist items, including adding to collections 
     * and removing from lists. The tooltip dynamically updates based on user actions 
     * and permissions.
     * 
     * Features:
     * - Displays options based on the selected wishlist item.
     * - Supports adding/removing items from collections or lists.
     * - Listens for user interactions and updates the UI accordingly.
     * - Ensures smooth integration with SwymStorefrontLayoutContext?.
     * 
     * Dependencies:
     * - SwymStorefrontLayoutContext: Provides necessary context for actions and permissions.
     * - SwymStorefrontLayoutAPI: Handles wishlist operations.
     * - SwymStorefrontLayoutExtensions: Manages UI interactions like opening drawers.
     */
    class SwymStorefrontLayoutActionTooltip extends HTMLElement {
      constructor() {
        super();
    
        this.isTooltipOpen = false;
        this.currentTarget = null;
        this._tooltipKeydownController = null;
        this.actionType = SwymStorefrontLayoutContext?.ActionTypes.ManageListItem;
    
        this.listItem = null;
        this.collections = null;
        this.listId = null;
        this.list = null;
        this.renderUI();
        this.elements = {
          viewPortLayout: document.querySelector('.swym-storefront-layout-layout'),
          tooltipLayout: this.querySelector('.swym-storefront-layout-action-tooltip-layout'),
          optionsContainer: this.querySelector('#swym-storefront-layout-action-tooltip-options'),
          wishlistItemsContainer: document.querySelector('swym-storefront-layout-wishlist-container #swym-storefront-layout-items-container'),
          sflItemsContainer: document.querySelector('swym-storefront-layout-sfl-container #swym-storefront-layout-items-container')
        }
        this.addEventListenerToView();
      }
    
        renderUI() {
          this.innerHTML = `
        <div class="swym-storefront-layout-action-tooltip-layout">
          <div id="swym-storefront-layout-action-tooltip-options" tabindex="-1" aria-label="Wishlist options"></div>
        </div>
      `;
        }
    
      setData({ listId, list, item, selectedVariantId, collections, actionType = SwymStorefrontLayoutContext?.ActionTypes.ManageListItem, canCreateLists = true }) {
        this.listId = listId;
        this.list = list;
        this.listItem = item;
        this.collections = SwymStorefrontLayoutContext?.collections;
        this.currentSlectedVariantId = selectedVariantId;
        this.canCreateLists = canCreateLists;
        this.elements.wishlistItemsContainer = document.querySelector(`swym-storefront-layout-wishlist-container .swym-storefront-layout-items-container[data-lid="${listId}"]`)
        this.elements.sflItemsContainer = document.querySelector(`swym-storefront-layout-sfl-container .swym-storefront-layout-items-container[data-lid="${listId}"]`);
        this.elements.collectionItemsContainer = document.querySelector(`swym-storefront-layout-collection-list .swym-storefront-layout-items-container[data-lid="${listId}"]`);
        if (actionType === SwymStorefrontLayoutContext?.ActionTypes.ManageListItem) {
          this.renderWishlistItemOptions();
        }else if(actionType === SwymStorefrontLayoutContext?.ActionTypes.EditCollection){
          this.renderEditCollection();
        }else if(actionType === SwymStorefrontLayoutContext?.ActionTypes.SaveCollection){
          this.renderSaveCollection();
        }else if(actionType === SwymStorefrontLayoutContext?.ActionTypes.ManageSflListItem){
          this.renderSflListItemOptions();
        }else if(actionType === SwymStorefrontLayoutContext?.ActionTypes.ManageSfyListItem){
          this.renderSfyListItemOptions();
        } else if(actionType ===  SwymStorefrontLayoutContext?.ActionTypes.ShareSingleWishlist) {
          this.renderShareSingleWishlist();
        }
      }
    
      async renderWishlistItemOptions() {
        if (this.listItem && this.elements.optionsContainer) {
          let selectedVariantId = this.currentSlectedVariantId || this.listItem?.epi;
          const selectedVariant = SwymStorefrontLayoutContext?.getSelectedVariant(this.listItem, selectedVariantId);
          const productImage = selectedVariant?.featured_image?.src || this.listItem.productData?.featured_image || this.listItem.iu;
          let canEdit = SwymStorefrontLayoutContext?.checkUserCanEditList(this.list);
          
          // Get multi-wishlist configuration to determine if we should show "Add to list" option
          const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
    
          this.elements.optionsContainer.innerHTML = `
            ${shouldShowMultiple? `<div class="swym-storefront-layout-action-tooltip-btn add-to-collection-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.addToCollectionCta || 'Add to collection'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <path d="M7.33331 8.66683H3.33331V7.3335H7.33331V3.3335H8.66665V7.3335H12.6666V8.66683H8.66665V12.6668H7.33331V8.66683Z" fill="currentColor"/>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.addToCollectionCta}
            </div>` : ''}
            ${canEdit?`<div class="swym-storefront-layout-action-tooltip-btn remove-from-list-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove from list'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor" aria-hidden="true">
                <path d="M4.66669 14.5C4.30002 14.5 3.98613 14.3694 3.72502 14.1083C3.46391 13.8472 3.33335 13.5333 3.33335 13.1667V4.5H2.66669V3.16667H6.00002V2.5H10V3.16667H13.3334V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3334 14.5H4.66669ZM11.3334 4.5H4.66669V13.1667H11.3334V4.5ZM6.00002 11.8333H7.33335V5.83333H6.00002V11.8333ZM8.66669 11.8333H10V5.83333H8.66669V11.8333Z" fill="currentColor"></path>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove from list'}
            </div>`:''}
          `;
          this.addOptionEventListeners();
        }
      }
    
      async renderShareSingleWishlist() {
        // Check if user is logged in before showing share option
        const isLoggedIn = window._swat?.platform?.isLoggedIn();
        if(!isLoggedIn) {
          this.elements.optionsContainer.innerHTML = '';
          return;
        }
    
        if(this.elements.optionsContainer) {
                this.elements.optionsContainer.innerHTML = `<div class="swym-storefront-layout-action-tooltip-btn share-collection-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta || 'Share collection'}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
                      <path d="M9.91666 12.8337C9.43055 12.8337 9.01735 12.6635 8.67707 12.3232C8.3368 11.983 8.16666 11.5698 8.16666 11.0837C8.16666 11.0253 8.18124 10.8892 8.21041 10.6753L4.11249 8.28366C3.95693 8.42949 3.77707 8.54373 3.57291 8.62637C3.36874 8.70901 3.14999 8.75033 2.91666 8.75033C2.43055 8.75033 2.01735 8.58019 1.67707 8.23991C1.3368 7.89963 1.16666 7.48644 1.16666 7.00033C1.16666 6.51421 1.3368 6.10102 1.67707 5.76074C2.01735 5.42046 2.43055 5.25033 2.91666 5.25033C3.14999 5.25033 3.36874 5.29164 3.57291 5.37428C3.77707 5.45692 3.95693 5.57116 4.11249 5.71699L8.21041 3.32533C8.19096 3.25727 8.17881 3.19164 8.17395 3.12845C8.16909 3.06526 8.16666 2.99477 8.16666 2.91699C8.16666 2.43088 8.3368 2.01769 8.67707 1.67741C9.01735 1.33713 9.43055 1.16699 9.91666 1.16699C10.4028 1.16699 10.816 1.33713 11.1562 1.67741C11.4965 2.01769 11.6667 2.43088 11.6667 2.91699C11.6667 3.4031 11.4965 3.8163 11.1562 4.15658C10.816 4.49685 10.4028 4.66699 9.91666 4.66699C9.68332 4.66699 9.46457 4.62567 9.26041 4.54303C9.05624 4.46039 8.87638 4.34616 8.72082 4.20033L4.62291 6.59199C4.64235 6.66005 4.6545 6.72567 4.65936 6.78887C4.66423 6.85206 4.66666 6.92255 4.66666 7.00033C4.66666 7.0781 4.66423 7.14859 4.65936 7.21178C4.6545 7.27498 4.64235 7.3406 4.62291 7.40866L8.72082 9.80033C8.87638 9.65449 9.05624 9.54026 9.26041 9.45762C9.46457 9.37498 9.68332 9.33366 9.91666 9.33366C10.4028 9.33366 10.816 9.5038 11.1562 9.84408C11.4965 10.1844 11.6667 10.5975 11.6667 11.0837C11.6667 11.5698 11.4965 11.983 11.1562 12.3232C10.816 12.6635 10.4028 12.8337 9.91666 12.8337ZM9.91666 11.667C10.0819 11.667 10.2205 11.6111 10.3323 11.4993C10.4441 11.3875 10.5 11.2489 10.5 11.0837C10.5 10.9184 10.4441 10.7798 10.3323 10.668C10.2205 10.5562 10.0819 10.5003 9.91666 10.5003C9.75138 10.5003 9.61284 10.5562 9.50103 10.668C9.38923 10.7798 9.33332 10.9184 9.33332 11.0837C9.33332 11.2489 9.38923 11.3875 9.50103 11.4993C9.61284 11.6111 9.75138 11.667 9.91666 11.667ZM2.91666 7.58366C3.08193 7.58366 3.22048 7.52776 3.33228 7.41595C3.44409 7.30415 3.49999 7.1656 3.49999 7.00033C3.49999 6.83505 3.44409 6.69651 3.33228 6.5847C3.22048 6.4729 3.08193 6.41699 2.91666 6.41699C2.75138 6.41699 2.61284 6.4729 2.50103 6.5847C2.38923 6.69651 2.33332 6.83505 2.33332 7.00033C2.33332 7.1656 2.38923 7.30415 2.50103 7.41595C2.61284 7.52776 2.75138 7.58366 2.91666 7.58366ZM9.91666 3.50033C10.0819 3.50033 10.2205 3.44442 10.3323 3.33262C10.4441 3.22081 10.5 3.08227 10.5 2.91699C10.5 2.75171 10.4441 2.61317 10.3323 2.50137C10.2205 2.38956 10.0819 2.33366 9.91666 2.33366C9.75138 2.33366 9.61284 2.38956 9.50103 2.50137C9.38923 2.61317 9.33332 2.75171 9.33332 2.91699C9.33332 3.08227 9.38923 3.22081 9.50103 3.33262C9.61284 3.44442 9.75138 3.50033 9.91666 3.50033Z" fill="currentColor" fill-opacity="0.8"/>
                    </svg>
                    ${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta}
                  </div>`;
                  this.addEditCollectionEventListeners();
        }
      }
    
      async renderShareSFLWishlist() {
        // Check if user is logged in before showing share option
        const isLoggedIn = window._swat?.platform?.isLoggedIn();
        if(!isLoggedIn) {
          this.elements.optionsContainer.innerHTML = '';
          return;
        }
    
        if(this.elements.optionsContainer) {
          this.elements.optionsContainer.innerHTML = `<div class="swym-storefront-layout-action-tooltip-btn share-collection-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta || 'Share collection'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
                <path d="M9.91666 12.8337C9.43055 12.8337 9.01735 12.6635 8.67707 12.3232C8.3368 11.983 8.16666 11.5698 8.16666 11.0837C8.16666 11.0253 8.18124 10.8892 8.21041 10.6753L4.11249 8.28366C3.95693 8.42949 3.77707 8.54373 3.57291 8.62637C3.36874 8.70901 3.14999 8.75033 2.91666 8.75033C2.43055 8.75033 2.01735 8.58019 1.67707 8.23991C1.3368 7.89963 1.16666 7.48644 1.16666 7.00033C1.16666 6.51421 1.3368 6.10102 1.67707 5.76074C2.01735 5.42046 2.43055 5.25033 2.91666 5.25033C3.14999 5.25033 3.36874 5.29164 3.57291 5.37428C3.77707 5.45692 3.95693 5.57116 4.11249 5.71699L8.21041 3.32533C8.19096 3.25727 8.17881 3.19164 8.17395 3.12845C8.16909 3.06526 8.16666 2.99477 8.16666 2.91699C8.16666 2.43088 8.3368 2.01769 8.67707 1.67741C9.01735 1.33713 9.43055 1.16699 9.91666 1.16699C10.4028 1.16699 10.816 1.33713 11.1562 1.67741C11.4965 2.01769 11.6667 2.43088 11.6667 2.91699C11.6667 3.4031 11.4965 3.8163 11.1562 4.15658C10.816 4.49685 10.4028 4.66699 9.91666 4.66699C9.68332 4.66699 9.46457 4.62567 9.26041 4.54303C9.05624 4.46039 8.87638 4.34616 8.72082 4.20033L4.62291 6.59199C4.64235 6.66005 4.6545 6.72567 4.65936 6.78887C4.66423 6.85206 4.66666 6.92255 4.66666 7.00033C4.66666 7.0781 4.66423 7.14859 4.65936 7.21178C4.6545 7.27498 4.64235 7.3406 4.62291 7.40866L8.72082 9.80033C8.87638 9.65449 9.05624 9.54026 9.26041 9.45762C9.46457 9.37498 9.68332 9.33366 9.91666 9.33366C10.4028 9.33366 10.816 9.5038 11.1562 9.84408C11.4965 10.1844 11.6667 10.5975 11.6667 11.0837C11.6667 11.5698 11.4965 11.983 11.1562 12.3232C10.816 12.6635 10.4028 12.8337 9.91666 12.8337ZM9.91666 11.667C10.0819 11.667 10.2205 11.6111 10.3323 11.4993C10.4441 11.3875 10.5 11.2489 10.5 11.0837C10.5 10.9184 10.4441 10.7798 10.3323 10.668C10.2205 10.5562 10.0819 10.5003 9.91666 10.5003C9.75138 10.5003 9.61284 10.5562 9.50103 10.668C9.38923 10.7798 9.33332 10.9184 9.33332 11.0837C9.33332 11.2489 9.38923 11.3875 9.50103 11.4993C9.61284 11.6111 9.75138 11.667 9.91666 11.667ZM2.91666 7.58366C3.08193 7.58366 3.22048 7.52776 3.33228 7.41595C3.44409 7.30415 3.49999 7.1656 3.49999 7.00033C3.49999 6.83505 3.44409 6.69651 3.33228 6.5847C3.22048 6.4729 3.08193 6.41699 2.91666 6.41699C2.75138 6.41699 2.61284 6.4729 2.50103 6.5847C2.38923 6.69651 2.33332 6.83505 2.33332 7.00033C2.33332 7.1656 2.38923 7.30415 2.50103 7.41595C2.61284 7.52776 2.75138 7.58366 2.91666 7.58366ZM9.91666 3.50033C10.0819 3.50033 10.2205 3.44442 10.3323 3.33262C10.4441 3.22081 10.5 3.08227 10.5 2.91699C10.5 2.75171 10.4441 2.61317 10.3323 2.50137C10.2205 2.38956 10.0819 2.33366 9.91666 2.33366C9.75138 2.33366 9.61284 2.38956 9.50103 2.50137C9.38923 2.61317 9.33332 2.75171 9.33332 2.91699C9.33332 3.08227 9.38923 3.22081 9.50103 3.33262C9.61284 3.44442 9.75138 3.50033 9.91666 3.50033Z" fill="currentColor" fill-opacity="0.8"/>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta}
            </div>`;
            this.addShareSFLEventListeners();
        }
      }
    
      addEditCollectionEventListeners() {
        const shareCollectionBtn = this.querySelector('.share-collection-button');
        const deleteCollectionBtn = this.querySelector('.delete-list-button');
        this.listId = SwymStorefrontLayoutContext?.sflList?.lid;
        
        shareCollectionBtn?.addEventListener('click', () => {
          this.shareCollection();
        });
        
        // Keyboard support for share button
        shareCollectionBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.shareCollection();
          }
        });
        
        deleteCollectionBtn?.addEventListener('click', async () => {
          try {
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.deleteLists([this.list]);
            this.closeTooltip();
            window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List;
            SwymStorefrontLayoutExtensions?.refreshWishList();
            const collectionListView = document.querySelector('swym-storefront-layout-collection-list');
            collectionListView.closeCollectinListView();
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionDeleted,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
              iconType: SwymStorefrontLayoutContext?.NotificationIconType?.SuccessIcon
            });
    
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutCollectionDeleted, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCollectionInteractions });
    
          } catch (error) {
            window._swat?.utils.error('Failed to delete collection:', error);
          }
        });
        
        // Keyboard support for delete button
        deleteCollectionBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            deleteCollectionBtn.click();
          }
        });
      }
    
      addShareSFLEventListeners() {
        const shareCollectionBtn = this.querySelector('.share-collection-button');
        shareCollectionBtn?.addEventListener('click', () => {
          this.shareCollection(SwymStorefrontLayoutContext.sflList);
        });
        
        // Keyboard support for share button
        shareCollectionBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.shareCollection(SwymStorefrontLayoutContext.sflList);
          }
        });
      }
      
      addOptionEventListeners() {
        const addToCollectionBtn = this.querySelector('.add-to-collection-button');
        const removeFromListBtn = this.querySelector('.remove-from-list-button');
    
        addToCollectionBtn?.addEventListener('click', () => {
          this.closeTooltip();
          
          SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.setData({
            listId: this.listId,
            list: this.list,
            item: this.listItem,
            collections: this.collections,
            actionType: SwymStorefrontLayoutContext?.ActionTypes.AddToCollection,
            canCreateLists: this.canCreateLists
          });
          SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActions?.openDrawer();
    
        });
    
        removeFromListBtn?.addEventListener('click', async () => {
          try {
    
            this.closeTooltip();
    
            let { epi, empi, du } = this.listItem;
            if(this.currentSlectedVariantId){
              epi = this.currentSlectedVariantId;
            }
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, this.listId);
    
            // Try to find and remove the element from whichever container it's in
            let elementDeleted = this.elements.wishlistItemsContainer?.querySelector(`[data-epi="${epi}"]`) ||
                                this.elements.collectionItemsContainer?.querySelector(`[data-epi="${epi}"]`);
            elementDeleted?.remove();
    
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutItemRemovedFromList, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
    
          } catch (error) {
            window._swat?.utils.error('Failed to remove product from the list:', error);
          }
        });
      }
    
      async renderEditCollection() {
        if (this.list && this.elements.optionsContainer) {
          // Check if user is logged in before showing share option
          const isLoggedIn = window._swat?.platform?.isLoggedIn();
          
          const shareButton = isLoggedIn ? `
            <div class="swym-storefront-layout-action-tooltip-btn share-collection-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta || 'Share collection'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="currentColor" aria-hidden="true">
                <path d="M9.91666 12.8337C9.43055 12.8337 9.01735 12.6635 8.67707 12.3232C8.3368 11.983 8.16666 11.5698 8.16666 11.0837C8.16666 11.0253 8.18124 10.8892 8.21041 10.6753L4.11249 8.28366C3.95693 8.42949 3.77707 8.54373 3.57291 8.62637C3.36874 8.70901 3.14999 8.75033 2.91666 8.75033C2.43055 8.75033 2.01735 8.58019 1.67707 8.23991C1.3368 7.89963 1.16666 7.48644 1.16666 7.00033C1.16666 6.51421 1.3368 6.10102 1.67707 5.76074C2.01735 5.42046 2.43055 5.25033 2.91666 5.25033C3.14999 5.25033 3.36874 5.29164 3.57291 5.37428C3.77707 5.45692 3.95693 5.57116 4.11249 5.71699L8.21041 3.32533C8.19096 3.25727 8.17881 3.19164 8.17395 3.12845C8.16909 3.06526 8.16666 2.99477 8.16666 2.91699C8.16666 2.43088 8.3368 2.01769 8.67707 1.67741C9.01735 1.33713 9.43055 1.16699 9.91666 1.16699C10.4028 1.16699 10.816 1.33713 11.1562 1.67741C11.4965 2.01769 11.6667 2.43088 11.6667 2.91699C11.6667 3.4031 11.4965 3.8163 11.1562 4.15658C10.816 4.49685 10.4028 4.66699 9.91666 4.66699C9.68332 4.66699 9.46457 4.62567 9.26041 4.54303C9.05624 4.46039 8.87638 4.34616 8.72082 4.20033L4.62291 6.59199C4.64235 6.66005 4.6545 6.72567 4.65936 6.78887C4.66423 6.85206 4.66666 6.92255 4.66666 7.00033C4.66666 7.0781 4.66423 7.14859 4.65936 7.21178C4.6545 7.27498 4.64235 7.3406 4.62291 7.40866L8.72082 9.80033C8.87638 9.65449 9.05624 9.54026 9.26041 9.45762C9.46457 9.37498 9.68332 9.33366 9.91666 9.33366C10.4028 9.33366 10.816 9.5038 11.1562 9.84408C11.4965 10.1844 11.6667 10.5975 11.6667 11.0837C11.6667 11.5698 11.4965 11.983 11.1562 12.3232C10.816 12.6635 10.4028 12.8337 9.91666 12.8337ZM9.91666 11.667C10.0819 11.667 10.2205 11.6111 10.3323 11.4993C10.4441 11.3875 10.5 11.2489 10.5 11.0837C10.5 10.9184 10.4441 10.7798 10.3323 10.668C10.2205 10.5562 10.0819 10.5003 9.91666 10.5003C9.75138 10.5003 9.61284 10.5562 9.50103 10.668C9.38923 10.7798 9.33332 10.9184 9.33332 11.0837C9.33332 11.2489 9.38923 11.3875 9.50103 11.4993C9.61284 11.6111 9.75138 11.667 9.91666 11.667ZM2.91666 7.58366C3.08193 7.58366 3.22048 7.52776 3.33228 7.41595C3.44409 7.30415 3.49999 7.1656 3.49999 7.00033C3.49999 6.83505 3.44409 6.69651 3.33228 6.5847C3.22048 6.4729 3.08193 6.41699 2.91666 6.41699C2.75138 6.41699 2.61284 6.4729 2.50103 6.5847C2.38923 6.69651 2.33332 6.83505 2.33332 7.00033C2.33332 7.1656 2.38923 7.30415 2.50103 7.41595C2.61284 7.52776 2.75138 7.58366 2.91666 7.58366ZM9.91666 3.50033C10.0819 3.50033 10.2205 3.44442 10.3323 3.33262C10.4441 3.22081 10.5 3.08227 10.5 2.91699C10.5 2.75171 10.4441 2.61317 10.3323 2.50137C10.2205 2.38956 10.0819 2.33366 9.91666 2.33366C9.75138 2.33366 9.61284 2.38956 9.50103 2.50137C9.38923 2.61317 9.33332 2.75171 9.33332 2.91699C9.33332 3.08227 9.38923 3.22081 9.50103 3.33262C9.61284 3.44442 9.75138 3.50033 9.91666 3.50033Z" fill="currentColor" fill-opacity="0.8"/>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.shareCollectionCta}
            </div>` : '';
    
          this.elements.optionsContainer.innerHTML = `
            ${shareButton}
            <div class="swym-storefront-layout-action-tooltip-btn delete-list-button" role="button" tabindex="0"        aria-label="${SwymStorefrontLayoutContext?.Strings?.deleteCollectionCta || 'Delete collection'}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor" aria-hidden="true">
                        <path d="M4.66667 14.5C4.3000114.5 3.98612 14.3694 3.72501 14.1083C3.46389 13.8472 3.33334 13.5333 3.33334 13.1667V4.5H2.66667V3.16667H6.00001V2.5H10V3.16667H13.3333V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3333 14.5H4.66667ZM11.3333 4.5H4.66667V13.1667H11.3333V4.5ZM6.00001 11.8333H7.33334V5.83333H6.00001V11.8333ZM8.66667 11.8333H10V5.83333H8.66667V11.8333Z" fill="currentColor"/>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.deleteCollectionCta}
            </div>
          `;
          this.addEditCollectionEventListeners();
        }
      }
    
      addEditCollectionEventListeners() {
        const shareCollectionBtn = this.querySelector('.share-collection-button');
        const deleteListBtn = this.querySelector('.delete-list-button');
    
        shareCollectionBtn?.addEventListener('click', () => {
          this.shareCollection();
          this.closeTooltip();
        });
        
        // Keyboard support for share button
        shareCollectionBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.shareCollection();
            this.closeTooltip();
          }
        });
    
        deleteListBtn?.addEventListener('click', async () => {
          try {
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.deleteLists([this.list]);
            this.closeTooltip();
            window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List;
            SwymStorefrontLayoutExtensions?.refreshWishList();
            const collectionListView = document.querySelector('swym-storefront-layout-collection-list');
            collectionListView.closeCollectinListView();
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionDeleted,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
              iconType: SwymStorefrontLayoutContext?.NotificationIconType?.SuccessIcon
            });
    
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutCollectionDeleted, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutCollectionInteractions });
    
          } catch (error) {
            window._swat?.utils.error('Failed to remove product from the list:', error);
          }
        });
        
        // Keyboard support for delete button
        deleteListBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            deleteListBtn.click();
          }
        });
      }
    
      async renderSaveCollection() {
        if (this.list && this.elements.optionsContainer) {
          this.elements.optionsContainer.innerHTML = `
            <div class="swym-storefront-layout-action-tooltip-btn save-collection-button" role="button" tabindex="0"        aria-label="${SwymStorefrontLayoutContext?.Strings?.saveCollectionCta || 'Save collection'}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12px" height="12px" viewBox="0 0 48 48" fill="none" aria-hidden="true">
                <path d="M8 28H24" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 37H24" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 19H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M8 10H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M30 33H40" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M35 28L35 38" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.saveCollectionCta}
            </div>
          `;
          this.addSaveCollectionEventListeners();
        }
      }
    
      addSaveCollectionEventListeners() {
        const saveCollectionBtn = this.querySelector('.save-collection-button');
        
        saveCollectionBtn?.addEventListener('click', () => {
          this.closeTooltip();
          this.handleSaveCollection();
        });
      }
      async shareCollection() {
        const activeTab = document.querySelector('.swym-storefront-layout-tab-button.swym-storefront-layout-tab-button-active');
        const activeDataView = activeTab?.getAttribute('data-view');
        window._swat.evtLayer.dispatchEvent(new CustomEvent('sw:renderShareWishlistUI', {
          detail: {
            lid: this.list?.lid || this.listId,
            lname: '',
            list: activeDataView === "tabSavedForLater" ? SwymStorefrontLayoutContext?.sflList : this.list,
            layoutType: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType,
            senderName: '', // optional,
            activeDataView
          }
        }));
      }
      
      async handleSaveCollection(){
        let savedList = await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.createList(this.list.lname);
        let itemsToAdd = this.list.listcontents.map(({ empi, epi, du }) => ({ empi, epi, du }));
        await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.addProductsToList(itemsToAdd, savedList.lid);
        window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.List;
        
        SwymStorefrontLayoutExtensions?.Notification?.setMessage({
          message: SwymStorefrontLayoutContext?.Strings?.notificationMessageCollectionSaved,
          status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Neutral,
          iconType: SwymStorefrontLayoutContext?.NotificationIconType?.SuccessIcon,
          duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
          action: {
            label: SwymStorefrontLayoutContext?.Strings?.notificationActionViewCollection,
            onClick: () => {
              window.location.hash = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList + savedList.lid;
            }
          }
        });
    
      }
    
      addEventListenerToView() {
        document.addEventListener("click", (event) => {
          if (!this.elements.tooltipLayout.contains(event.target)) {
            this.closeTooltip();
          }
        });
      }
    
      async renderSflListItemOptions(){
        if (this.listItem && this.elements.optionsContainer) {
          let selectedVariantId = this.currentSlectedVariantId || this.listItem?.epi;
          const selectedVariant = SwymStorefrontLayoutContext?.getSelectedVariant(this.listItem, selectedVariantId);
          let canEdit = SwymStorefrontLayoutContext?.checkUserCanEditList(this.list);
          this.elements.optionsContainer.innerHTML = `
            ${canEdit?`<div class="swym-storefront-layout-action-tooltip-btn remove-from-list-button" role="button" tabindex="0"        aria-label="${SwymStorefrontLayoutContext?.Strings?.removeSflItemCta || 'Remove from list'}">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor" aria-hidden="true">
                        <path d="M4.66669 14.5C4.30002 14.5 3.98613 14.3694 3.72502 14.1083C3.46391 13.8472 3.33335 13.5333 3.33335 13.1667V4.5H2.66669V3.16667H6.00002V2.5H10V3.16667H13.3334V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3334 14.5H4.66669ZM11.3334 4.5H4.66669V13.1667H11.3334V4.5ZM6.00002 11.8333H7.33335V5.83333H6.00002V11.8333ZM8.66669 11.8333H10V5.83333H8.66669V11.8333Z" fill="currentColor"></path>
                      </svg>
                      ${SwymStorefrontLayoutContext?.Strings?.removeSflItemCta || 'Remove from list'}
            </div>`:''}
          `;
          this.addSflOptionEventListeners();
        }
      }
    
      async renderSfyListItemOptions(){
        if (this.listItem && this.elements.optionsContainer) {
          this.elements.optionsContainer.innerHTML = `
            <div class="swym-storefront-layout-action-tooltip-btn swym-sfy-remove-button" role="button" tabindex="0" aria-label="${SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove'}">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="currentColor" aria-hidden="true">
                <path d="M4.66669 14.5C4.30002 14.5 3.98613 14.3694 3.72502 14.1083C3.46391 13.8472 3.33335 13.5333 3.33335 13.1667V4.5H2.66669V3.16667H6.00002V2.5H10V3.16667H13.3334V4.5H12.6667V13.1667C12.6667 13.5333 12.5361 13.8472 12.275 14.1083C12.0139 14.3694 11.7 14.5 11.3334 14.5H4.66669ZM11.3334 4.5H4.66669V13.1667H11.3334V4.5ZM6.00002 11.8333H7.33335V5.83333H6.00002V11.8333ZM8.66669 11.8333H10V5.83333H8.66669V11.8333Z" fill="currentColor"></path>
              </svg>
              ${SwymStorefrontLayoutContext?.Strings?.removeItemCta || 'Remove'}
            </div>
          `;
          this.addSfyOptionEventListeners();
        }
      }
    
      addSfyOptionEventListeners() {
        const removeBtn = this.querySelector('.swym-sfy-remove-button');
        removeBtn?.addEventListener('click', async () => {
          try {
            this.closeTooltip();
            const { epi, empi, du } = this.listItem;
            const lid = this.listId;
    
            // Remove item from ALL context references (String comparison for type safety)
            SwymStorefrontLayoutContext.updateAllListContents((listcontents = []) =>
              listcontents.filter(item => String(item.epi) !== String(epi))
            );
    
            // Dispatch WishlistFetched to update UI immediately
            if (SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched) {
              document.dispatchEvent(new CustomEvent(SwymStorefrontLayoutContext.CustomEvents.WishlistFetched, {
                detail: {
                  defaultList: SwymStorefrontLayoutContext.DefaultList,
                  collections: SwymStorefrontLayoutContext.collections,
                  lists: SwymStorefrontLayoutContext.lists
                }
              }));
            }
    
            SwymStorefrontLayoutExtensions?.Notification?.setMessage({
              message: SwymStorefrontLayoutContext?.Strings?.notificationMessageItemRemoved,
              status: SwymStorefrontLayoutContext?.NotificationStatusTypes?.Toast,
              duration: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutNotificationDuration,
              image: this.listItem?.iu
            });
    
            // Fire API THEN refresh to reconcile with server
            await SwymStorefrontLayoutAPI?.SwymWLAsyncApis?.removeProductFromList({ epi, empi, du }, lid);
            SwymStorefrontLayoutExtensions?.refreshWishList();
            window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYItemRemoved, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutItemInteractions, epi, empi });
          } catch (err) {
            window._swat?.utils.error('[SFY] Remove failed', err);
          }
        });
        removeBtn?.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            removeBtn.click();
          }
        });
      }
    
      addSflOptionEventListeners() {
        const removeFromListBtn = this.querySelector('.remove-from-list-button');
    
        removeFromListBtn?.addEventListener('click', async () => {
          try {
    
            this.closeTooltip();
    
            let { epi, empi, du } = this.listItem;
            if(this.currentSlectedVariantId){
              epi = this.currentSlectedVariantId;
            }
            await SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.removeProductFromSFL({ epi, empi, du }, this.listId);
    
            let elementDeleted = this.elements.sflItemsContainer?.querySelector(`[data-epi="${epi}"]`);
            elementDeleted?.remove();
    
            window._swat?.triggerSwymEvent(window._swat?.JSEvents?.removedFromSFL, this.listItem);
    
          } catch (error) {
            window._swat?.utils.error('Failed to remove product from the list:', error);
          }
        });
      }
    
      attachEventToHideTooltip(){
    
        window.removeEventListener("scroll", ()=> this.closeTooltip());
        window.addEventListener("scroll", ()=> this.closeTooltip());
    
        let scrollableElements = document.querySelectorAll('.swym-storefront-layout-scrollable');
    
        scrollableElements.forEach((element) => {
          element.removeEventListener("scroll", ()=> this.closeTooltip());
          element.addEventListener("scroll", ()=> this.closeTooltip());
        });
      }
    
        openTooltip() {
          this.isTooltipOpen = true;
          this._closedViaKeyboard = false;
          const tl = this.elements.tooltipLayout;
    
          // Abort any previous keydown listener to prevent accumulation
          if (this._tooltipKeydownController) {
            this._tooltipKeydownController.abort();
          }
          this._tooltipKeydownController = new AbortController();
    
          tl.classList.add("swym-storefront-layout-show-action-tooltip-view");
          tl.setAttribute("role", "dialog");
          tl.setAttribute("aria-label", "Wishlist options");
          tl.setAttribute("aria-hidden", "false");
          tl.setAttribute("tabindex", "-1");
    
          const firstBtn = this.elements.optionsContainer?.querySelector('.swym-storefront-layout-action-tooltip-btn');
          if (firstBtn) {
            firstBtn.focus();
          } else {
            tl.focus();
          }
    
          tl.addEventListener(
            "keydown",
            (e) => {
              if (["Enter", " "].includes(e.key)) {
                const activeBtn = document.activeElement?.closest('[role="button"]');
                if (activeBtn && tl.contains(activeBtn)) {
                  e.preventDefault();
                  activeBtn.click();
                }
              }
              if (e.key === "Escape") {
                e.preventDefault();
                this._closedViaKeyboard = true;
                this.closeTooltip();
              }
            },
            { signal: this._tooltipKeydownController.signal }
          );
    
          this.attachEventToHideTooltip();
        }
    
      showOnTarget(buttonTarget){
        this.closeTooltip();
    
        let viewPort = document.querySelector('.swym-storefront-layout-layout');
    
        const tooltip = this.elements.tooltipLayout;
        let buttonRect = buttonTarget.getBoundingClientRect();
        let viewPortRect = viewPort?.getBoundingClientRect();
    
        const buttonRight = buttonRect.right;
        const buttonLeft = buttonRect.left;
        const buttonLeftOnViewPort = buttonRect.left - viewPortRect?.left;
    
        const tooltipWidth = this.elements.tooltipLayout.offsetWidth
        const viewportWidth = viewPort.clientWidth
    
    
        if (buttonLeftOnViewPort > viewportWidth / 2) {
          tooltip.style.left = `${(buttonLeft + 2) - tooltipWidth}px`
          tooltip.style.top = `${buttonRect.top + 25}px`
        } else {
          tooltip.style.left = `${buttonLeft + 2 }px`
          tooltip.style.top = `${buttonRect.top + 25}px`
        }
    
        setTimeout(()=>{
          this.openTooltip();
          this.currentTarget = buttonTarget;
        },100)
    
      }
    
      closeTooltip() {
        this.isTooltipOpen = false;
        const tl = this.elements.tooltipLayout;
        tl.classList.remove('swym-storefront-layout-show-action-tooltip-view');
        tl.setAttribute("aria-hidden", "true");
        tl.removeAttribute("role");
        tl.removeAttribute("aria-label");
        if (this._tooltipKeydownController) {
          this._tooltipKeydownController.abort();
          this._tooltipKeydownController = null;
        }
        if (this._closedViaKeyboard && this.currentTarget) {
          this.currentTarget.focus();
        }
        this._closedViaKeyboard = false;
      }
    
    }
    
    /**
     * SwymStorefrontLayoutNotification
     * 
     * A Web Component for displaying notifications in the storefront layout. 
     * It supports customizable configurations, auto-hide functionality, 
     * and dynamic content rendering based on user actions.
     * 
     * Features:
     * - Supports various notification types (success, info, etc.).
     * - Configurable options for displaying images, titles, messages, and action buttons.
     * - Auto-hide functionality with configurable duration.
     * - Supports icons and images based on notification type.
     * - Integrates with `SwymStorefrontLayoutContext?.Settings` to check if notifications are enabled.
     * 
     * Dependencies:
     * - `SwymStorefrontLayoutContext`: Provides settings and icon type references.
     * 
     * Usage:
     * ```html
     * <swym-storefront-layout-notification></swym-storefront-layout-notification>
     * ```
     * 
     * Example JavaScript Usage:
     * ```javascript
     * const notification = document.querySelector('swym-storefront-layout-notification');
     * notification.setMessage({
     *   message: 'Item added to wishlist!',
     *   status: 'success',
     *   duration: 4000,
     *   image: 'https://example.com/image.jpg',
     *   action: {
     *     label: 'View Wishlist',
     *     onClick: () => console.log('Wishlist opened')
     *   }
     * });
     * ```
     * 
     * Attributes:
     * - `status` (String) - Defines the notification status (e.g., `success`, `info`, `error`).
     * - `role` (String) - Defaults to `"alert"` for accessibility.
     * 
     * Methods:
     * - `setMessage(data, config)`: Sets notification content and displays it.
     * - `setNotificationConfig(config)`: Merges user-defined configuration with defaults.
     * - `renderUI()`: Updates the UI based on the provided notification data.
     * - `autoHide(duration)`: Automatically hides the notification after a specified duration.
     * - `showNotification()`: Displays the notification.
     * - `hideNotification()`: Hides the notification.
     * 
     * Events:
     * - `click` on `.swym-storefront-layout-notification-action` triggers the provided action callback.
     */
    class SwymStorefrontLayoutNotification extends HTMLElement {
      constructor() {
        super();
        this.timeout = null;
        this.notificationData = null;
        this.defaultConfig = {
          showProgress: false,
          showImage: true,
          showActionButton: false,
          showMessage: true,
          showTitle: false
        };
    
        this.notificationConfig = this.defaultConfig;
      }
    
      connectedCallback() {
        this.setAttribute('role', this.getAttribute('role') || 'alert');
        this.setAttribute('status', this.getAttribute('status') || 'info');
      }
    
      setMessage(data, config = {}) {
        // Login nudge is intentionally persistent — suppress transient toasts while it is visible.
        // Pass config.priority = 'high' (e.g. errors) to break through and dismiss the nudge.
        if (this.hasAttribute('data-nudge-active')) {
          if (config.priority !== 'high') return;
          this.removeAttribute('data-nudge-active');
        }
        const {
          actionType, message, title, status = 'success', duration = 3000, action, image, product, icon, iconType
        } = data;
        
        this.notificationData = {
          actionType, message, status, duration, action, image, product, icon, iconType,
          title: title || product?.dt || null
        };
        
        if (SwymStorefrontLayoutContext?.Settings?.EnableStorefrontLayoutNotification) {
          this.setAttribute('status', status);
          this.setNotificationConfig(config);
          this.renderUI();
          this.autoHide(duration);
        }
      }
    
      setNotificationConfig(config) {
        this.notificationConfig = { ...this.defaultConfig, ...config };
      }
    
      renderUI() {
        if (!this.notificationData) return;
        
        const { message, image, iconType, title, action } = this.notificationData;
        const { showProgress, showImage, showActionButton, showMessage, showTitle } = this.notificationConfig;
        
        this.innerHTML = `
          ${showProgress ? '<div class="swym-storefront-layout-notification-progress-bar swym-storefront-notification-animated"></div>' : ''}
          <div class="swym-storefront-layout-notification-container">
            <div class="swym-storefront-layout-notification-content-container"> 
              ${showImage && (image || iconType) ?`<div class="swym-storefront-layout-notification-image-container">
                ${ image ? `<img class="swym-storefront-layout-notification-image" src="${image}" alt="Notification Icon">` : ''}
                ${iconType ? this.getIconHtml(iconType) : ''}
              </div>`:''}
              <div class="swym-storefront-layout-notification-content">
                ${showTitle && title ? `<div class="swym-storefront-layout-notification-title">${title}</div>` : ''}
                ${showMessage && message ? `<div class="swym-storefront-layout-notification-message">${message}</div>` : ''}
              </div>
            </div>
            ${showActionButton && action ? `<button class="swym-storefront-layout-notification-action">${action.label}</button>` : ''}
          </div>
        `;
        
        if (action) {
          this.querySelector('.swym-storefront-layout-notification-action')?.addEventListener('click', (event) => {
            this.hideNotification();
            action.onClick?.(event);
          });
        }
      }
    
      getIconHtml(iconType) {
        if (iconType === SwymStorefrontLayoutContext?.NotificationIconType?.SuccessIcon) {
          return `<svg viewBox="0 0 18 18" fill="none" class="swym-storefront-layout-notification-icon" aria-hidden="true">
            <path d="m12.053 5.429-.62.645-3.782 3.98-1.131-1.04-.654-.602-1.152 1.384.661.603 1.745 1.606.613.566 5.553-5.844-1.233-1.298Z" fill="currentColor"></path>
          </svg>`;
        }
        return '';
      }
    
      autoHide(duration) {
        clearTimeout(this.timeout);
        this.showNotification();
        this.timeout = setTimeout(() => this.hideNotification(), duration);
      }
    
      showNotification() {
        this.classList.add('swym-storefront-layout-notification-visible');
      }
    
      hideNotification() {
        this.classList.remove('swym-storefront-layout-notification-visible');
      }
    
      /**
       * setLoginNudge — shows a persistent corner notification prompting guest users to
       * log in when auto-wishlist has accumulated >= THRESHOLD items this session.
       *
       * Design choices:
       *  - Reuses this element (already bottom-left corner, clear of ATC bars).
       *  - No autoHide — stays until the user acts (login or dismiss).
       *  - _swat.wrapLogin respects the merchant's configured LoginPath and restores
       *    the current page after login via the POSTLOGINRD cookie.
       *  - Two thresholds: first nudge at 3 items (no +N), second nudge at 5 items (3 thumbs + +N).
       *  - sessionStorage keys are set immediately on show so each threshold fires at most once per session.
       */
      setLoginNudge() {
        const THRESHOLD_FIRST = 3;
        const THRESHOLD_SECOND = 5;
        const SESSION_KEY_FIRST = 'swym-login-nudge-3';
        const SESSION_KEY_SECOND = 'swym-login-nudge-5';
        const AUTO_DISMISS_MS = 2 * 60 * 1000;
        if (!SwymStorefrontLayoutContext.isLoginNudgeEnabled()) return;
        if (SwymStorefrontLayoutContext?.isShopperLoggedIn) return;
        if (!SwymStorefrontLayoutContext?.Settings?.EnableStorefrontLayoutNotification) return;
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig?.() || {};
        const SFY_LIST_NAME = 'Saved For Me';
        // B1: separate AW vs explicit counts — whichever hits threshold first fires
        let awItems, explicitItems;
        if (shouldShowMultiple) {
          awItems = SwymStorefrontLayoutContext.getSfyList?.()?.listcontents || [];
          explicitItems = (SwymStorefrontLayoutContext?.allLists || [])
            .filter(list => list.lname !== SFY_LIST_NAME)
            .flatMap(list => list.listcontents || []);
        } else {
          const defaultContents = SwymStorefrontLayoutContext?.DefaultList?.listcontents || [];
          awItems = defaultContents.filter(item => item.source === 'auto-wishlist');
          explicitItems = defaultContents.filter(item => item.source !== 'auto-wishlist');
        }
        const awCount = awItems.length;
        const explicitCount = explicitItems.length;
        // Priority: AW threshold-2 > AW threshold-1 > explicit threshold-2 > explicit threshold-1
        // Build priority-ordered candidate list, then walk it skipping session-suppressed entries.
        // Shared session keys (swym-login-nudge-3 / -5) are intentional: once a threshold nudge
        // fires for either AW or explicit items, that same threshold won't fire again this session
        // regardless of item type — preventing double-nudging within a session.
        const candidates = [
          ...(awCount >= THRESHOLD_SECOND        ? [{ sessionKey: SESSION_KEY_SECOND, showExtras: true,  nudgeItems: awItems,       isAW: true  }] : []),
          ...(awCount >= THRESHOLD_FIRST         ? [{ sessionKey: SESSION_KEY_FIRST,  showExtras: false, nudgeItems: awItems,       isAW: true  }] : []),
          ...(explicitCount >= THRESHOLD_SECOND  ? [{ sessionKey: SESSION_KEY_SECOND, showExtras: true,  nudgeItems: explicitItems, isAW: false }] : []),
          ...(explicitCount >= THRESHOLD_FIRST   ? [{ sessionKey: SESSION_KEY_FIRST,  showExtras: false, nudgeItems: explicitItems, isAW: false }] : []),
        ];
        let chosen = null;
        for (const c of candidates) {
          try { if (sessionStorage.getItem(c.sessionKey)) continue; } catch (e) {}
          chosen = c;
          break;
        }
        if (!chosen) return;
        const { sessionKey, showExtras, nudgeItems, isAW } = chosen;
        const InstrumentActionCodes = SwymStorefrontLayoutExtensions?.InstrumentActionCodes;
        const InstrumentUtmTerms = SwymStorefrontLayoutExtensions?.InstrumentUtmTerms;
        const nudgeCodes = isAW
          ? (sessionKey === SESSION_KEY_FIRST
              ? {
                  shown: InstrumentActionCodes?.StorefrontLayoutAWNudge1Shown,
                  loginClicked: InstrumentActionCodes?.StorefrontLayoutAWNudge1LoginClicked,
                  dismissed: InstrumentActionCodes?.StorefrontLayoutAWNudge1Dismissed,
                }
              : {
                  shown: InstrumentActionCodes?.StorefrontLayoutAWNudge2Shown,
                  loginClicked: InstrumentActionCodes?.StorefrontLayoutAWNudge2LoginClicked,
                  dismissed: InstrumentActionCodes?.StorefrontLayoutAWNudge2Dismissed,
                })
          : (sessionKey === SESSION_KEY_FIRST
              ? {
                  shown: InstrumentActionCodes?.StorefrontLayoutExplicitNudge1Shown,
                  loginClicked: InstrumentActionCodes?.StorefrontLayoutExplicitNudge1LoginClicked,
                  dismissed: InstrumentActionCodes?.StorefrontLayoutExplicitNudge1Dismissed,
                }
              : {
                  shown: InstrumentActionCodes?.StorefrontLayoutExplicitNudge2Shown,
                  loginClicked: InstrumentActionCodes?.StorefrontLayoutExplicitNudge2LoginClicked,
                  dismissed: InstrumentActionCodes?.StorefrontLayoutExplicitNudge2Dismissed,
                });
        const nudgeUtmTerm = isAW
          ? InstrumentUtmTerms?.StorefrontLayoutAWLoginNudgeEngagement
          : InstrumentUtmTerms?.StorefrontLayoutExplicitLoginNudgeEngagement;
        const count = nudgeItems.length;
        const strings = SwymStorefrontLayoutContext?.Strings;
        const thumbs = nudgeItems.slice(0, THRESHOLD_FIRST); // always first 3
        const extraCount = showExtras ? count - THRESHOLD_FIRST : 0;
        // XSS: escape item.iu — alt is already escaped with &quot; but src was not
        const escAttr = (s) => (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const thumbsHtml = thumbs.map(item => `<img class="swym-aw-nudge-thumb" src="${escAttr(item.iu)}" alt="${escAttr(item.dt)}" loading="lazy" />`).join('');
        const extraHtml = extraCount > 0 ? `<span class="swym-aw-nudge-extra">+${extraCount}</span>` : '';
        // No hardcoded English fallbacks — strings come from strings/*.js locale files via retailerSettings
        const boldMessage = (isAW
          ? (strings?.awNudgeMessage || '')
          : (strings?.explicitNudgeMessage || '')
        ).replace('{count}', count);
        const subMessage = strings?.awNudgeMessageSub || '';
        const dismissLabel = strings?.awNudgeDismiss || '';
        const loginLabel = strings?.awNudgeLoginCTA || '';
        clearTimeout(this.timeout);
        // Use data-nudge-active instead of status to avoid inheriting the dark info background
        this.setAttribute('data-nudge-active', '');
        this.removeAttribute('status');
        // Mark as shown immediately — each threshold fires at most once per session
        try { sessionStorage.setItem(sessionKey, '1'); } catch (e) {}
        this.innerHTML = `
          <div class="swym-aw-nudge-card">
            <div class="swym-aw-nudge-header">
              <div class="swym-aw-nudge-thumbs-row">
                ${thumbsHtml}${extraHtml}
              </div>
              <button type="button" class="swym-aw-nudge-dismiss-btn" aria-label="${escAttr(dismissLabel)}"><svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button>
            </div>
            <p class="swym-aw-nudge-message"><strong>${escAttr(boldMessage)}</strong> ${escAttr(subMessage)}</p>
            <div class="swym-aw-nudge-login-container"></div>
          </div>
        `;
        const nudgeLoginContainer = this.querySelector('.swym-aw-nudge-login-container');
        const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login;
        const renderNudgeClassicBtn = () => {
          nudgeLoginContainer.innerHTML = `<button type="button" class="swym-aw-nudge-login-btn" aria-label="${escAttr(loginLabel)}">${escAttr(loginLabel)}</button>`;
          nudgeLoginContainer.querySelector('.swym-aw-nudge-login-btn')?.addEventListener('click', () => {
            clearTimeout(this._nudgeAutoDismissTimer);
            window._swat?.instrumentV3(nudgeCodes.loginClicked, { 'utm-term': nudgeUtmTerm });
            window.location.href = loginUrl || '/account/login';
          });
        };
        window._swat?.initShopLogin(nudgeLoginContainer, {
          apiKey: SWYM_SHOP_API_KEY,
          showFallbackImmediately: true,
          loginUrl: loginUrl,
          onComplete: (event) => {
            if (event.signedIn) {
              clearTimeout(this._nudgeAutoDismissTimer);
              window._swat?.instrumentV3(nudgeCodes.loginClicked, { 'utm-term': nudgeUtmTerm });
              window.location.reload();
            }
          },
          onFallback: renderNudgeClassicBtn,
          onShown: () => {
            window._swat?.instrumentV3(InstrumentActionCodes?.StorefrontLayoutLoginNudgeShopLoginShown, { "utm-term": InstrumentUtmTerms?.StorefrontLayoutShopLoginNudgeEngagement });
          }
        });
        this.querySelector('.swym-aw-nudge-dismiss-btn')?.addEventListener('click', () => {
          clearTimeout(this._nudgeAutoDismissTimer);
          nudgeLoginContainer.innerHTML = '';
          window._swat?.instrumentV3(nudgeCodes.dismissed, { "utm-term": nudgeUtmTerm });
          this.removeAttribute('data-nudge-active');
          this.hideNotification();
        });
        this.showNotification();
        window._swat?.instrumentV3(nudgeCodes.shown, { "utm-term": nudgeUtmTerm });
        // Auto-dismiss after 2 minutes — unblocks setMessage callers after a reasonable window
        this._nudgeAutoDismissTimer = setTimeout(() => {
          if (this.hasAttribute('data-nudge-active')) {
            this.removeAttribute('data-nudge-active');
            this.hideNotification();
          }
        }, AUTO_DISMISS_MS);
      }
    }
    
    /**
     * SwymStorefrontLayoutLoader Web Component
     *
     * This custom element is responsible for rendering different types of loading placeholders 
     * for the storefront layout. The type of loader is determined by the `loadertype` attribute.
     *
     * Supported loader types:
     * - WishlistListItem: Displays skeleton loaders for wishlist items.
     * - CollectionImages: Displays a placeholder for collection images.
     * - CarouselListItem: Displays skeleton loaders for carousel items.
     * - SpinnerLoader: Displays a rotating spinner for loading states.
     *
     * The component listens for attribute changes to control visibility (`loading`) 
     * and size (`width`, `height`).
     *
     * Usage:
     * <swym-storefront-layout-loader loadertype="WishlistListItem" loading="true"></swym-storefront-layout-loader>
     */
    class SwymStorefrontLayoutLoader extends HTMLElement {
      constructor() {
        super();
    
        this.renderLoader();
    
      }
    
      renderLoader() {
        const loadertype = this.getAttribute('loadertype');
        const buttonCta = this.getAttribute('buttonCta');
    
        const loaderListItemHtml = Array.from({ length: 5 })
        .map((_, i) => {
          return `
          <swym-storefront-layout-item class="swym-storefront-layout-loader">
            <div class="swym-storefront-layout-grid-item">
              <div class="swym-storefront-layout-grid-item-image-container">
                <div class="swym-storefront-layout-grid-item-image"></div>
              </div>
              <div class="swym-storefront-layout-grid-item-content">
                <div class="swym-storefront-layout-grid-item-title"></div>
                <div class="swym-storefront-layout-grid-item-price-variant">
                </div>
                <div class="swym-storefront-layout-grid-item-action-container">
                  ${buttonCta?`<button class="swym-storefront-layout-grid-item-add-to-cart-button" data-action="add-to-cart">${buttonCta}</button>`:''}
                </div>
              </div>
              
              <div tabindex="-1" class="swym-storefront-layout-grid-item-option-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
                  <circle cx="1.5" cy="1.50014" r="1.5" fill="#B1B7C3"></circle>
                  <circle cx="1.5" cy="6.50014" r="1.5" fill="#B1B7C3"></circle>
                  <circle cx="1.5" cy="11.5001" r="1.5" fill="#B1B7C3"></circle>
                </svg>
              </div>
            
            </div>
          </swym-storefront-layout-item>
        `;
        })
        .join("");
    
        if(loadertype === SwymStorefrontLayoutContext?.LoaderViewType.WishlistListItem){
          this.parentElement.innerHTML = `${loaderListItemHtml}`
        }else if(loadertype === SwymStorefrontLayoutContext?.LoaderViewType.CollectionImages){
          this.parentElement.innerHTML = `
            <div class="swym-storefront-layout-loader swym-storefront-layout-collection-list-images"></div>
          `
        }else if(loadertype === SwymStorefrontLayoutContext?.LoaderViewType.CarouselListItem){
          const loaderCollectionListHtml = Array.from({ length: 4 })
                    .map((_, i) => {
                      return `
                      <div class="swym-storefront-layout-loader swym-storefront-layout-collection-grid-item">
                        <div class="swym-storefront-layout-collection-grid-item-info-container">
                          <div class="swym-storefront-layout-collection-grid-item-name"></div>
                          <div class="swym-storefront-layout-collection-grid-item-count"></div>
                        </div>
                        <div class="swym-storefront-layout-collection-grid-item-image-container">

                          <div class="swym-storefront-layout-collection-grid-item-secondary-image ">
                            <div class="swym-storefront-layout-collection-grid-item-image"></div>
                          </div>

                          <div class="swym-storefront-layout-collection-grid-item-secondary-image ">
                          <div class="swym-storefront-layout-collection-grid-item-image"></div>
                          </div>

                          <div class="swym-storefront-layout-collection-grid-item-secondary-image ">
                            <div class="swym-storefront-layout-collection-grid-item-image"></div>
                          </div>

                        </div>
                        <div class="swym-storefront-layout-collection-grid-item-view-button-container">
                          <div class="swym-storefront-layout-collection-grid-item-view-button"></div>
                        </div>
                        <div id="swym-storefront-layout-collection-grid-item-option-button" class="swym-storefront-layout-collection-grid-item-option-button">
                          <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="none">
                            <circle cx="1.5" cy="1.50014" r="1.5" fill="#1C3C35"></circle>
                            <circle cx="1.5" cy="6.50014" r="1.5" fill="#1C3C35"></circle>
                            <circle cx="1.5" cy="11.5001" r="1.5" fill="#1C3C35"></circle>
                          </svg>
                        </div>
                      </div>
                    `;
                    })
                    .join("");
    
                  this.parentElement.innerHTML = `${loaderCollectionListHtml}`
        }else if(loadertype === SwymStorefrontLayoutContext?.LoaderViewType.SpinnerLoader){
          this.innerHTML = `
          <div class="swym-storefront-layout-loader-container">
            <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">
                <path fill="currentColor" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
                  <animateTransform 
                <animateTransform 
                  <animateTransform 
                    attributeName="transform" 
                  attributeName="transform" 
                    attributeName="transform" 
                    attributeType="XML" 
                  attributeType="XML" 
                    attributeType="XML" 
                    type="rotate"
                    dur="1s" 
                  dur="1s" 
                    dur="1s" 
                    from="0 50 50"
                    to="360 50 50" 
                  to="360 50 50" 
                    to="360 50 50" 
                    repeatCount="indefinite" />
              </path>
            </svg>
          </div>
          `;
        }
      }
    
      static get observedAttributes() {
        return ['loading', 'width', 'height'];
      }
    
      attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'loading') {
          if (newValue === 'true') {
            this.style.display = 'flex';
          } else {
            this.style.display = 'none';
          }
        } else if (name == 'width') {
          this.style.width = newValue;
        } else if (name == 'height') {
          this.style.height = newValue;
        }
      }
    }
    
    /**
     * SwymStorefrontLayoutTitle Web Component
     *
     * This custom element is responsible for rendering the title section of the storefront layout, 
     * including the wishlist title and total item count.
     *
     * Functionality:
     * - Displays the wishlist title using `SwymStorefrontLayoutContext?.Strings?.title`.
     * - Shows the total count of wishlist items retrieved from `SwymStorefrontLayoutContext?.lists`.
     * - Listens for the `WishlistFetched` event and updates the title dynamically when the wishlist is fetched.
     *
     * Usage:
     * <swym-storefront-layout-title></swym-storefront-layout-title>
     */
    class SwymStorefrontLayoutTitle extends HTMLElement {
      constructor() {
        super();
    
        this.renderTitle();
    
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, () => {
          this.renderTitle();
        })
      }
    
      renderTitle() {
        // Exclude the Saved For You list and auto-wishlist items — those are shown in the Saved For You tab
        const totalCount = (SwymStorefrontLayoutContext?.allLists || [])
          .filter(list => list.lname !== SFY_LIST_NAME)
          .reduce((total, list) => total + (list.listcontents || []).filter(item => item.source !== 'auto-wishlist').length, 0);
    
        // Drawer UI Polish: personalize title for single wishlist + logged-in users (drawer only)
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
        const customerName = swymEscAttr(SwymStorefrontLayoutContext?.SwymCustomerData?.name?.split(' ')?.[0]);
        let titleText = SwymStorefrontLayoutContext?.Strings?.title;
        if (isDrawer && !shouldShowMultiple && isLoggedIn && customerName) {
          titleText = (SwymStorefrontLayoutContext?.Strings?.personalizedTitle || "{{name}}'s Wishlist").replace('{{name}}', customerName);
        }
    
        const hideCount = isDrawer && !shouldShowMultiple;
        const titleIcon = isDrawer ? (SwymStorefrontLayoutExtensions?.getWishlistIconSvg?.('filled') || '') : '';
        this.innerHTML = `
        <div>
          <div class="swym-storefront-layout-title" id="swym-wishlist-title" role="heading" aria-level="2">
            ${titleIcon}
            ${titleText}
          </div>
          ${ !hideCount && totalCount?`<div class="swym-storefront-layout-total-list-items-count" id="swym-storefront-layout-total-list-items-count" aria-live="polite">${totalCount} ${totalCount<=1? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items }</div>`:''}
        </div>
        `;
        
        // Apply heading font styles after rendering the HTML using shared utility
        const titleElement = this.querySelector('.swym-storefront-layout-title');
        SwymStorefrontLayoutExtensions?.applyHeadingFontStyles(titleElement);
      }
    
    }
    
    /**
     * SwymStorefrontLayoutLoggedUser Web Component
     *
     * This custom element handles user authentication UI within the storefront layout.
     *
     * Functionality:
     * - Checks if a user is logged in using `SwymStorefrontLayoutContext?.isShopperLoggedIn`.
     * - Displays a login prompt if the user is not logged in (when `showLogin="true"`).
     * - Shows a welcome message with the user's name or email (when `showuser="true"`).
     * - Registers a callback in `window.SwymCallbacks` to update UI when Swym state changes.
     * - Tracks login button clicks via `SwymStorefrontLayoutExtensions?.InstrumentActionCodes`.
     *
     * Attributes:
     * - `showuser` (boolean): Determines whether to display logged-in user details.
     * - `showLogin` (boolean): Determines whether to display the login prompt.
     *
     * Usage:
     * <swym-storefront-layout-logged-user showuser="true" showLogin="true"></swym-storefront-layout-logged-user>
     */
    /**
     * Guest login popup: the login message with a Shop Login button
     * (falls back to the classic login redirect when Shop Login is unavailable).
     */
    SwymStorefrontLayoutExtensions.openLoginModal = function () {
      if (document.querySelector('.swym-storefront-layout-login-modal')) return;
      const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login || window.SWYM_ACCOUNT_OR_LOGIN_URL || '/account/login';
      const previouslyFocused = document.activeElement;
      const previousBodyOverflow = document.body.style.overflow;
      const modal = document.createElement('div');
      modal.className = 'swym-storefront-layout-login-modal';
      modal.innerHTML = `
        <div class="swym-storefront-layout-login-modal-backdrop"></div>
        <div class="swym-storefront-layout-login-modal-content" role="dialog" aria-modal="true" aria-labelledby="swym-storefront-layout-login-modal-title" aria-describedby="swym-storefront-layout-login-modal-text">
          <button type="button" class="swym-storefront-layout-login-modal-close" aria-label="${SwymStorefrontLayoutContext?.Strings?.closeDrawer || 'Close'}">
            <svg width="14" height="14" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>
          </button>
          <h2 id="swym-storefront-layout-login-modal-title" class="swym-storefront-layout-login-modal-title">${SwymStorefrontLayoutContext?.Strings?.loginModalTitle || 'Sign In'}</h2>
          <p id="swym-storefront-layout-login-modal-text" class="swym-storefront-layout-login-modal-text">${SwymStorefrontLayoutContext?.Strings?.loginText}</p>
          <div class="swym-storefront-layout-login-modal-shop-login"></div>
        </div>
      `;
      document.body.appendChild(modal);
      document.body.style.overflow = 'hidden';

      const shopLoginContainer = modal.querySelector('.swym-storefront-layout-login-modal-shop-login');
      const renderClassicBtn = () => {
        shopLoginContainer.innerHTML = `<button type="button" class="swym-storefront-layout-login-modal-button">${SwymStorefrontLayoutContext?.Strings?.loginButtonText}</button>`;
        shopLoginContainer.querySelector('button')?.addEventListener('click', () => {
          window.location.href = loginUrl;
        });
      };
      const shopLoginHandle = window._swat?.initShopLogin?.(shopLoginContainer, {
        apiKey: SWYM_SHOP_API_KEY,
        loginUrl: loginUrl,
        presentationMode: 'button',
        showFallbackImmediately: true,
        onComplete: (event) => {
          if (event.signedIn) window.location.reload();
        },
        onFallback: renderClassicBtn
      });
      if (!shopLoginHandle && !shopLoginContainer.innerHTML) renderClassicBtn();

      const dialog = modal.querySelector('.swym-storefront-layout-login-modal-content');
      const getFocusable = (root) => {
        let elements = Array.from(root.querySelectorAll('button, [href], input, select, textarea, iframe, [tabindex]:not([tabindex="-1"])'));
        for (const el of elements) {
          if (el.shadowRoot) elements = elements.concat(getFocusable(el.shadowRoot));
        }
        return elements;
      };
      const onKeydown = (event) => {
        if (event.key === 'Escape') return close();
        if (event.key !== 'Tab') return;
        const focusable = getFocusable(dialog);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        const isInside = dialog.contains(document.activeElement);
        if (event.shiftKey && (document.activeElement === first || !isInside)) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && (document.activeElement === last || !isInside)) {
          event.preventDefault();
          first.focus();
        }
      };
      const close = () => {
        shopLoginHandle?.destroy?.();
        document.removeEventListener('keydown', onKeydown, true);
        document.body.style.overflow = previousBodyOverflow;
        modal.remove();
        if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
      };
      modal.querySelector('.swym-storefront-layout-login-modal-close').addEventListener('click', close);
      modal.querySelector('.swym-storefront-layout-login-modal-backdrop').addEventListener('click', close);
      document.addEventListener('keydown', onKeydown, true);
      modal.querySelector('.swym-storefront-layout-login-modal-close').focus();
    };

    class SwymStorefrontLayoutLoggedUser extends HTMLElement {
      constructor() {
        super();
        if (!window.SwymCallbacks) {
          window.SwymCallbacks = [];
        }
        window.SwymCallbacks.push(this.swymCallbackFn.bind(this));
        // Re-evaluate login prompt visibility after wishlist data is fetched,
        // since DefaultList may not be populated when swymCallbackFn first fires
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, () => {
          this.updateLoginPromptVisibility();
        });
      }

      connectedCallback() {
        // Show the guest banner while the wishlist is still loading
        if (SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-section') {
          this.updateLoginPromptVisibility();
        }
      }

      swymCallbackFn(swat) {
        const showUser = this.getAttribute('showuser') === 'true';
        const showLogin = this.getAttribute('showLogin') === 'true';
        let isUserLogged = SwymStorefrontLayoutContext?.isShopperLoggedIn;
    
        if (!isUserLogged && showLogin) {
          this.updateLoginPromptVisibility();
        } else if (isUserLogged && showUser) {
          this.renderUserDetails();
        } else if (isUserLogged && showLogin) {
          // For drawer + single wishlist: render share button in the login-user container
          // (same background, no heading/description text)
          this.renderLoggedInShareContainer();
        }
    
      }
    
      updateLoginPromptVisibility() {
        const showLogin = this.getAttribute('showLogin') === 'true';
        if (!showLogin) return;
        let isUserLogged = SwymStorefrontLayoutContext?.isShopperLoggedIn;
        if (isUserLogged) return;
    
        // Always show login prompt inside collection list view for guests,
        // since the collection list overlays the main empty state
        const isInsideCollectionList = this.closest('swym-storefront-layout-collection-list');
        if (isInsideCollectionList) {
          this.renderLoginContainer();
          return;
        }
    
        // Hide the separate login prompt when wishlist is empty, since
        // the guest empty state already includes login CTAs
        // (the page layout keeps the banner for guests at all times, including while loading)
        const isSection = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-section';
        const wishlistIsEmpty = !SwymStorefrontLayoutContext?.DefaultList?.listcontents?.length;
        if (wishlistIsEmpty && !isSection) {
          this.innerHTML = '';
          return;
        }
        this.renderLoginContainer();
      }
    
      renderUserDetails() {
        let customer = SwymStorefrontLayoutContext?.SwymCustomerData;
        this.innerHTML = `
          <div class="swym-storefront-layout-logged-user-container"> 
            <div class="swym-storefront-layout-logged-user-welcome-message">${SwymStorefrontLayoutContext?.Strings?.loggedUserWelcomeMessage} <span class="swym-storefront-layout-logged-user-name">${customer?.name ? customer?.name : customer?.email}</span></div>
          </div>
        `
      }
    
      renderLoginContainer() {
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        const showInlineButtons = isDrawer && !shouldShowMultiple;
    
        // Drawer + single wishlist: show inline Login to Save + Share buttons
        if (showInlineButtons) {
          const shareIcon = SwymStorefrontLayoutExtensions.getShareIconSvg();
    
          const loginToSaveCta = SwymStorefrontLayoutContext?.Strings?.loginToSaveCta || 'Login to Save';
          const inlineButtons = `
            <div class="swym-storefront-layout-login-actions">
              <div class="swym-storefront-layout-shop-login-container"></div>
              <button class="swym-storefront-layout-share-footer-share-btn" data-action="share" aria-label="${SwymStorefrontLayoutContext?.Strings?.shareCta || 'Share'}">
                ${shareIcon} ${SwymStorefrontLayoutContext?.Strings?.shareCta || 'Share'}
              </button>
            </div>`;
    
          this.innerHTML = `
            <div class="swym-storefront-layout-login-user-container">
              <div class="swym-storefront-layout-login-content">
                <div class="swym-storefront-layout-login-heading">${SwymStorefrontLayoutContext?.Strings?.loginHeading}</div>
                <div class="swym-storefront-layout-login-description">${SwymStorefrontLayoutContext?.Strings?.loginText}</div>
              </div>
              ${inlineButtons}
            </div>
          `;
          const shopLoginContainer = this.querySelector('.swym-storefront-layout-shop-login-container');
          const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login;
          const renderDrawerClassicBtn = () => {
            shopLoginContainer.innerHTML = `<button class="swym-storefront-layout-share-footer-login-btn" data-action="login" aria-label="${loginToSaveCta}">${loginToSaveCta} <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.49951 10C3.49951 9.58579 3.8353 9.25 4.24951 9.25L13.9391 9.25L11.2192 6.53036C10.9263 6.23748 10.9263 5.7626 11.2192 5.4697C11.512 5.17679 11.9869 5.17676 12.2798 5.46964L16.2802 9.46964C16.4209 9.6103 16.4999 9.80107 16.4999 10C16.4999 10.1989 16.4209 10.3897 16.2802 10.5304L12.2798 14.5304C11.9869 14.8232 11.512 14.8232 11.2192 14.5303C10.9263 14.2374 10.9263 13.7625 11.2192 13.4696L13.9391 10.75L4.24951 10.75C3.8353 10.75 3.49951 10.4142 3.49951 10Z" fill="currentColor"/></svg></button>`;
            shopLoginContainer.querySelector('[data-action="login"]')?.addEventListener('click', () => {
              window.location.href = loginUrl || '/account/login';
            });
          };
          renderDrawerClassicBtn();
          this.attachShareFooterEvents();
          return;
        }
    
        // Default: modal/section/multi-wishlist
        this.innerHTML = `
          <div class="swym-storefront-layout-login-user-container">
            <div class="swym-storefront-layout-login-content">
              <div class="swym-storefront-layout-login-heading">${SwymStorefrontLayoutContext?.Strings?.loginHeading}</div>
              <div class="swym-storefront-layout-login-description">${SwymStorefrontLayoutContext?.Strings?.loginText}</div>
            </div>
            <div class="swym-storefront-layout-shop-login-container"></div>
          </div>
        `;
        const shopLoginContainer = this.querySelector('.swym-storefront-layout-shop-login-container');
        const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login;
        const renderModalClassicBtn = () => {
          shopLoginContainer.innerHTML = `<button class="swym-storefront-layout-login-button"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><circle cx="12" cy="8" r="4" fill="currentColor"/><path d="M4 20c0-4.4 3.6-8 8-8s8 3.6 8 8" fill="currentColor"/></svg>${SwymStorefrontLayoutContext?.Strings?.loginButtonText}</button>`;
          shopLoginContainer.querySelector('.swym-storefront-layout-login-button')?.addEventListener('click', () => {
            SwymStorefrontLayoutExtensions.openLoginModal();
          });
        };
        renderModalClassicBtn();
      }
    
      attachShareFooterEvents() {
        const shareBtn = this.querySelector('[data-action="share"]');
        const loginBtn = this.querySelector('[data-action="login"]');
    
        shareBtn?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          const isLoggedIn = window._swat?.platform?.isLoggedIn();
          if (!isLoggedIn) {
            const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login || '/account/login';
            window.location.href = loginUrl;
            return;
          }
          const activeTab = document.querySelector('.swym-storefront-layout-tab-button.swym-storefront-layout-tab-button-active');
          const activeDataView = activeTab?.getAttribute('data-view');
          const list = SwymStorefrontLayoutContext?.DefaultList;
          const isSflTab = activeDataView === 'tabSavedForLater';
          const activeList = isSflTab ? SwymStorefrontLayoutContext?.sflList : list;
          window._swat?.evtLayer?.dispatchEvent(new CustomEvent('sw:renderShareWishlistUI', {
            detail: {
              lid: activeList?.lid || '',
              lname: '',
              list: activeList,
              layoutType: SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType,
              senderName: '',
              activeDataView
            }
          }));
        });
    
        loginBtn?.addEventListener('click', () => {
          const loginUrl = SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.Login || '/account/login';
          window.location.href = loginUrl;
        });
      }
    
      renderLoggedInShareContainer() {
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        if (!isDrawer || shouldShowMultiple) {
          this.innerHTML = '';
          return;
        }
    
        const selectedView = SwymStorefrontLayoutContext?.SelectedLayoutView;
        const isSfyTab = selectedView === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou;
        const shareLabel = isSfyTab
          ? (SwymStorefrontLayoutContext?.Strings?.shareThisListCta || 'Share This List')
          : (SwymStorefrontLayoutContext?.Strings?.shareCta || 'Share');
    
        const shareIcon = SwymStorefrontLayoutExtensions.getShareIconSvg();
    
            this.innerHTML = `
              <div class="swym-storefront-layout-login-user-container">
            <div class="swym-storefront-layout-login-actions">
              <button class="swym-storefront-layout-share-footer-share-btn swym-storefront-layout-share-footer-share-btn-full" data-action="share" aria-label="${shareLabel}">
                ${shareIcon} ${shareLabel}
              </button>
            </div>
          </div>
        `;
    
        this.attachShareFooterEvents();
    
        // Listen for tab changes to update share button label.
        // Remove any previous listener first to prevent stacking on re-render.
        if (this._tabChangeListener) {
          document.removeEventListener('click', this._tabChangeListener);
        }
        this._tabChangeListener = (e) => {
          if (e.target?.closest?.('.swym-storefront-layout-tab-button')) {
            requestAnimationFrame(() => this.renderLoggedInShareContainer());
          }
        };
        document.addEventListener('click', this._tabChangeListener);
      }
    
      disconnectedCallback() {
        if (this._tabChangeListener) {
          document.removeEventListener('click', this._tabChangeListener);
          this._tabChangeListener = null;
        }
      }
    
    }
    
    class SwymStorefrontLayoutTabs extends HTMLElement {
      constructor() {
        super();
        this.elements = {};
        SwymStorefrontLayoutContext.SelectedLayoutView = SwymStorefrontLayoutContext?.Tabs?.[0] || null;
      }
    
      connectedCallback(){
        this.initUI();
        this._layoutInitHandler = () => {
          SwymStorefrontLayoutContext.Tabs = [SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist];
          if(window._swat.retailerSettings.SFL?.SFLFeatureEnabled){
            SwymStorefrontLayoutContext.Tabs.push(SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SaveForLater);
          }
          // SavedForYou tab is added/removed dynamically by the WishlistFetched listener below
          this.initUI();
        };
        this._wishlistFetchedHandler = () => {
          if (window.SwymEnabledCommonFeatures?.['auto-add-to-wishlist-from-pdp']?.enabled) {
            const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
            const hasAutoWishlistItems = shouldShowMultiple
              ? (SwymStorefrontLayoutContext.getSfyList()?.listcontents?.length > 0)
              : (SwymStorefrontLayoutContext?.DefaultList?.listcontents || []).some(item => item.source === 'auto-wishlist');
            const savedForYouViewType = SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou;
            const currentIdx = SwymStorefrontLayoutContext.Tabs?.indexOf(savedForYouViewType);
            if (hasAutoWishlistItems && currentIdx === -1) {
              SwymStorefrontLayoutContext.Tabs.splice(1, 0, savedForYouViewType);
            } else if (!hasAutoWishlistItems && currentIdx !== -1) {
              SwymStorefrontLayoutContext.Tabs.splice(currentIdx, 1);
              if (SwymStorefrontLayoutContext.SelectedLayoutView === savedForYouViewType) {
                SwymStorefrontLayoutContext.SelectedLayoutView = SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist;
              }
            }
          }
          // Always re-render to update tab count badges
          this.initUI();
        };
        this._sflFetchedHandler = () => { this.initUI(); };
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.LayoutInitialized, this._layoutInitHandler);
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, this._wishlistFetchedHandler);
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForLaterFetched, this._sflFetchedHandler);
      }
    
      disconnectedCallback(){
        if (this._layoutInitHandler) {
          document.removeEventListener(SwymStorefrontLayoutContext?.CustomEvents?.LayoutInitialized, this._layoutInitHandler);
        }
        if (this._wishlistFetchedHandler) {
          document.removeEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, this._wishlistFetchedHandler);
        }
        if (this._sflFetchedHandler) {
          document.removeEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForLaterFetched, this._sflFetchedHandler);
        }
      }
    
      initUI(){
        this.renderUI();
        this.initElement();
    
        // Always sync content panels visibility with SelectedLayoutView
        const selectedView = SwymStorefrontLayoutContext?.SelectedLayoutView || SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist;
        const tabContent = document.querySelector('swym-storefront-layout-tab-content');
        tabContent?.querySelectorAll('.swym-storefront-layout-tab-container').forEach(container => {
          const isActive = container.id === selectedView;
          container.classList.toggle('swym-storefront-layout-tab-content-active', isActive);
          if (isActive) container.removeAttribute('hidden');
          else container.setAttribute('hidden', '');
        });
    
        if (this.elements.currentSelectedTab) {
          this.setTabSelection(this.elements.currentSelectedTab);
          this.attachEvents();
        }
      }
    
      renderUI() {
        let tabs = SwymStorefrontLayoutContext?.Tabs;
        if (!tabs?.length || tabs?.length<=1){
          this.innerHTML = '';
          return;
        }
        
        this.innerHTML = `
          <div class="swym-storefront-layout-tabs-view">
            <div class="swym-storefront-layout-tabs" role="tablist" aria-label="Wishlist views">
              ${tabs.map((tab, index)=>{
                const isActive = tab===SwymStorefrontLayoutContext?.SelectedLayoutView;
                const isDrawerLayout = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
                const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
                const tabCount = isDrawerLayout ? this.getTabItemCount(tab) : 0;
                const hideCount = !isDrawerLayout || shouldShowMultiple || !isActive;
                const countBadge = isDrawerLayout ? `<span class="swym-storefront-layout-tab-count${hideCount ? ' swym-storefront-layout-tab-count-hidden' : ''}">${tabCount}</span>` : '';
                return `<button class="swym-storefront-layout-tab-button ${isActive?'swym-storefront-layout-tab-button-active':''}" data-view="${tab}" role="tab" aria-selected="${isActive}" aria-controls="${tab}" tabindex="${isActive ? '0' : '-1'}" id="tab-${tab}">${SwymStorefrontLayoutContext?.Strings?.[tab]}${countBadge}</button>`
              }).join('')}
            </div>
            <div class="swym-storefront-layout-tab-indicator"></div>
          </div>
        `;
      }
    
      getTabItemCount(tab) {
        if (tab === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist) {
          const allItems = SwymStorefrontLayoutContext?.DefaultList?.listcontents || [];
          const hasSfyTab = SwymStorefrontLayoutContext?.Tabs?.includes(SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou);
          return hasSfyTab ? allItems.filter(item => item.source !== 'auto-wishlist').length : allItems.length;
        }
        if (tab === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou) {
          return SwymStorefrontLayoutContext?.savedForYouItems?.length || 0;
        }
        if (tab === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SaveForLater) {
          return SwymStorefrontLayoutContext?.sflListItems?.length || 0;
        }
        return 0;
      }
    
      initElement(){
        this.elements = {
          tabs: this.querySelectorAll('.swym-storefront-layout-tab-button'),
          tabIndicator: this.querySelector('.swym-storefront-layout-tab-indicator'),
          currentSelectedTab: this.querySelector('.swym-storefront-layout-tab-button-active'),
          tabContent: document.querySelector('swym-storefront-layout-tab-content')
        };
      }
    
      setTabSelection(selectedTab){
        if (!selectedTab) return;
    
        const selectedView = selectedTab.getAttribute('data-view');
        if (!selectedView) return;
    
        SwymStorefrontLayoutContext.SelectedLayoutView = selectedView || SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist;
    
        this.elements.tabContainers = this.elements.tabContent?.querySelectorAll('.swym-storefront-layout-tab-container');
    
        // Update ARIA attributes and tabindex for accessibility
        this.elements.tabs?.forEach(tab => {
          const isSelected = tab === selectedTab;
          tab.classList.toggle('swym-storefront-layout-tab-button-active', isSelected);
          tab.setAttribute('aria-selected', isSelected);
          tab.setAttribute('tabindex', isSelected ? '0' : '-1');
          // Toggle tab count visibility (opacity) for drawer layout — always hidden for multi-wishlist
          const countBadge = tab.querySelector('.swym-storefront-layout-tab-count');
          if (countBadge) {
            const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
            countBadge.classList.toggle('swym-storefront-layout-tab-count-hidden', shouldShowMultiple || !isSelected);
          }
        });
        
        this.elements.tabContainers?.forEach(tabContainer => {
          const isActive = tabContainer.id === selectedView;
          tabContainer.classList.toggle('swym-storefront-layout-tab-content-active', isActive);
          // Manage hidden attribute for better accessibility
          if (isActive) {
            tabContainer.removeAttribute('hidden');
          } else {
            tabContainer.setAttribute('hidden', '');
          }
        });
        
        this.setTabIndicator();
      }
    
      setTabIndicator(){
        let selectedTab = this.elements.currentSelectedTab;
        if(selectedTab){
        // Wait for next frame to ensure layout is complete
          requestAnimationFrame(() => {
            const tabCenter = selectedTab.offsetLeft + selectedTab.offsetWidth / 2;
            this.elements.tabIndicator?.style.setProperty(
              'left',
              `${tabCenter - (this.elements.tabIndicator.offsetWidth ?? 0) / 2}px`
            );
          })
        }
      }
      
      attachEvents() {
        this.elements.tabs?.forEach((tab) => {
          // Click event handler
          tab.addEventListener('click', (event) => {
            const clickedTab = event.target?.closest('[role="tab"]');
            if (!clickedTab) return;
            this.elements.currentSelectedTab = clickedTab;
            this.setTabSelection(clickedTab);
            if (clickedTab.getAttribute('data-view') === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou) {
              window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYTabViewed, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
            }
          });
          
          // Keyboard navigation for accessibility
          tab.addEventListener('keydown', (event) => {
            // Validate event target is a tab
            const eventTarget = event.target?.closest('[role="tab"]');
            if (!eventTarget) return;
    
            const tabArray = Array.from(this.elements.tabs || []);
            if (tabArray.length === 0) return;
    
            const currentIndex = tabArray.indexOf(eventTarget);
            if (currentIndex === -1) return; // Target not in tabs array
            
            let targetTab = null;
            
            switch(event.key) {
              case 'ArrowRight':
                event.preventDefault();
                targetTab = tabArray[(currentIndex + 1) % tabArray.length];
                break;
              case 'ArrowLeft':
                event.preventDefault();
                targetTab = tabArray[(currentIndex - 1 + tabArray.length) % tabArray.length];
                break;
              case 'Home':
                event.preventDefault();
                targetTab = tabArray[0];
                break;
              case 'End':
                event.preventDefault();
                targetTab = tabArray[tabArray.length - 1];
                break;
              case 'Enter':
              case ' ':
                event.preventDefault();
                this.elements.currentSelectedTab = eventTarget;
                this.setTabSelection(eventTarget);
                if (eventTarget.getAttribute('data-view') === SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou) {
                  window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFYTabViewed, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
                }
                return;
              default:
                return;
            }
            
            if (targetTab) {
              this.elements.currentSelectedTab = targetTab;
              this.setTabSelection(targetTab);
              targetTab.focus();
            }
          });
        });
        
        // Debounced resize handler to reposition indicator
        if (window.addEventListener && SwymStorefrontLayoutContext?.swat?.utils?.debounce) {
          window.addEventListener('resize', SwymStorefrontLayoutContext.swat.utils.debounce(() => {
            this.setTabIndicator();
          }, 200));
        }
      }
    }
    
    class SwymStorefrontLayoutTabContent extends HTMLElement {
      constructor() {
        super();
        this.renderUI();
      }
    
      renderUI() {
        this.innerHTML = `
          <swym-storefront-layout-wishlist-container 
            id="${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist}" 
            class="swym-storefront-layout-tab-container swym-storefront-layout-tab-content-active"
            role="tabpanel"
            aria-labelledby="tab-${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.Wishlist}"
            tabindex="0"
          ></swym-storefront-layout-wishlist-container>
          <swym-storefront-layout-sfl-container 
            id="${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SaveForLater}" 
            class="swym-storefront-layout-tab-container"
            role="tabpanel"
            aria-labelledby="tab-${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SaveForLater}"
            tabindex="0"
            hidden
          ></swym-storefront-layout-sfl-container>
          <swym-storefront-layout-saved-for-you-container
            id="${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou}"
            class="swym-storefront-layout-tab-container"
            role="tabpanel"
            aria-labelledby="tab-${SwymStorefrontLayoutContext?.StorefrontLayoutViewType?.SavedForYou}"
            tabindex="0"
            hidden
          ></swym-storefront-layout-saved-for-you-container>
          
        `;
      }
    }
    
    
    class SwymStorefrontLayoutWishlistContainer extends HTMLElement {
      constructor() {
        super();
        this.wishlist = null;
        this.collections = [];
        this.elements = {};
        this.initUI();
        document.addEventListener(
          SwymStorefrontLayoutContext?.CustomEvents?.LayoutInitialized,
          () => {
            this.attachSwymEventListeners(SwymStorefrontLayoutContext?.swat);
          }
        );
        document.addEventListener(
          SwymStorefrontLayoutContext?.CustomEvents?.AsyncApisInitialized,
          () => {
            SwymStorefrontLayoutExtensions?.refreshWishList();
          }
        );
        this.attachEventListner();
      }
    
      initUI() {
        this.renderUI();
        this.initElement();
      }
    
      renderUI() {
        const isLoggedIn = window._swat?.platform?.isLoggedIn();
        
        // Always render carousel element - it will show/hide itself based on data
        // We can't conditionally render here because allLists data isn't available yet
        this.innerHTML = `
          <div class="swym-storefront-layout-header">
            <swym-storefront-layout-title></swym-storefront-layout-title>
            <div class="swym-storefront-layout-header-shopper-info" role="button" tabindex="0">
              <img class="swym-storefront-layout-header-shopper-info-icon" src="${window.SWYM_GUEST_SHOPPER_ICON_URL || ''}" width="18" height="18" alt="">
              <span class="swym-storefront-layout-header-shopper-info-text">${SwymStorefrontLayoutContext?.isShopperLoggedIn ? swymEscAttr(SwymStorefrontLayoutContext?.SwymCustomerData?.email) : 'Guest Shopper'}</span>
            </div>
            ${isLoggedIn ?
              `<button id="swym-storefront-layout-collection-option-button" class="swym-storefront-layout-collection-option-button swym-single-share-wishlist-btn swym-hidden" tabindex="0" aria-haspopup="dialog" aria-expanded="false" aria-label="Action menu options">
              <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
                <circle cx="1.5" cy="1.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="6.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="11.5001" r="1.5" fill="currentColor"></circle>
              </svg>
            </button>` : ""}
          </div>
          <div class="swym-storefront-layout-body" role="region" aria-label="Wishlist Content Section">
            <swym-storefront-layout-collection-carousel></swym-storefront-layout-collection-carousel>
            <swym-storefront-layout-default-wishlist></swym-storefront-layout-default-wishlist>
            <swym-storefront-layout-collection-list id="swym-storefront-layout-collection-list" role="list" aria-label="Your Wishlist Collections"></swym-storefront-layout-collection-list>
         </div>
        `;
      }
    
      initElement() {
        this.elements = {
          wishlistListComponent: this.querySelector("swym-storefront-layout-default-wishlist"),
          collectionsCarouselComponent: this.querySelector("swym-storefront-layout-collection-carousel"),
          collectionsListComponent: this.querySelector("swym-storefront-layout-collection-list"),
          swymListActionButton: this.querySelector("#swym-storefront-layout-collection-option-button"),
          shopperInfo: this.querySelector(".swym-storefront-layout-header-shopper-info"),
          shopperInfoText: this.querySelector(".swym-storefront-layout-header-shopper-info-text"),
        };
        const onShopperInfoActivate = () => {
          if (!SwymStorefrontLayoutContext?.isShopperLoggedIn) return SwymStorefrontLayoutExtensions.openLoginModal();
          if (window.SWYM_ACCOUNT_OR_LOGIN_URL) window.location.href = window.SWYM_ACCOUNT_OR_LOGIN_URL;
        };
        this.elements.shopperInfo?.addEventListener('click', onShopperInfoActivate);
        this.elements.shopperInfo?.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          onShopperInfoActivate();
        });
      }
    
        attachEventListner(){
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, () => {
          if (this.elements.shopperInfoText) {
            const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
            const customerEmail = SwymStorefrontLayoutContext?.SwymCustomerData?.email;
            this.elements.shopperInfoText.textContent = (isLoggedIn && customerEmail) ? customerEmail : 'Guest Shopper';
          }
          this.wishlist = SwymStorefrontLayoutContext?.DefaultList || null;
          // Use allLists as the source for collections, excluding default list and the SFY list
          // (SFY list is shown in its own dedicated tab, not in the collections carousel)
          const allLists = SwymStorefrontLayoutContext?.allLists || SwymStorefrontLayoutContext?.collections || [];
          const defaultListId = SwymStorefrontLayoutContext?.DefaultList?.lid;
          const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          const sfyListId = shouldShowMultiple ? SwymStorefrontLayoutContext.getSfyList()?.lid : null;
          this.collections = allLists.filter(list => list.lid !== defaultListId && list.lid !== sfyListId);
          this.renderWishlistAndCollections();
        })
        this.elements.swymListActionButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if(SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.closeTooltip();
            event.target.setAttribute('aria-expanded', 'false');
          }else{
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
              listId: "",
              list: this.wishlist,
              collections: this.collections,
              actionType: SwymStorefrontLayoutContext?.ActionTypes.ShareSingleWishlist
            });
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
            event.target.setAttribute('aria-expanded', 'true');
          }
        });
    
      }
      attachSwymEventListeners(swat) {
        swat?.evtLayer?.addEventListener(
          swat?.JSEvents?.storeAddedToCart,
          (data) => {
            swat.utils.debounce(() => {
              this.renderWishlistAndCollections();
            }, 1000)();
          }
        );
    
        swat?.evtLayer?.addEventListener(
          swat?.JSEvents?.storeRemovedFromCart,
          (data) => {
            swat.utils.debounce(() => {
              this.renderWishlistAndCollections();
            }, 1000)();
          }
        );
      }
    
    
      renderWishlistAndCollections() {
        // Use centralized helper to determine multi-wishlist behavior
        const { shouldShowMultiple, canCreateLists } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        // Check for auto-wishlist items directly — don't rely on Tabs array state since
        // the Tabs listener and this listener fire in undefined order on the same event.
        const autoWishlistEnabled = window.SwymEnabledCommonFeatures?.['auto-add-to-wishlist-from-pdp']?.enabled;
        // Multi-list: SFY items live in the dedicated "Saved For Me" list, not in DefaultList
        const hasSfyItems = autoWishlistEnabled && (
          shouldShowMultiple
            ? (SwymStorefrontLayoutContext.getSfyList()?.listcontents?.length > 0)
            : (SwymStorefrontLayoutContext?.DefaultList?.listcontents || []).some(item => item.source === 'auto-wishlist')
        );
    
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        if(this.collections?.length > 0 || (this.wishlist && this.wishlist?.listcontents?.length > 0)) {
          // Hide the 3-dot menu in drawer + single wishlist — share is handled by the footer button
          if (!(isDrawer && !shouldShowMultiple)) {
            this.querySelector("#swym-storefront-layout-collection-option-button")?.classList.remove('swym-hidden');
          }
        }
        
        if ( this.wishlist || this.collections) {
          if(window.location.hash.startsWith(SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList)){
            const collectionId = window.location.hash.slice(SwymStorefrontLayoutContext?.StorefrontLayoutUrls?.CollectionList.length);
            if(this.elements.collectionsListComponent && this.collections){
              let selectedCollection = this.collections?.find((collection)=> collection.lid === collectionId);
              this.elements.collectionsListComponent.setData({ 
                list: selectedCollection, 
                collections: this.collections,
                canCreateLists: canCreateLists,
                shouldShowMultiple: shouldShowMultiple
              })
            }
          }
    
          // Filter auto-wishlist items from the Wishlist tab — they belong in the SFY tab only.
          // In single-list mode, both share DefaultList. In multi-list mode, this is a safety net
          // in case DefaultList somehow contains auto-wishlist items (e.g. SFY list was lists[0]).
          const wishlistForDisplay = hasSfyItems
            ? { ...this.wishlist, listcontents: (this.wishlist?.listcontents || []).filter(item => item.source !== 'auto-wishlist') }
            : this.wishlist;
    
          this.elements.wishlistListComponent?.setData({ 
            wishlist: wishlistForDisplay, 
            collections: this.collections,
            canCreateLists: canCreateLists,
            shouldShowMultiple: shouldShowMultiple
          });
    
          // Always call setData on carousel so it can manage its own visibility
          if (this.elements.collectionsCarouselComponent) {
            this.elements.collectionsCarouselComponent?.setData({ 
              collections: shouldShowMultiple ? this.collections : [],
              canCreateLists: canCreateLists,
              shouldShowMultiple: shouldShowMultiple
            });
          }
        }
      }
    }
    
    class SwymStorefrontLayoutSaveForLaterContainer extends HTMLElement{
      constructor(){
        super();
        this.sflData = null;
        this.collections = [];
        this.elements = {};
    
        this.initUI();
    
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.AsyncApisInitialized, () => {
          if(window._swat?.retailerSettings.SFL?.SFLFeatureEnabled){
            this.initSfl();
          }
        })
    
        this.attachEventListner();
      }
    
      initUI(){
        this.renderUI();
        this.initElement();
      }
    
      renderUI(){
        const isLoggedIn = window?._swat?.platform?.isLoggedIn();
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        const hideOptionButton = isDrawer && !shouldShowMultiple;
        this.innerHTML = `
          <div class="swym-storefront-layout-header">
            <swym-storefront-layout-sfl-title></swym-storefront-layout-sfl-title>
            ${isLoggedIn && !hideOptionButton ?
            `<div id="swym-storefront-layout-collection-option-button" class="swym-storefront-layout-collection-option-button swym-hidden">
              <svg xmlns="http://www.w3.org/2000/svg" width="3" height="13" viewBox="0 0 3 13" fill="currentcolor">
                <circle cx="1.5" cy="1.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="6.50014" r="1.5" fill="currentColor"></circle>
                <circle cx="1.5" cy="11.5001" r="1.5" fill="currentColor"></circle>
              </svg>
            </div>` : ""
            }
          </div>
          <div class="swym-storefront-layout-body">
            <swym-storefront-layout-sfl-list></swym-storefront-layout-sfl-list>
          </div>
        `;
      }
    
      initElement(){
        this.elements = {
          sflList: this.querySelector('swym-storefront-layout-sfl-list'),
          swymListActionButton: this.querySelector('#swym-storefront-layout-collection-option-button')
        }
      }
    
      async initSfl(){
        if(!SwymStorefrontLayoutContext?.sflListId){
          await SwymStorefrontLayoutAPI?.SwymSFLAsyncApis?.updateSflList();
          window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFLInitialized, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
        }
    
        if(!SwymStorefrontLayoutContext?.sflList){
          SwymStorefrontLayoutExtensions?.refreshSFLList();
        }
        if(SwymStorefrontLayoutContext?.sflList) {
          const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
          const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          // Hide the 3-dot menu in drawer + single wishlist — share is handled by the footer button
          if (!(isDrawer && !shouldShowMultiple)) {
            this.querySelector("#swym-storefront-layout-collection-option-button")?.classList.remove("swym-hidden");
          }
        } 
      }
      attachEventListner(){
        this.elements.swymListActionButton?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          if(SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.isTooltipOpen && SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.currentTarget === event.target){
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.closeTooltip();
          }else{
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.setData({
              listId: SwymStorefrontLayoutContext?.sflListId,
              list: "",
              collections: "",
              actionType: SwymStorefrontLayoutContext?.ActionTypes.ShareSingleWishlist
            });
    
            SwymStorefrontLayoutExtensions?.SwymStorefrontLayoutActionTooltip?.showOnTarget(event.target);
          }
        });
    
      }
    }
    
    class SwymStorefrontLayoutSaveForLaterTitle extends HTMLElement {
      constructor() {
        super();
    
        this.renderTitle();
    
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForLaterFetched, () => {
          this.renderTitle();
        })
      }
    
      renderTitle() {
        const totalCount = SwymStorefrontLayoutContext?.sflListItems?.length || 0;
        this.innerHTML = `
        <div>
          <div class="swym-storefront-layout-title" id="swym-sfl-title" role="heading" aria-level="2">
            ${SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer' ? (SwymStorefrontLayoutExtensions?.getWishlistIconSvg?.('filled') || '') : ''}
            ${SwymStorefrontLayoutContext?.Strings?.savedForLaterTitle}
          </div>
          ${ totalCount?`<div class="swym-storefront-layout-total-list-items-count" id="swym-storefront-layout-total-list-items-count" aria-live="polite">${totalCount} ${totalCount<=1? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items }</div>`:''}
        </div>
        `;
        
        // Apply heading font styles after rendering the HTML using shared utility
        const titleElement = this.querySelector('.swym-storefront-layout-title');
        SwymStorefrontLayoutExtensions?.applyHeadingFontStyles(titleElement);
      }
    
    }
    class SwymStorefrontLayoutSaveForLaterList extends HTMLElement {
      constructor() {
        super();
        this.renderUI();
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForLaterFetched, () => {
          this.renderSFL();
        })
      }
    
      renderUI() {
        let sflData = SwymStorefrontLayoutContext?.sflData || null;
        this.innerHTML = `
          <div id="swym-storefront-layout-items-container" class="swym-storefront-layout-items-container swym-storefront-layout-sfl-list-container">
            ${sflData===null?`<swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType?.WishlistListItem}" buttonCta="${SwymStorefrontLayoutContext?.Strings?.moveToCartCta}" height="100px"></swym-storefront-layout-loader>`:''}
          </div>
        `
        this.initElements();
      }
    
      initElements(){
        this.elements = {
          title: this.querySelector('.swym-storefront-layout-sfl-list-title'),
          itemsContainer: this.querySelector('#swym-storefront-layout-items-container')
        }
      }
    
    
      async renderSFL() {
        const slfListItems =  SwymStorefrontLayoutContext?.sflListItems;
        if (slfListItems?.length && this.elements.itemsContainer) {
          
          const fragment = document.createDocumentFragment();
    
          slfListItems.forEach((item) => {
            const sflItem = document.createElement('template');
            sflItem.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-sfl-item-${item.empi}-${item.epi}" class="swym-storefront-layout-sfl-item ${SwymStorefrontLayoutContext?.getSelectedVariant(item, item?.cprops?.selectedVariantId || item?.epi)?.available === false ? 'swym-storefront-layout-item-sold-out' : ''}"></swym-storefront-layout-item>`;
            fragment.appendChild(sflItem.content);
          });
          
          this.elements.itemsContainer.innerHTML = '';
          this.elements.itemsContainer.appendChild(fragment);
    
          slfListItems.forEach(async (item) => {
            let sflItemElement = document.querySelector(`#swym-storefront-layout-sfl-item-${item.empi}-${item.epi}`);
            sflItemElement?.setData({
              item,
              listItemType: SwymStorefrontLayoutContext?.ListItemType?.SaveForLaterItem,
              sflList: SwymStorefrontLayoutContext?.sflData?.list
            })
          });
          this.elements.itemsContainer.classList.remove('swym-storefront-layout-items-has-empty');
          window._swat?.instrumentV3(SwymStorefrontLayoutExtensions?.InstrumentActionCodes?.StorefrontLayoutSFLItemsRendered, { "utm-term": SwymStorefrontLayoutExtensions?.InstrumentUtmTerms?.StorefrontLayoutUiEngagement });
        }else{
          const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
          const { shouldShowMultiple: sflShouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
          const cartUrl = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/cart';
          const accountUrl = (window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/account';
    
          if (sflShouldShowMultiple) {
            // Multi wishlist – old simple SFL empty state
            this.elements.itemsContainer.innerHTML = `
              <div class="swym-storefront-layout-empty-container">
                <div class="swym-storefront-layout-empty-sfl-container">
                  <div class="swym-storefront-layout-empty-sfl-content">
                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="75" height="75" viewBox="0 0 75 75" fill="none">
                    <rect width="75" height="75" fill="url(#pattern0_1065_979)" fill-opacity="0.8"/>
                    <defs>
                    <pattern id="pattern0_1065_979" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_1065_979" transform="scale(0.00195312)"/>
                    </pattern>
                    <image id="image0_1065_979" width="512" height="512" preserveAspectRatio="none" xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgAAAAIACAYAAAD0eNT6AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAN1wAADdcBQiibeAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAACAASURBVHic7N15nB1VnT7+p6ru1nuS7qQ5JIEgpDuBQIhXhsUBARFRYGRxA0dlFETRUcdlcNQZN1xHZ34/HUVHmVHHZXRGxwX3BUEBFS9LIKRviZKQ5SJkT3ffpZbz/aM7MUt3eru3PlV1nvfrlRcQum89SXdXPffUqXMsrTWIKN7Wr1+/xLKsNQBO1Fov11ovC8PwKK11n9a6AMDRWtsA7PF/WuP/bgGw9v2cW5YV2rbtW5bVsCyrZllW1bKsYQB7LMvabVnWTgBPWpZ1v23btw8MDPxB6I9MRC1msQAQxcPQ0NBCrfVlWuvzwzA8NQzD/jAMO8IwzEn9nNq2rR3HGbFt+0nbth+1LGudbdu/tSzrtoGBgS0ioYioKVgAiASUy+UTtNaXhWF4bhiGq3zfV0EQ5KRzzYRt22Emk9nhOM79tm1/17btLw0MDOyQzkVE08MCQBSBcrlcDMPwtUEQXDB+sc9IZ2o2y7KQyWSGHcdZ7zjOTy3L+vzg4KArnYuIJsYCQNQCruvOC8Pw+iAIXuD7/irf9/PSmSRkMpmG4ziPOo7zQ8dxPjwwMFCRzkREY1gAiJqkXC5fHATBtUEQ/KXneX382TqYZVnIZrOPZzKZ7ziO84GBgYGN0pmITMYCQDQH5XJ5TRAEN3me90xT3+XPxngZ2JbJZL5n2/YHeKuAKHosAEQz5LrugiAI3uv7/osbjUavdJ40yGazO7LZ7I9t237f4ODgw9J5iEzAAkA0Da7r2mEYvsb3/dc3Go3l48/XU5NZloVcLvdYJpP5yIoVKz4pnYcozVgAiI7Add3jfd//TKPROCcIgqx0HpNkMplaLpf7huM4bxoYGHhCOg9R2rAAEE2gXC4Xfd//TL1eL/JnRJZlWTqfz6/NZDJvGxwc/KF0HqK0YAEgOkC5XH6W53mfaDQag/zZiJ9sNrsjl8t91rbtfxoYGGhI5yFKMhYAIgDlcvkqz/M+XK/Xl0pnoak5juPl8/lbHMf524GBAV86D1ESsQCQ0YaGhl7red67G41Gn3QWmrlMJtPI5XI3j88TCKXzECUJCwAZqVwuP6PRaHy10Wgo6Sw0d5lMppbP5z9h2/bbWASIpocFgIzium6/53n/V6/Xz+T3fvpkMplqPp//2IoVK/5ROgtR3LEAkBFc17WDIPhUrVa7NgxDRzoPTc62bdi2DcsaW2rBsqxp/fu+c5nWGo7jPNbW1nbD0qVLvyfwRyBKBBYASr2hoaGXNxqNf/M8r1M6i8ls24bjOIf989Df23dRb5KvAvg7pdSfmvmiRGnAAkCpVS6XT/E87xv1ev0E6SxpN74V8P5fE13cBe0CcCOAzyqleMIjGscCQKm0fv36f63Vam8Iw5BL9jbZvot8Nps96J8JcBeA65VSD0kHIYoDFgBKFdd1lzYajdvr9fpx0lnSIJPJIJfLIZvNIpfLIZPJNHuIPmoegI8BeK9SqiodhkgSCwClxtDQ0N/WarV/CYIgEW9H42Z8i17kcrn9v2zblo7VKn8EcINS6kfSQYiksABQ4rmu2+l53k9qtdoZ0lmSZHznPeTz+f3v8hP+7n42/htjkwQflw5CFDUWAEq0crl8aa1W+5rv+23SWZLAtm3k83kUCgUUCgUTL/gT2Qng5Uqp70oHIYoSCwAl1sMPP/w/tVrt+fwePrJMJrP/gp/L5aTjxJUG8BEA71BKBdJhiKLAAkCJ47puZ6PRuL9erx8vnSWucrnc/ot+Qmbox8XtAF7MWwJkAhYASpRyuTxQr9fv8TyvWzpL3Ni2jba2NnR0dPCiPzePY6wE3C4dhKiVWAAoMcrl8sXVavX/giDISmeJk1wuh46ODt7Tb64AwDsAfISLB1FasQBQIgwNDd04Ojr6Qa01r3AYe7ff3t6O9vZ2vttvre8CeJlSapd0EKJmYwGg2Fu/fv1XR0dHXyydIw74bl/EowCer5S6VzoIUTOxAFBsua6b8zzvN7Va7VTpLNLy+Ty6uro4i19OHcB1Sqn/kg5C1CwsABRLrut21+t1t9Fo9EtnkZTL5dDV1YV8Pi8dhcYeFXyLUupfpIMQNQMLAMXO+MX/D41Go086i5RsNouuri4UCgXpKHS4Dyml/kE6BNFcsQBQrIxf/B9pNBoLpbNIyGQy6O7u5oU//j4H4NVcNIiSjAWAYsPki38mk0FXVxfa2riicYL8H4CrlFJ16SBEs8ECQLHgum7n+LD/IuksUbIsC52dnejq6pKOQrNzG4DnKaX2SgchmikWABI3fvF/xLQJf9lsFvPmzUM2y3WNEu5eAM9RSj0hHYRoJlgASJSpF/997/r5LH9q/B7AhUqpDdJBiKaLBYDEuK7bXq/X/2jSxT+TyWDevHl8nj+dtgI4Vyn1e+kgRNNhSwcgczUajXtMuvh3dnZi4cKFvPin19EAflSpVJR0EKLpYAEgEevXr/96vV4/UTpHFDKZDPr6+tDd3c0h//Q7DmMlYJ50EKKpsABQ5MY39nmBdI4otLW18V2/eU4G8N1KpcJnOinWOAeAIlUuly8cHR39YRiGqX8r3NnZie7ubukYJOe7AK5QSvnSQYgmwgJAkXFd99jR0VE3CILUvx3u7u5GZ2endAyS93kAr1BK8URLscNbABQJ13Vz9Xq9ZMLFf968ebz40z7XAPiwdAiiibAAUCQ8z/tto9Holc7RSpZlobe3F+3t7dJRKF7eWqlU3iodguhQLADUcuvXr/+vWq22WjpHK9m2jd7eXm7bS5P5cKVSuUY6BNGBOAeAWqpcLl86MjLynTR/nzmOg97eXmQyGekoFG8+gGcppX4hHYQIYAGgFnJdt1CtVrf7vp/aMfFsNosFCxbAcRzpKJQMfwKwRilVkQ5CxFsA1DK+7/8ozRf/fe/8efGnGegH8LVKpcLhIhLHAkAtUS6XX1qtVs+RztEq++752zZ/hGjGzgbwQekQRLwFQE3nuu68arX6J9/3U/nI377Z/lzdj+bocqXUt6RDkLn49oWazvO8n6f14g+Au/lRs3y+UqmcIB2CzMUCQE01NDT0xlqttkY6R6t0dnairY1LvFNT9AD4X+4ZQFJYAKhpXNdVtVrtn6VztEoul+Pa/tRsqwF8UjoEmYkFgJqm0Wj8PAiCVM5utm0b8+fPl45B6fQ3lUrlFdIhyDwsANQU5XL5BfV6fYV0jlbp6enh437USp+sVCqnSIcgs7AAUFM0Go1PSWdolY6ODt73p1YrYGxSYCpH0CieWABozoaGht7caDT6pHO0guM4vO9PUVkD4O+lQ5A5uA4AzYnruna1Wt3j+36HdJZWWLBgAQqFgnQMMkcdY0sFr5cOQunHEQCakyAI/iWtF/9CocCLP0UtD+A/KpUKz83Ucvwmo1lzXbe9Xq/fIJ2jFSzLQk9Pj3QMMtMZAN4gHYLSjwWAZi0Igs8HQZCVztEKnZ2dnPVPkm6qVCrHS4egdGMBoFkZX/TnSukcrWDbNjo7O6VjkNnaAXyuUqlY0kEovVgAaFZ83//vMAxT+f3T2dkJy+J5l8SdC+DV0iEovfgUAM1YuVw+ZWRk5IE0fu/Yto3+/n4WAIqLvQBWKaUekw5C6ZPKd3DUWr7vfzWNF39gbNEfXvwpRroAfEY6BKUTCwDNSLlcvrBWq50onaMVbNtGR0cqn2ikZLuoUqlcLB2C0ocFgGbE87x/l87QKu3t7bBt/khQLP1zpVLhYynUVDzb0bSVy+UVjUbjWOkcrdLe3i4dgWgyKwFcJx2C0oUFgKYtCIJ/Tuu9/1wuh0yG+7BQrL2nUql0SYeg9GABoGlrNBoXSmdoFb77pwRYBOBG6RCUHiwANC1DQ0N/GwRBTjpHK1iWxe1+KSneVKlUlkiHoHRgAaBp8X3/jdIZWqWtrY2P/lFStAF4v3QISgcWAJqS67rHNhqNp0jnaBW++6eEeWmlUlkjHYKSjwWAppTmyX+WZSGXS+WdDUovC8BHpUNQ8rEA0JQajcal0hlaJZfLcfifkuj8SqVyiXQISjYWADqioaGhl/u+X5DO0SqFQmr/aJR+H+JugTQXLAB0RL7vv006Qyvl83npCESzdRKAv5IOQcnFAkCTcl23v9FoDErnaBXHcbj4DyXdP0gHoORiAaBJBUHwEa11aocY+e6fUuD0SqVynnQISiYWAJqU53lXSGdopWw2Kx2BqBk4CkCzwgJAEyqXy1d4ntcpnaOVOPxPKfGsSqVSlA5BycMCQBPyff/N0hlajSMAlCKpnqxLrcECQBPyfT/VK43Ztg3b5rc/pcYVlUplQDoEJQvPgHSYcrlc9H0/1evjcvifUsYGdwqkGeJZkA4ThuEbpDO0GgsAJUW1WsWWLVsAjO1bkc/n0dbWhkKhAMdxDvzQv65UKu9SSm0WCUqJw7MgHcb3/QukM7Qa7/9THGmtMTQ0hD/84Q/YtGkTNm3ahO3bt0/68UcffTRWrVqFk046CcuXL885jvNmAH8XXWJKMiutm7zQ7Liu2zk8PLwnzc//A0Bvby/XAaDYqNfruPvuu/Gzn/0MTzzxxKxeI5/PY8WKFcGSJUuOv/766zc2OSKlEEcA6CBhGN6Q9os/wFsAcxEEAR5//HFs3rwZW7ZsQRiGyOfzKBQK+4emOzo6cNxxx3GvhSns3r0bP/nJT/CrX/0K1Wp1Tq9Vr9fxwAMPOO3t7R8CcFVzElKa8SxIBwmC4MXSGVrNsqxD753SEWitsXbtWqxduxabNm3C1q1b4XnelJ/nOA6WL1+OVatWYdWqVVBKRZA2OdatW4f/+I//wPDwcFNfd+PGjandvZOai7cA6CAPPPDAaNqfAMjlcujr65OOEXvVahV33303fv7zn+PJJ5+c8+v19vbizDPPxIUXXmj07ZcwDHHrrbfi+9//Plp1/r3gggsuf/3rX/+tlrw4pQZHAGg/13VV2i/+AIf/p7J9+3b89Kc/xV133YVardbU17311lvxy1/+EpdddhnOPPNMWFbq7zYdZM+ePfjc5z6Hcrnc0uNs27btnQBYAOiIOAJA+w0NDf39yMjIh6VztFp3dzc6O1O9yvGs/fa3v8WXvvQl1Ov1lh/rmGOOwQtf+EIsX7685ceKg3q9jo985CPYvLn1T+l1dnaGl1xySdfVV1892vKDUWJxISDaLwzDi6QzRIEjAIfzfR9f/vKXccstt0Ry8QeAxx57DB/96Efx1a9+tWVD4XGhtcYXvvCFSC7+ADA8PGxv3br1HyM5GCUWz4S0XxAEJ0tniAILwMGefPJJfOYzn8GmTZtEjv+LX/wCo6OjuOaaa1I7OfP73/8+SqVSpMfcsmXLNeBOgXQEHAEgAIDruhnP83qlc0QhrReZ2Xj00Ufx/ve/X+ziv89vf/tbfPrTn4bv+6I5WmHt2rX47ne/G/lxN2zYcNTNN9+8KvIDU2KwABAAQGt9iQnP/1uWZdzEs8ns3r0bN99885yfP2+WtWvX4hOf+ERktyCiEIYhvv71r4vc4giCANu3b/9g5AemxGABIABAGIbPl84QBe4AOMb3fXz605/G7t27paMcZGhoCJ///OelYzTNfffd15RHKGfr0UcffZbYwSn2eDYkAEAQBKdJZ4gCC8CYL3/5y/jjH/8oHWNC9957Lx544AHpGE3xox/9SPT4Tz75ZP7jH//4K0RDUGzxbEgAgCAIFktniAILAHDbbbfhrrvuko5xRF/5yldic2titsrlMjZulF+S//HHH3+zdAaKJ06HJriuawdB0C6dIwqmF4BarYZvf/vb0jGmtGvXLnzrW9/CVVcld0n7X/3qV7P+XNu2oZTCMcccg6VLl2Lp0qVYvHgxtNaoVquo1WoYHR3F8PAw1q1bh7Vr12Lv3r0TvtYjjzyy8pZbblnwyle+csesA1EqsQAQtNZnmTABEGABuOOOOxLzzvr222/H6aefjqc85SnSUWZlNk9W5PN5nHPOObjgggswb968CT/m0EWsisUiwjDEI488gvvuuw/33Xcfdu7cuf//12o1a9u2bTcBuGHGgSjVWAAIWusLpDNExeQCEAQBfvrTn0rHmDatNW677bZEFgDf9/GnP/1p2h/f2dmJ888/H+eddx7a22c+GGfbNgYGBjAwMIDnP//5uOOOO/Cd73wHo6NjCwFu3rz5xWABoEOYezak/cIw/AvpDFExuQD8+te/jt2s/6k8+OCDCIJAOsaMVSoVhGE4rY8977zz8MEPfhAXX3zxrC7+h3IcB+eddx5uuukmnHvuubAsC4899tj8m2+++S/n/OKUKhwBIIRhOCidISomF4Bmz0jv6OjYf286k8mgWq1idHQU9Xod1WoVO3fuxPbt2+d0jGq1iqGhIZx00klNSh2N6Sz5a9s2XvSiF+Hcc89tSYaOjg5cddVVOPHEE3HLLbfgiSeeeB+A81pyMEokFgBCEARHSWeIiqkFYMeOHTMakp7I/PnzcdZZZ2HZsmVYsmQJFixYMOXnbNmyBffddx/uvfdebNmyZVbHvf/++xNXAKbaRTGfz+O6667DySe3fvXt1atX461vfSu+9KUvnfmWt7zF/uhHPzq9oQlKPRYAw7mumzHlCQDA3AIw24svABx11FF49rOfjdNPP33GyygvXrwYixcvxiWXXIInnngC9913H375y1/OaHGcBx54AFdffXWiVnCcbAIfMFakXve612HJkiWR5Vm6dCle85rX5Ddv3nwFgP+N7MAUaywAhtNa/0Xad2I7EAvA9B133HF49rOfjVNPPbUpF99Fixbh2c9+Ni644ALcfvvtuPXWWzEyMjLl5+3evRsjIyOJ2sJ5sgLQ09ODt73tbUcsCK0yb948zJs37xlgAaBxLACG01qfIp0hSiwAU2tra8NLXvISnHZaaxaHdBwH559/Ps4880x87Wtfw9133z3l5yRtk6Cenp7Dfs9xHFx33XUiF/8DXAzgbyUDUHyYeTak/bTWxkwANHkjoOkWgGOPPRbveMc7WnbxP1BbWxuuueYaXHPNNcjlckf8WM/zWp6nmXp6eg67XXLZZZdh+fLlQon2O65SqZwoHYLigQXAcFrr46QzRMXUiz8ADA8PT/kxq1evxo033oiFCxdGkOjPzjzzTLz97W9Hb+/ku1EnbQTAcRycfvrp+/97+fLleNazYrMvz8XSASgeWAAMp7WObiaSMFOH/wGgu7v7iP9/zZo1uP7662c8ya9ZlFJ485vfPGkJSNoIAABccMHY+lq2bePFL35xnAroJdIBKB7MPSMSAEBrHe3bPUEmF4CJ7knvs2bNGlx33XViF/99ent7Jy0BHR0dAonmZvHixVi5ciXOPvvsSGf8T8NZlUpFdCICxYO5Z0QCAIRhaMyJwOQCMNkIwOLFi/GKV7xC/OK/z74S0NXVtf/3jj766CPeHoizSy65BM973vOkYxwqA+Ai6RAkz9wzIgEAwjA0Zg0Ak00087ytrQ3XX3/9lBPwotbb24trr712f2E75ZTkPqhywgknxHX0gvMAiAXAZK7r2mEYGvMoaIzuwUZu8eLFh/3ey1/+cvT39wukmdqKFStw2WWXARibnEhN95xKpcLzv+GMOfnT4bTWAyYtAmRyAVizZg3mzZuHXbt2AQCe9rSnYc2aNcKpjuzCCy/Etm3bcNxxxjyoEqVeAGcAuEs6CMlhAzTbsdIBomRyAXAcB8985jMBANlsFldeeaVwoqlZloWXvOQlRn/dWoxPAxiOBcBgWuujpTNQdM4++2wUCgVcdNFF09rIh1KP8wAMxwJgNiUdIEqmv5Nsa2vDpZdeigsvvFA6CsXDKZVKZal0CJLDAmAwrfUi6QxRMr0AAGOL08Rt1j+J4iiAwVgAzNYnHYCIRHEegMFYAAymtTbqRjBHAIgOc36lUmmTDkEyWAAMprU2ZhVAgAWAaAJtAM6SDkEyWAAMprU+8g4xRGSCp0sHIBksAGbrlA4QJY4AEE2IIwCGYgEwmNbaqH0AWACIJnQmlwU2E7/oBtNaF6QzEJG4bgCrpENQ9FgADBaGYV46Q5Q4AkA0Kd4GMBALgMG01kZtBsUCQDQpTgQ0EAuAwbTW/PoTEcACYCReAAy1fv36LpO2AgY4AkB0BMdVKhWj9gYhFgBjWZZ1jHSGqLEAEB0R5wEYhgXAXEukA0SNBYDoiHgbwDAsAOY6WjoAEcUKRwAMwwJgLt7vI6IDPZUbA5mFBcBQWutF0hmIKFayAE6TDkHRYQEwlNa6TzoDEcUObwMYhAXAXAukAxBR7HAioEFYAAyltZ4nnYGIYuesSqXCx2UMwQJgKK11t3QGIoqdBQCOlQ5B0WABMJTWulM6AxHFEncGNAQLgKG01u3SGaJm2tLHRLN0snQAigYLgKG01nzel4gmwhEAQ7AAGEprnZPOQESxxAJgCKP2g08r13ULWuunY6zQVSzL2jowMLDjSJ+jtebXnogmsqJSqWSUUr50kMmUSqU8gO7xXxkAG4rFYl02VfJYvC+aPOVy+awgCD4UBMFAEAQLgiDITvRxtm0HmUzmCcdx1tq2/SPbtr8yMDDwJwC49957tWlf+4ULFyKbnfCviogOdqJSar10iPEL/RoApwM4A8BfYGwjs0NHMEMAjwFwATwE4D+LxeJDEUZNJBaABBkaGvo7z/Pe0mg0Zr2RTzabHc5kMr9oNBqXBEHQzHixxwJANG0vVEr9j8SBS6XSfABXAHgxgHNw+MV+um4D8HEA3ykWi2GT4qUKC0ACuK57fL1e/02j0eht5utms1lYlgXf9xGG6f/5YAEgmrb3KqXeFdXBSqVSB4DnYeyi/2zM/qI/kXsBXFEsFjc28TVTgZMAY65cLl8xOjq6vtkXfwDwPA++72PhwoXo6emB4zjNPgQRJVMkEwFLpVJ/qVS6CcAmAF8GcCmae/EHgKcC+F2pVHpmk1838TgCEGNDQ0MfHB0dfVsrv0Y9PT3o6OjY/9/VahXDw8PwPK9lx5TCEYD4CMMQIyMjGB0dPeifIyMjqFarh41IHfgzMNHPw3R+z7IOX+F2qt879P9bloX29nZ0dHTs/+eB/27bqXlP9Xul1ECrXrxUKi0H8BYALwNQaNVxDhEAeHOxWPz/Izpe7LEAxFS5XL5sZGTk/1r59XEcB4sWLZrwJFiv1zE8PIx6PT0Ta1kAoheGIbZs2YINGzZg48aN2LBhA5588knUajXpaC1RKBTQ19eHZcuWYdmyZTj22GOxePHiJI6uhQA6lVLVZr5oqVQ6DcDbAFwGuRHoS4vF4q1Cx44VFoAYcl23r1qtbvZ9P9/K43R3d6Oz88grAtfrdezZsycVIwIsAK3neR7Wrl2LRx55BBs2bMCmTZtS8b0zF9lsFkuWLMGyZctw/PHHY/Xq1cjlErEMR1EpdW8zXqhUKh0L4EMYu8cvbTuA1cVicYt0EGksADH00EMPDdXr9cFWHsOyLPT39097yHJ0dBR79uxJ9GRBFoDWefTRR3HnnXfid7/7HarVpr5pTJ1CoYBisYinP/3pOP7446XjHMnLlVJfnMsLlEqlLgBvB/BGRDfUPx23A3hmsVg061GoQ3AxmJgZGhq6qdUXfwBob2+f0f3K9vZ2tLW1YXh4GMPDw1xXnwAAlUoF3/jGN/Dggw9KR0mMWq2GO++8E3feeSdOPPFEPP/5z8fixYulY01k1hMBS6WSA+BaAO8FsKhpiZrnGQDeDOAj0kEkcQQgZtauXTvseV7H1B85N/39/bO+LxkEAXbv3p24+7h9fX1JGXqNPd/38b//+7+4/fbbEz0qFAeWZeHss8/GC1/4wriNUP1AKfXcmX5SqVQ6E8C/I/5LCj8B4BiTVxDkCECMDA0NvTqKi3+hUJjTpCTHcbBgwQJUq1Xs3r2bFwDD7NmzBzfffDP++Mc/SkdJBa017rjjDmzcuBGvfvWrsWDBAulI+8zoAl4qlXIA3gPgrQCSMOtxEYC/BnCLdBApqXlmJQ08z3tnFMfJ55szt7CtrQ0LFy5s2utR/D3++ON4//vfz4t/C2zcuBEf+MAHsGnTJuko+yytVCpHniU8rlQqnQrgdxib4Z+Ei/8+b5QOIIkFICbK5fI5jUYjkhuBzbxgO46D3t5e9PT0TPg4IaXH3r178YlPfAK7du2SjpJae/fuxb/927/F6e942ZH+Z6lUckql0jsA/BbAyZEkaq5VpVLpQukQUlgAYsL3/UgmoziOg0ym+Xd+Ojo6sHDhwljfY+d8l9nzPA+f+tSnsG3bNukoqbdr1y588pOfjMsaHMsm+x+lUmkQwF0AbgIQq8kLM/Ra6QBSWABiwvf9SNpzK4frM5kM+vr60N3dzdGAlPnhD3/IYf8IPfbYY/je974nHQOYoACUSiWrVCq9EcB9GNudL+meUSqVjLwWGvmHjhvXdZXv++1RHCuK+/WdnZ2xfOaeIwCzs2vXLvz4xz+WjmGcn/3sZ9i+fbt0jGUH/kepVFoG4OcA/hVAm0CeVuhB/J9YaAkWgBgIw/CaqI4V1YS9TCaDhQsXoqurK5LjTQcLwOx861vfQqPRkI5hHN/38c1vflM6xrJ9/1Iqla4FsBbAuVJhWugvpQNIYAGIgTAMZ/ys7Wxks9nINyvp6urCwoULWzLvgFpveHgYv/nNb6RjGKtUKklPCFxWKpVUqVT6HoDPAohPo2+up0sHkMACEAO+70cy/CT1uF42m8XChQsP2nVQAkcAZu7ee+/lOg+CtNa45557JI8/AOAhAJG8SRHEEQCKnuu6Od/350VxLMnn9S3LQk9PD+bNmyc2QZAFYOZ+97vfSUcwnmQBsCyry7Ks2KxM1ELHlEqlo6VDRI0FQJ6K6sIUh0l57e3t6OvrS+L2qMYZGRmB67rSMYy3ceNG0cmABv2s9ksHiBoLgDCtdSTt2rKsyO//T2bfLYGo1wzgCMDMbNy4kX9nMbFx40axYxs0f0f2HqWAeFwRzBZJAYhbi7dtG319feLzxnC38QAAIABJREFUAmhyMVqS1nibN28WO3bczh0tZNzJiAVA3vwoDhLXFh/lvAC+m50ZyYsOHYwFIBLT2vcgTVgAhGmtI5kAGOcf4qjmBbAAzAwLQHxs3bpV7NhxPnc0GUcAKHI9URwk7j/EUvMCaHJ79+6VjkDjJL8WcR09bAEWAIrcnigOEpcJgEfS6nkBHAGYmVqtJh2BxtXrdbHv37i/eWgi477h439VSDnLsiJ50DpJm/O0al4AC8D0hWEIz/OkY9A4rbXYcsy2bSfq/DEHco9aCGEBEGZZ1gNR/HAl7QeY6wXI4rv/+JH8mhjyc7hBOkDUWACEDQwMhLZtt/ytVtIKADA2L6Cvr69p9yA5AjB9MdmLng4g+TUxoAAEAIx77pUFIAYcx4lkHkASOY6Dvr6+pkwOZAGYvjisGkkHk/yaJGEO0RxtLRaLxt3zSv1XNQksy3oygmO0+hAtY9s2ent70daWlu3H469QKEhHoENIfk0MGAHYIB1AAgtADNi2/cdWHyPJBQAYyz9//vw5PSHAEYDpy2QyJrzrSxTJzbwM+F54RDqAhNR/VZPAtu1vtPoYabn49fT0oLu7WzqGETgKEB/ZbFb0ImxAAbhdOoCE1H9Vk8C27S/Ztt3SK3Sa9nTv7OzE/PnzZzyqkZYSFBXecokP6TJmQAH4iXQACan/qibBwMBAI5PJtHStzzQVAGDs4rRgwYIZlQAWgJnp7e2VjkDj+vr6RI+f8gKwrlgsyq21LCjVX9UkyWQyv2jl66etAABj90S5VkDrHHXUUdIRaFx/v+xW9SkvAEa++wdYAGLDtu3PtvL10/rudyZrBaT176BVlFLSEWicdAFIeclmASBZg4ODtzuO07LnUNM4ArDPdNcKYAGYGY4AxIf018KyrMQ/STSJBgydAAiwAMRKNpt9oFWvneYCAPx5rQDpyVJpwhGA+JAuAEBqbwP8pFgsjkiHkJLKr2hSZTKZd7XqtdNeAIA/rxUwWQngCMDMzJ8/nyUgBubPn4+jjz5aOkZaC8C/SweQZMxGz0kwODj4/bVr1+72PK+n2a/t+36zXzKW9pWAnTt3HrZ5CgvAzJ166qmoVCrSMSaUhYWjrSyORQ7HWDkstDJoh412WGP/tGy0wYYFYBQhRnWIKvTYvyPENu3jMTSwUTewRXtoIJ7fH6tXr5aOACCVBWALgO9Jh5DEAhAz2Wz2vz3Pu77ZrxsEAbTWab2PdxDLsrBgwQLs3LkT1WpVOk6irV69Gj/4wQ+kYwAAuuBgjdWGU+w2HIsclJWBg+l9P3fDQbd1yES2Az41BPC49rARDTyoq7g3rGI3guaFn4NTTz1VOgKAVBaAW4rFYjy+yEJYAGLGcZy327b9qjAMm36l9jyvKZvqJMX8+fMBYH8J4AjAzC1btgw9PT3YvXu3yPGXWFk81WrHU612DFj5aV7uZ84GcLSVxdHI4kyrA9oG/qDrKOlRlHQVm3SjRUc+svb2dgwMDIgc+1ApKwAhgFukQ0hjAYiZgYGBHevWrXuwVqud0uzX9n3fqAIATFwCTBgFaRbLsrB69WrccccdkR0zBwtPtztxkdWFYyyZ71cLwAlWHidYebwI87FZe/ix3oM7wmHUI7xVcPLJJ8fmEby45GiSHxSLxcekQ0hLVaVLi0wm855WvK4p8wAONX/+fC5rOwdR3YPuQwZX2/PxycxSvMruFbv4T2SJlcUr7F58KrMUL7MX4Cgrmq154zL8D6RuBMDoyX/7cAQghgYHB7/54IMPPtloNBY283U9z7jtrvfbNxLAEYCZW7FiBfL5POr1ektevw8ZXOXMxxlWR+zfkbTDxnPsblyEbvxOj+Ir4U48rlvzc5XJZHDSSSe15LVnI0UFYB2AW6VDxEFqvqJpk8vl3tTs1zR1BGCf2WwgRK27EOVh4YX2PPxLZjHOSsDF/0AWgNOsdvyzczSutuejrQXpV65cKboF8KFSVADeXSwW0/9c9DSk5iuaNoODg1/K5XJN3aBi35MAJmMBmJ1mDkVbAM6xOvGvmSW43J6HbMum9rVeBhYutXvwr5nFOM/ubOqfJE7D/0BqfnYeANDy7deTggUgxnK53N82+zUbDZnZzJRsp556Krq7u+f8OvPg4B3OUXiN04f5SM+ksh44eJXdh3c5R6G3CXdWOzo68LSnPa0JyZonJQXgXcVi0ex3QQdgAYixwcHBb+bz+abOVGUBoNnI5/O49NJL5/Qap1pt+HDmaJxkpXe55kGrgA9njsZpVvucXufiiy+O3bLWKSgApWKx+G3pEHHCAhBz2Wy2qYsCtWoiF6XfX/7lX85qVzoHFl5iz8ffO/3oTtG7/sl0wMabnEV4hd07q9sbvb29eMYzntGCZHOTggLwT9IB4oYFIOYGBwd/mM/nf9+s12s0GkbsC0DNZ9s2Lr/88hl9TjccvNs5CpfYPQm+0z87z7K7cJOjsGCGtwQuu+yyaW1vHbWETwK8u1gsfl86RNwk+itqimw2e4Vt2027b8XbADRba9aswVOe8pRpfewiK4P3OEfhBCs+M9mjdoyVw3szR+Hoaa4bsHTpUpx22mktTjV7CR0FCAC8TjpEHLEAJMDg4OBDhULhf5r1erwNQHNxxRVXTPkxx1o5vMdRkS2YE2e9yODdzlE4fhpF6Morr4z1RTbO2Y7g5mKxeK90iDhiAUgIx3FekslkRpvxWiwANBfLly/HKadMvlL1SquAf3KOwjwD7vdPVxccvNPpx8nW5CtSrly5EitXroww1cwlsAA8DuCd0iHiigUgIQYGBvx8Pn9DM17L930EgdGbYNEcXXHFFRPeEx608vgHpx/tPLUcpgAbf+8smvApCMuycOWVVwqkmpkEFoA3F4tFmZ2sEoA/pQmyYsWKLxQKhXXNeC3OA6C5UErh7LPPPuj3jrKyeIvTn+iFfVotAwtvchZhySG3Rs4880wsXbpUKNX0JawA3FYsFr8iHSLOWAASJpvNXmzb9pyn8fM2AM3VC1/4Qhx33HEAgE7YuNFehE6eUqbUDhs3Ov37b5Ecc8wxuOqqq4RTTU+CngRoAGjKiGmaJearSWMGBgY2FgqFm+f6OtVq1fhlgWluMpkMbrjhBiyaPx9vcfo54W8G+pDBjU4/Fnb34IYbbkjMNt0JGgH4cLFYHJIOEXcsAAm0cuXK1+Vyuc1zeQ2tNWq1WrMikaG6u7vxpmc/D4MGP+o3W8usHN587nP271SZBAkpAPcCeJ90iCRgAUioXC53/lxvBYyONuWhAjLc/PPOxMZTlknHSJxNg4sx/+LzpGPMSAIKQA3AS4vForl7n88AC0BCDQ4O/r6tre1dc3mNer3OVQGpKea/6ipsVD3SMRJjU18nel73UukYM5aAAvC2YrH4sHSIpGABSLAVK1bcNNenAjgKQE1hAfNufBU2d8RvCdu4qbQ56Hn79YAd+4vpYWJeAH4G4OPSIZKEBSDhstnsuY7jzPqZvmq12sw4ZDArm0HbP7wKf8pwculknnQ0sjdeC+STMenvUDEuALsAXMOtfmeGBSDhBgYGthUKhVfP9vM9z4Pn8XYZNUd2fg/0O16FzfnYXijEbM1Z8P7hlcgtXCAdZdZi/Bjga4vF4pwmRpsotl9Nmr4VK1b8Z1tb209m+/kcBaBmal/Uh873vxGPzYvXfvaSNnfn0HbT69GpZr6dMk3pv7jgz+ywAKREJpO5KJfLbZ3N53IeADWb3VbAvPe+AZuX9klHEbfl6Pnoft8b4XS0S0dJo3sBXC8dIqlYAFJiYGAgzOfzT81kMjNe4i8MQ64MSM3n2Oi+8TpsfdoATLwxqwFsPfV4dL39eiDDjZFaYBuAK4rFIocwZ4kFIEUGBgb+VCgULrUsa8bn25GRkVZEItNZQOffXImtL70Ie2xzasCIpbHlxReg87oXAvGdODdjMZoEGAB4UbFY3CgdJMlYAFJmcHDwJ+3t7e+d6efVajX4vt+KSEToOmMNav90PR7pSP874Q1tNkbecS26zz5NOkqavbVYLP5cOkTSWVwPPp0efvjhn1Wr1fNn8jltbW2JWpaUkicMQmz5j69h+f2PIpeyXQN9aPz+xKVQr74atpPOojM6Oopdu3ZJx/hKsVh8iXSINGABSCnXde16vb650WiomXxef38/nJSevCg+vCe2Y+9nv45jt+5KRQ14rL8bHdc+H9mj0z3Lv1qtYufOnZIR7gdwFu/7NwcLQIq5rquq1eoG3/envepIR0cHenq4pCtFo/7wIwi/+B30703mJNRtHTmEVz8XhVNXSkeJhHAB2A7gacVicYNUgLRhAUi5crl80cjIyPe11tN6o2VZFvr7++O84Ael0Ohtv4b1vV+iv5qMeSjbCg78C89C+4VPT9Ukv6kIFoAAwEXFYvGnEgdPKxYAAwwNDb1vZGTkndP9+K6uLnR1dbUyEtGEnvzVPWjc+gsM7vVjN0NZA3A7bDjPOQeLzjtTOo4IwQLw1mKx+FGJA6cZC4AhHnroobBer0/rrYpt2+jv74/TIz9kmNqWxzHy7Z+h192Mbk92x8q9GQvbli9G26Xno/3YxaJZpNVqNezYsSPqw/53sVi8KuqDmoBbdxnC8zxks9lprfsfhiFGRkbQ2dkZQTKiwxUWH4XCDWMTvXdv2Ipdt92NwvoNWDTSaPmkQQ3gyfYsRlcci55zz4Bz/FL0tviYNKm1AF4pHSKtOAJgiFKppC3Lgm3bCIJgyo93HAeLFi3iKADFy6692H7HbzD88O+Rf3I3FtYDzNdzu1mw2wrxRN5Gra8HHStPQN8zzgDmdzcpcLpEPAKwA2OT/h6N6oCmYQEwgOu6i/bu3fsnYOzCHoYhpvN1nzdvHtrbuX45xVt12w7sefj3qG7aimDvCKxqHXa9AafuIdPwAWj4uSyCXAZhIQ9dyMHp6kDbEoXOlSego3+h9B8hMSIsAAGA5xaLxR9HcTBT8RaAAbTWR+/79yAIpn0rYHh4GG1tbRwFoFhr61uAtnNOl45hhAjPBa/lxb/14jbRllrjqAP/w/M85HJTLw3g+z73CCCiqL2nWCx+RjqECVgADKC1Pmx5skajgXw+P+XnDg8PIwxlZ2ETkTE+WywW3y0dwhQsAGaY8CZnvV6fciQgDEPs3bu3JaGIiA7wbQCvkQ5hEhYAM/RN9j8ajcaUJWBkZGRacwaIiGbpTgBXFYvFqR9RoqZhATCA1vqIjzHvWyPgSPbs2dPUTERE4x4GcCk3+IkeC4ABtNYLpvj/8H0fmczkD4XU63XUarWmZyOi5GjBY+ObMbbGv+gWg6ZiATDDlNv7aa0RhuERtwLes2dPK04ARGSmnRi7+G+SDmIqFgADaK2ntbPPvtn+k+0EyMcCiczWxDcANQB/VSwW1zXrBWnmWAAMoLWe9qL+QRDAcZxJF/zgY4FENEcBxib8/Uo6iOlYAMzQMZMP9jxv0vkAfCyQyFxNGgF4bbFY/FYzXojmhgXAAFrrtpl+zpFWC+RjgUQ0S1zlL0ZYAAygtZ56yb8JHGmNgN27d88pExElzxxHALjKX8ywABhAaz31wv+TmGzJ4EajwQmBRDRd3wBX+YsdFgADaK2PvMrPFCZbMnjPnj3wfX8uL01ECTLLEYDvgav8xRILgAG01pM/3D9NE90O0Fpj165dc31pIkqvnwC4slgsctJQDLEAGCAMw6Zs4j1RCWg0GhgeHm7GyxNRzM1wBOB2AJcVi8V6i+LQHLEApJzrupNuBDQbE5WAvXv38lYAER3obgCXFIvFUekgNDkWgJTTWh/X7Nc8dPMgrTV27uRS3kRpN80RgBKA5xSLRQ4NxhwLQPo9pdkvuG/zoANLgOd5XCCIiNYCuLBYLPI54QRgAUg5rfXSFr3uYSVgeHiYCwQRpdgUIwDrATyrWCzuiCgOzRELQMpprRe38LUP2kZ431MB3DGQyDiPAHhmsVh8QjoITR8LQPod1coX37eN8L4S4HkenwogSqlJyv0GAOcXi8VKtGlorlgAUk5rvbDVxwjD8KASsHfvXt4KIEqhCXYC3YKxd/6bBOLQHLEApJzWekEUx9lXAhxnbM2hnTt38lYAUcoc8jP9OMbe+f9RKA7NEQtAymmte6I61r53B47jwPd97NmzJ6pDE1EEDhgB2AbggmKx6ArGoTliAUg5rXVXlMcLgrHlvh3HwcjICKrVapSHJ6IWGh8B2Imx2f7rhOPQHLEApJzWui3qY+4rAbZtY9euXVwlkCglwjDcC+CiYrF4v3QWmjsWgJQLw/DwvXwjEAQBLMuCZVnYsWMH5wMQpYBlWc8rFou/lc5BzcECkHJa64zUsfeVgDAMuVQwUfL5p5566m3SIah5WABSzHXdXLN2ApytIAhg2zZ3DSRKPrb4lGEBSDGtddP3AZgN3/fhOA6Gh4fRaDSk4xDR7HB9/5RhAUi3WBQAYGyFQMdxsHPnzv2TBIkoUVgAUoYFIMW01sdIZziQ53n7nwzgpECixGEBSBkWgHRbIh3gUJ7nIQxDbh1MlDwsACnDApBiWmslnWEinueh0WigVqtJRyGi6WMBSBkWgBTTWvdLZ5jMvqcCuEgQUWJwbe+UYQFIMa11r3SGI2k0GtizZw/nAxAlA0cAUoYFIMW01vOlM0ylVqth165d0jGIaGosACnDApBiUW8ENFvVapU7BxLFHwtAyrAApJjWulM6w3QNDw/zyQCieGMBSBkWgBQLwzDynQDnYu/evRgZGZGOQUQTYwFIGRaAFAvDMCudYaZ2796N0dFR6RhEdDgWgJRhAUgp13VVUmfX79q1C9VqVToGER2MBSBlWABSSmt9snSGudi1axcXCiKKFxaAlGEBSCmt9QrpDHOhtcbOnTu5eyBRfPBRnZRhAUipuGwFPBdaa2zfvh2e50lHITKdr5TiDN2UYQFIKa31sdIZmmFfCeCSwUSi+O4/hVgAUkprfZR0hmYJw5AlgEgW7/+nEAtASmmtF0pnaKYgCLB9+3YEQSAdhchELAApxAKQUlrredIZmm1fCQjDUDoKkWlYAFKIBSClwjDskM7QCr7vY/v27dxBkChaLAApxAKQUmEY5qQztIrnedi5c6d0DCKTsACkEAtACrmu2x6GYaq/trVajZsHEUWHBSCFUn2RMJXW+iTpDFHYu3cvlwwmigYfA0whFoB0SvQqgDOxa9curhZI1HocAUghFoAU0loPSGeIitYaO3bs4OOBRK3FApBCLAAplJZVAKcrDEPs2LGDTwYQtQ4LQAqxAKSQ1nqJdIao8ckAopbaJh2Amo8FIIW01v3SGSTUajXs2cO5SkQtsEU6ADUfC0AKhWE4XzqDlOHhYYyOjkrHIEqbrdIBqPlYAFJIa90lnUHS7t27+WQAUfOMKKU4ByCFWABSKAzDgnQGSXwygKipOPyfUiwAKeO6bi4Igox0DmlhGHJSIFFzcPg/pVgAUkZr/TTpDHHRaDQwPDwsHYMo6TgCkFIsACmjtS5KZ4iTvXv3wvM86RhEScYRgJRiAUgZU/YBmC6tNXbt2sVFgohmjyMAKcUCkDJa6xOkM8SN53ncOZBo9jgCkFIsACkThqFxqwBOx/DwMHzfl45BlEQcAUgpFoCU0Vr3SWeIK64SSDQrLAApxQKQMkEQGL0I0JHUajXU63XpGERJogFUpENQa7AApIjrunYYhjnpHHHGUQCiGdmmlOKyminFApAiWusTOdv9yDzPQ7ValY5BlBScAJhiLAAporU+TTpDEoyMjEhHIEoK3v9PMRaAFNFanyydIQkajQbXBSCaHhaAFGMBSBGt9XLpDEnBjYKIpoW3AFKMBSBFtNbHSGdICo4AEE0LRwBSjAUgRcIw7JfOkBQsAETTwhGAFGMBSJEwDHukMxBRqnAEIMVYAFIkCIK8dAYiShUWgBRjAUgJ13WXaq0t6RxElBoNANukQ1DrsACkhNb6dOkMSWJZ7EpEU6gopThZJsVYAFJCa32qdAYiShVOAEw5FoCUCMNwUDoDEaUK7/+nHAtASmitl0lnIKJUYQFIORaAlAjDcKl0hiThHACiKfEWQMqxAKREEAQLpDMQUapwBCDlWABSwHXdziAIstI5iChVOAKQciwAKaC1Pk86AxGlDkcAUo4FIAW01mdLZyCi1GEBSDkWgBQIw5BrAMwQJwESHdEepdSIdAhqLRaAFAjD8HjpDESUKnz3bwAWgBQIgoDbABNRM7EAGIAFIAWCIGiXzkBEqfJH6QDUeiwACVcul9dwF8CZ4xwAoiN6RDoAtR4LQMJprc+XzkBEqcMCYAAWgITTWp8mnYGIUocFwAAsAAkXhuEK6QxElDp/kA5ArccCkHBhGC6RzkBEqbJVKTUqHYJajwUg4YIgmCedIYk4CZBoUhz+NwQLQIK5rrsoCAJHOgcRpQoLgCFYABJMa32BdAYiSh0WAEOwACRYGIZnSWcgotRhATAEC0CCaa1Pkc6QVJwDQDQpFgBDsAAkWBiGx0lnSCJe/ImOiI8AGoIFIMGCIOiTzpBELABEk3pSKbVHOgRFgwUgoVzXLQRBUJDOkUQsAEST4vC/QVgAEkprfanWWjpGIrEAEE2KBcAgLAAJFYbhc6QzJBULANGkWAAMwgKQUGEYchOgWWIBIJoUC4BBWAASKgiCZdIZiCh1WAAMwgKQQK7rFnzf75TOkVQcASCaFAuAQVgAEkhrfQknAM4eCwDRhHYqpXZIh6DosAAkECcAzg0LANGE+O7fMCwACcQJgHPDAkA0IRYAw7AAJFAQBFwCeA5YAIgmxAJgGBaAhHFdN8cJgHPDAkA0IRYAw7AAJAwnAM4dCwDRhFgADMMCkDBhGD5XOgMRpRILgGFYABKGEwDnjiMARIfZq5R6QjoERYsFIGE4AXDuWACIDsN3/wZiAUiQ8QmAXdI5ko4FgOgwLAAGYgFIEK31czkBcO5YAIgOwwJgIBaABAnD8GLpDGnAAkB0GBYAA7EAJAgnADYHCwDRYVgADMQCkCBBEDxFOkMasAAQHWa9dACKHgtAQnACIBG1yBNKqSelQ1D0WAASQmt9OScANgdHAIgO8qB0AJLBApAQQRBcJZ0hLVgAiA7ykHQAksECkBBBEJwhnSEtWACIDsIRAEOxACSA67o5z/MWSedICxYAooNwBMBQLAAJoLV+kdaaV60mYQEg2k8DWCcdgmSwACRAEAQvks6QFpZlsQAQ/dkGpdSwdAiSwQKQAEEQ/IV0hrSwbX7LEx2A9/8NxrNhzLmuW/A8r086R1qwABAdhPf/DcazYcyFYfjXvP/fPCwARAfhCIDBeDaMuTAMXyCdIU14/5/oIBwBMBgLQMwFQVCUzpAmHAEg2s8DUJYOQXJ4Nowx13XbPc/rlc6RJiwARPuVlVKedAiSw7NhjIVheA3X/28uFgCi/Xj/33A8G8ZYGIZXSmdIGxYAov14/99wPBvGmO/7a6QzpA0LANF+HAEwHM+GMeW6brfv+/Olc6QNnwIg2o8jAIZjAYipMAxfwfv/zccRACIAwDCADdIhSBbPhjEVhuHl0hnSiAWACACwTinFdxiG49kwpnzfXy2dIY1YAIgA8P4/gQUgllzXXeD7fo90jrThToBE+/H+P7EAxFEYhm/g/f/m48WfaD+OABALQBz5vn+VdIY04vA/0X4cASAWgLgZ3/73BOkcacQCQAQAeEIp9YR0CJLHM2LMhGH4ujAMOVbdAiwARAD47p/G8YwYM0EQXCOdIa1YAIgA8P4/jeMZMUZc17UbjcZK6RxpxQJABIAjADSOZ8QYCcPwVWEY8mvSInwKgAgARwBoHC82MRIEwbXSGdKMIwBECMACQON4RowRz/O4+l8LsQAQYUgpNSodguKBZ8SYKJfLVwdBkJHOkWYsAET4nXQAig+eEWPC9/3XSmdIOxYAIhYA+jOeEWPC9/2nSWdIOxYAIpSkA1B88IwYA+Vy+VLf93PSOdKOBYAMFwC4XzoExQfPiDEQBMEbpDOknW3bfAyQTLdOKVWVDkHxwQIQA57nnSWdIe0cx5GOQCSNw/90EBYAYeVy+Rzf99ukc6QdCwARJwDSwVgAhAVB8FbpDCbIZPiEJRmPBYAOwgIgzPf9Z0hnMAFHAMhwPoC10iEoXlgABJXL5TWe53VJ5zABCwAZ7iGlVE06BMULC4CgIAg+JJ3BFCwAZDgO/9NhWACEuK6baTQa50vnMAULABmOTwDQYVgAhIRh+E6u/R8Ny7K4CBCZjiMAdBieFYV4nvca6Qym4Lt/MpwHTgCkCbAACCiXy2c1Go1F0jlMwQJAhntQKdWQDkHxwwIgwPf9f5bOYBIWADIch/9pQiwAEXNdt73RaJwhncMkLABkOE4ApAmxAEQsCIIPhGHIv/cIsQCQ4TgCQBPihShinue9XDqDaVgAyGB1AA9Kh6B4YgGIULlcvtjzvHnSOUzDAkAGe1Ap5UmHoHhiAYiQ7/vvl85gIhYAMhiH/2lSLAARcV23r16vnyKdwzS2bcOyLOkYRFJYAGhSLAARCYLgY1prXokixm2AyXB8AoAmxQIQkUaj8XzpDCbi8D8ZrAbgIekQFF8sABEYGhp6ue/77dI5TMQCQAZ7QCnlS4eg+GIBiIDv+++QzmAqFgAyGIf/6YhYAFrMdd3jGo3GcukcpmIBIIPdIx2A4o0FoMV83/83rbV0DGOxAJDB7pQOQPHGAtBC5XJ5Sb1ef450DpOxAJChnlRK/V46BMUbC0ALBUHw1TAM+eifENu2Ydv8Ficj8d0/TYlnxxYpl8sn1mq1p0vnMFk2m5WOQCSFBYCmxALQIr7vf4UL/8hiASCDsQDQlFgAWqBcLj+9Xq+vls5hOq4CSIaqg48A0jSwALSA53mf58x/eRwBIEPdo5RqSIeg+GMBaLJyuXxJvV4/QToHcQSAjMXhf5oWFoAmazQan5HOQGMXf+4CSIZiAaBpYQFooqGhob9pNBpHS+c0VuxjAAAPQElEQVQgDv+T0e6SDkDJwALQRI1G42PSGWgMCwAZqqyU2i4dgpKBBaBJhoaG3up53nzpHDSGBYAMxeF/mjYWgCap1+vvks5Af8YJgGQoFgCaNhaAJli/fv2Hfd/vkM5BY2zb5h4AZCoWAJo2i8+rz8369euz9Xp9bxAEeeksNCafz6O3t1c6BlHUtimlFkqHoOTgCMDc3cyLf7zw/j8ZirP/aUZYAOagXC7312q1a6Rz0MF4/58MxeF/mhEWgDnwPO/HYRjyZnPMcASADMUCQDPCAjBLQ0NDr6rX66dI56CDWZbFEQAyUR3A76RDULKwAMxCuVzuqtVqH5fOQYdzHIdLAJOJSkqpunQIShYWgFnwff9WTvyLJw7/k6E4/E8zxgIwQ+Vy+fJ6vX6OdA6aGAsAGeqX0gEoeVgAZsB13Uy9Xv8i106ILxYAMlAA4A7pEJQ8LAAz4Pv+NzzP65TOQZNjASAD3auU2i0dgpKHBWCayuXyVbVa7a+kc9DkbNuGbfNbmozzc+kAlEw8W06D67r91Wr1Cxz6jze++ydDsQDQrLAATEOj0bgrCAJeXWKOBYAM5AH4lXQISiYWgCmsX7/+s/V6/SnSOWhq+TyfzCTj/EYpNSodgpKJBeAIyuXyRdVq9VrpHDQ9uVxOOgJR1Dj8T7PGAjAJ13W7a7XaN3nfPxlyuRxXACQT3SYdgJKLBWASnufd4ft+m3QOmh6++ycDVQHcLR2CkosFYAJDQ0P/WKvVVkvnoOnj/X8y0F1c/5/mggXgEOVyeUW1Wn23dA6aGY4AkIF4/5/mhAXgEI1G4xdhGPLvJUGy2Szv/5OJeP+f5oQXugOsX7/+vxqNRr90DpoZDv+TgYYB3CMdgpKNBWCc67pLa7XaS6Rz0Mxx+J8MdIdSypcOQcnGAjDO87yvh2HIceQEYgEgA3H4n+aMBQBAuVw+rV6vnyGdg2Yum81yAyAyEScA0pzxzAnA87yvcMGfZCoUCtIRiKK2E8D90iEo+YwvAOVy+bx6vX6CdA6aHRYAMtDtSqlQOgQln/EFwPf9D0tnoNlxHIc7AJKJfiEdgNLB6ALguu68RqPxNOkcNDt890+G4va/1BRGF4AgCD7Mmf/JxQJABhoG7/9TkxhdADzPu1o6A82OZVl8/I9M9GulVCAdgtLB2AJQLpef4Xlep3QOmp18Ps/lf8lEHP6npjG2AIRheIN0Bpo9Dv+ToVgAqGmMLQC+758rnYFmjwWADOQD+LV0CEoPIwuA67rdnuctks5Bs5PL5bj6H5nofqXUiHQISg8jz6JhGL6GK/8lV1tbm3QEIgkc/qemMrUAXCidgWaPBYAMdad0AEoXIwtAEARc+jehCoUCh//JVBwBoKYy8kwahiHv/ycU3/2Tof6glHpcOgSli3EF4OGHH84FQcAp5Alk2zZn/5Op+O6fms64AmDb9rmcAJhMhUKBi/+QqVgAqOmMKwBa65OkM9DstLe3S0cgksICQE1nXAEAsEA6AM2c4zhc+59MtU0pNSQdgtLHxALQIx2AZo7v/slgfPyPWoIFgBKBs//JYBz+p5bISAeImta6SzoDzUyhUEAmY9y3Ks3MKIASgADAovFfvQDSMGuUBYBawsSzqomjHonW0dEhHYHiZzOAu8Z/3YmxdfL9Az+gUqk4ABYDOBfAhQCehbFikCRVAPdKh6B0Mq4AWJb1J+kMNH3ZbBb5fF46BslbB+DnGLvY36WU2jTVJyilAgCPAfgigC9WKhULwGkAbgRwOZIxOnCPUqohHYLSycQCwNW0EoTv/o1XwdgF+0tKqTkt4DH++b8FcGWlUlkN4N0Anod4FwEO/1PLmDgcvlk6AE2P4zic/GcuDeBjAAaVUv8114v/oZRSDyilLgdwCYDtzXztJmMBoJYxrgBYljXl0CHFQ0dHB1f+M9MeAM9TSr1FKbW3lQdSSn0fwBoAd7fyOLMUYmyOA1FLmFgAHpTOQFOzLIvP/pvJBXC6Uuq7UR1wfD7BOQC+GtUxp+khpdRu6RCUXsYVgIGBgS2O43jSOejI2tvbue2vedYBOEti1bvxJwiuAXB71Mc+Ag7/U0sZNwkQADKZTCUIgmOkc5jCsiw4jlO3bXuPbdtPWJZVwdg9XmffL621DaAtDMP+MAznd3R02AA4/d8cjwK4UCkldj9eKdWoVCqXY2zYfYVUjgOwAFBLGVkAbNt+AAALQItkMpmRTCaz1nGcb1qWdevg4OCM39FVKpUsgNUAzgBw+viv5U2OSvHwOIBnKaW2SgdRSu2sVCrPAfBrAP3CcVgAqKUsE7fGHRoaeuPIyMi/SudIC9u2dTabXZ/JZL5j2/anBwYGNrbiOJVKZTnGhmlfBmBJK45BkdsF4BlKqbXSQQ5UqVROA/ALAFITUR5TSh0rdGwyhJEFwHVdNTw8vNXEP3sz5XK5bZlM5suO4/zTwMDAnqiOW6lUbADPBHA9gCsQ7+e4aXKjAC5QSsVxBj4qlcrzAHwTMnOlvqqUulrguGQQIwsAADz44IObG43GYukcSWPbts7n87c5jvP3g4ODJek8lUqlCOBDAC6QzkIz0gBwqVLqx9JBjqRSqXwIYwsRRe21SqlPCRyXDGLsNOtsNvtF6QxJYtu2bmtr+3lHR8fiE0888ZlxuPgDgFKqpJR6FsbWeX9AOg9N2+vifvEf914ALbmlNQXe/6eWM3YEwHXd9pGRkeEwDDl8fASWZelCoXBnJpP561bd22+WSqWSA3ATgLeAtwXi7NNKqddIh5iuSqVyKYDvRHjI3QAWKKXCCI9JBjK2AADAunXr1tZqtZOlc8SRZVnI5/O/zmQyLxscHPy9dJ6ZqFQq52NsAxje4omfOwGcp5RK1FoclUrl/wBcFtHhfqCUem5ExyKDGXsLAAAcx+GTAIewLAuFQuHejo6Ok0466aQzk3bxBwCl1M8x9ghhLCeXGWwLgCuTdvEf93oAIxEdi8P/FAmjC8CKFSv+03EcbrU5Lp/Pr+/o6HjqSSedVBwcHHxYOs9cjC8ocwGAH0hnIQBAHcDlSqlEbsc9vlzwuyM6HAsARcLoAgAA+Xz+G9IZpGUymdGOjo5XrFq16sTBwcH7pPM0i1JqFMBfAfiSdBbCq5VS90iHmKP/D0Cr9xJpYGzLYqKWM74AOI7z19ls1sgNN2zb1u3t7V9va2vrWbFixX9K52mF8TXeX4axkzfJ+LhS6vPSIeZq/Hvp9S0+TEkpVWvxMYgAsABgYGAgzOfzLzBt29l8Pv/H9vb2U1auXPmigYEBXzpPKymltFLq7wC8XTqLgX4B4M3SIZpFKfULAF9v4SE4/E+RMb4AAMDg4OBPCoXC96RzRCGTydQ7Ojpev2rVquMHBwcfks4TJaXUBwFcByCQzmKIxwC8YPydc5q8FUC1Ra99Z4tel+gwLADjMpnMFZlMJqpZvpGzLAttbW3fa2trW7BixYpPSOeRopT6HIBXAOAz1q1VBXCZUmqbdJBmU0o9hrHVJ1uBBYAiY/Q6AIcql8tXjIyMfCNtfyf5fP6xbDb7/MHBwaRPwmqaSqXySgCfBRcMapWXKKW+Ih2iVSqVSgHAegDLmviyQ0qplU18PaIj4gjAAQYHB7+ZplsB47P7X7Nq1apjefE/mFLqFgCvlc6RUh9L88UfAMYn6r2lyS/L+/8UKRaAQ5x44omXFAqFX0vnmAvbtsP29vYvjM/u/7R0nrhSSt0M4I3SOVLmJ5DZPCdySqlvAPh+E1+SBYAixVsAk1i3bt39tVpttXSOmRhfvveebDZ7+cDAwBbpPElRqVTeCuAj0jlS4PcAzlBK7ZAOEpVKpbIIY5tQHdWElztBKfWHJrwO0bSwABzBww8/fHu1Wj1HOsd05HK5P+VyuZcODg7+RDpLElUqlXcCeJ90jgRbD+CZSqmKdJCoVSqVCwD8GHObT/K4Uko1KRLRtPy/9u4nNI4yjOP4dyazm9oErfZgH7QQpG7SlEgVD/Zg/RdFQagIYlEQLB6Kl5Ye/IN/qKKCIIh4EL0oiicVeqkX60E9tAELRUGzC0EPxaeehKRFdjOZ8TArlLbGbLK77yT7+8Cwl52d32Fhnnnfd55XUwDLmJycvGtkZOSFOI5Lu2K8Pc//ytTU1Dbd/FfPzN6geF9dFXHnfgbuHsSbP4CZnQDeXuPPaPhf+k4jACtQr9dvbbVa37Rara2hs/xreHj4bJIkb2qOv7vc/THgM2A4dJZ14jTwwCAN+1+JuyfAD8Adq/yJw2b2XhcjifwvFQAdmJ2dfbXZbL6YpummENeP4zivVqszSZIcHh8fnwmRYRC4+53AMeC60FlK7hTwoJkNZCvtS7n7GHAGuGYVp99uZqe7m0hkeSoAOjQ3N1dZXFz8sNlsPpmmabUf10ySpFmtVr8YGho6VKvVBvpJq1/cfYJiJ8GxwFHK6nvgYTNbCB2kTNrrAY4BIx2cdgHYsgE7JkrJqQBYg3q9/nSapkdardauLMu62lAmiiIqlcq5SqXy7sTEhFaoB+Du24DjwG2hs5TMCWBfe7dFuYS776F4PXDLCk/51symexhJ5IpUAHRBo9EYzbLsUJZl00tLS7vSNN2aZVlHCyyjKCJJkvkkSc7EcfxVHMef1Gq1+V5llpVx91GKzV8eCp2lJD4GntWOdctz91so/jfjK/j6a2Z2tLeJRC6nAqBHGo3G3izLHs3z/KY8z0fzPN8MbM7z/Cogj+P4XBRFv0VRNBtF0U9RFJ3U8H45ufsQ8BxwFOjLtE8JLQAHN3qHv25y92HgJYrGSMv9b+5vv0kg0lcqAERWyN2ngE+B3aGz9NmPwH41qVkddx8HDgL7ubxh0BLF/P/5vgeTgacCQKQD7l4BXqZ4qtvorwpeAN4C3jGzVugw6117JOleYA9wY/tYMLPHgwaTgaUCQGQV3H078DrwFBuvoVYOfA48b2Z/hA4jIr2hAkBkDdx9kuIpeV/oLF1yCjhiZidDBxGR3lIBINIF7r4beAZ4Arg2cJxOLQJfAu/rxi8yOFQAiHSRu28CHgEOAPdR7umBP4GPgA8GtY+/yCBTASDSI+5+AzBNsfDrHmB72ERAsXXt8fYxY2ZLgfOISCAqAET6xN13UBQDe4GdwA7g6h5e8m+gDvwCfAd8bWZne3g9EVlHVACIBOTu1wM3X3SMURQFI/9xVIHzwDxFc56LP/8CGhQ3/F+B382stFtZi0hY/wAp4/jAGBS7MAAAAABJRU5ErkJggg=="/>
                    </defs>
                  </svg>
                    <div class="swym-storefront-layout-empty-sfl-title">${SwymStorefrontLayoutContext?.Strings?.emptySavedForLaterTitle}</div>
                    <div class="swym-storefront-layout-empty-sfl-description">${SwymStorefrontLayoutContext?.Strings?.emptySavedForLaterDescription}</div>
                    <a class="swym-storefront-layout-empty-sfl-view-cart-button" href="${(window.Shopify?.routes?.root || '/').replace(/\/$/, '') + '/cart'}">${SwymStorefrontLayoutContext?.Strings?.viewCartCta}</a>
                  </div>
                </div>
              </div>
            `;
            this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
            return;
          }
    
          let sflNoticeText = '';
    
          if (isLoggedIn) {
            sflNoticeText = SwymStorefrontLayoutContext?.Strings?.emptySflLoggedInNotice || '';
            this.elements.itemsContainer.innerHTML = `
              <div class="swym-storefront-layout-empty-container swym-storefront-layout-empty-state-sfl swym-storefront-layout-empty-state-sfl-logged">
                <div class="swym-storefront-layout-empty-wishlist-container">
                  <div class="swym-storefront-layout-empty-wishlist-content">
                    <div class="swym-storefront-layout-empty-state-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="#F5F5F5"/>
                        <path d="M20 18H18C17.4696 18 16.9609 18.2107 16.5858 18.5858C16.2107 18.9609 16 19.4696 16 20V32C16 32.5304 16.2107 33.0391 16.5858 33.4142C16.9609 33.7893 17.4696 34 18 34H30C30.5304 34 31.0391 33.7893 31.4142 33.4142C31.7893 33.0391 32 32.5304 32 32V20C32 19.4696 31.7893 18.9609 31.4142 18.5858C31.0391 18.2107 30.5304 18 30 18H28M20 18V16C20 15.4696 20.2107 14.9609 20.5858 14.5858C20.9609 14.2107 21.4696 14 22 14H26C26.5304 14 27.0391 14.2107 27.4142 14.5858C27.7893 14.9609 28 15.4696 28 16V18M20 18H28" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20 24H28M20 28H25" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-state-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <circle cx="7" cy="7" r="7" fill="#4CAF77"/>
                          <path d="M4 7L6 9L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                    </div>
                    <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptySflTitle || ''}</div>
                    <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptySflDescription || ''}</div>
                    <div class="swym-storefront-layout-empty-sfl-steps-card">
                      <div class="swym-storefront-layout-empty-sfl-step">
                        <div class="swym-storefront-layout-empty-sfl-step-icon swym-storefront-layout-empty-sfl-step-icon--green">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M1.5 1.5H3.5L4.8 8.8C4.9 9.3 5.3 9.6 5.8 9.6H13.2C13.7 9.6 14.1 9.2 14.2 8.7L15.5 4H4" stroke="#4CAF77" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="6.5" cy="12.5" r="1.3" stroke="#4CAF77" stroke-width="1.3"/>
                            <circle cx="13" cy="12.5" r="1.3" stroke="#4CAF77" stroke-width="1.3"/>
                          </svg>
                        </div>
                        <div class="swym-storefront-layout-empty-sfl-step-content">
                          <div class="swym-storefront-layout-empty-sfl-step-title">${SwymStorefrontLayoutContext?.Strings?.emptySflStep1Title || ''}</div>
                          <div class="swym-storefront-layout-empty-sfl-step-desc">${SwymStorefrontLayoutContext?.Strings?.emptySflStep1Description || ''}</div>
                        </div>
                      </div>
                      <div class="swym-storefront-layout-empty-sfl-step-divider"></div>
                      <div class="swym-storefront-layout-empty-sfl-step">
                        <div class="swym-storefront-layout-empty-sfl-step-icon swym-storefront-layout-empty-sfl-step-icon--red">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M3 5H15" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round"/>
                            <path d="M6 5V3H12V5" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.5 5L5.5 15H12.5L13.5 5" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.5 8V12M10.5 8V12" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round"/>
                          </svg>
                        </div>
                        <div class="swym-storefront-layout-empty-sfl-step-content">
                          <div class="swym-storefront-layout-empty-sfl-step-title">${SwymStorefrontLayoutContext?.Strings?.emptySflStep2Title || ''}</div>
                          <div class="swym-storefront-layout-empty-sfl-step-desc">${SwymStorefrontLayoutContext?.Strings?.emptySflStep2Description || ''}</div>
                        </div>
                      </div>
                    </div>
                    <div class="swym-storefront-layout-empty-sfl-notice swym-storefront-layout-empty-sfl-notice--grey">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8" stroke="#9B9B9B" stroke-width="1.2"/>
                        <path d="M6 9L8 11L12 7" stroke="#9B9B9B" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-sfl-notice-text"></span>
                    </div>
                    <hr class="swym-storefront-layout-empty-state-divider" />
                    <a href="${cartUrl}" class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-sfl-go-to-cart">
                      ${SwymStorefrontLayoutContext?.Strings?.emptySflGoToCartCTA || ''}
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none"><path d="M13.8536 4.85368C14.0488 4.65841 14.0488 4.34183 13.8536 4.14657L10.6716 0.964589C10.4763 0.769327 10.1597 0.769327 9.96447 0.964589C9.7692 1.15985 9.7692 1.47643 9.96447 1.6717L12.7929 4.50012L9.96447 7.32855C9.7692 7.52381 9.7692 7.84039 9.96447 8.03566C10.1597 8.23092 10.4763 8.23092 10.6716 8.03566L13.8536 4.85368ZM0.5 5.00012L13.5 5.00012L13.5 4.00012L0.5 4.00012L0.5 5.00012Z" fill="currentColor"/></svg>
                    </a>
                  </div>
                </div>
              </div>
            `;
          } else {
            sflNoticeText = SwymStorefrontLayoutContext?.Strings?.emptySflGuestNotice || '';
            this.elements.itemsContainer.innerHTML = `
              <div class="swym-storefront-layout-empty-container swym-storefront-layout-empty-state-sfl swym-storefront-layout-empty-state-sfl-guest">
                <div class="swym-storefront-layout-empty-wishlist-container">
                  <div class="swym-storefront-layout-empty-wishlist-content">
                    <div class="swym-storefront-layout-empty-state-icon">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                        <circle cx="24" cy="24" r="24" fill="#F5F5F5"/>
                        <path d="M20 18H18C17.4696 18 16.9609 18.2107 16.5858 18.5858C16.2107 18.9609 16 19.4696 16 20V32C16 32.5304 16.2107 33.0391 16.5858 33.4142C16.9609 33.7893 17.4696 34 18 34H30C30.5304 34 31.0391 33.7893 31.4142 33.4142C31.7893 33.0391 32 32.5304 32 32V20C32 19.4696 31.7893 18.9609 31.4142 18.5858C31.0391 18.2107 30.5304 18 30 18H28M20 18V16C20 15.4696 20.2107 14.9609 20.5858 14.5858C20.9609 14.2107 21.4696 14 22 14H26C26.5304 14 27.0391 14.2107 27.4142 14.5858C27.7893 14.9609 28 15.4696 28 16V18M20 18H28" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M20 24H28M20 28H25" stroke="#9B9B9B" stroke-width="1.5" stroke-linecap="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-state-badge">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <circle cx="7" cy="7" r="7" fill="#4CAF77"/>
                          <path d="M4 7L6 9L10 5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                    </div>
                    <div class="swym-storefront-layout-empty-wishlist-title">${SwymStorefrontLayoutContext?.Strings?.emptySflTitle || ''}</div>
                    <div class="swym-storefront-layout-empty-wishlist-description">${SwymStorefrontLayoutContext?.Strings?.emptySflDescription || ''}</div>
                    <div class="swym-storefront-layout-empty-sfl-steps-card">
                      <div class="swym-storefront-layout-empty-sfl-step">
                        <div class="swym-storefront-layout-empty-sfl-step-icon swym-storefront-layout-empty-sfl-step-icon--green">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M1.5 1.5H3.5L4.8 8.8C4.9 9.3 5.3 9.6 5.8 9.6H13.2C13.7 9.6 14.1 9.2 14.2 8.7L15.5 4H4" stroke="#4CAF77" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <circle cx="6.5" cy="12.5" r="1.3" stroke="#4CAF77" stroke-width="1.3"/>
                            <circle cx="13" cy="12.5" r="1.3" stroke="#4CAF77" stroke-width="1.3"/>
                          </svg>
                        </div>
                        <div class="swym-storefront-layout-empty-sfl-step-content">
                          <div class="swym-storefront-layout-empty-sfl-step-title">${SwymStorefrontLayoutContext?.Strings?.emptySflStep1Title || ''}</div>
                          <div class="swym-storefront-layout-empty-sfl-step-desc">${SwymStorefrontLayoutContext?.Strings?.emptySflStep1Description || ''}</div>
                        </div>
                      </div>
                      <div class="swym-storefront-layout-empty-sfl-step-divider"></div>
                      <div class="swym-storefront-layout-empty-sfl-step">
                        <div class="swym-storefront-layout-empty-sfl-step-icon swym-storefront-layout-empty-sfl-step-icon--red">
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                            <path d="M3 5H15" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round"/>
                            <path d="M6 5V3H12V5" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M4.5 5L5.5 15H12.5L13.5 5" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M7.5 8V12M10.5 8V12" stroke="#E53E3E" stroke-width="1.3" stroke-linecap="round"/>
                          </svg>
                        </div>
                        <div class="swym-storefront-layout-empty-sfl-step-content">
                          <div class="swym-storefront-layout-empty-sfl-step-title">${SwymStorefrontLayoutContext?.Strings?.emptySflStep2Title || ''}</div>
                          <div class="swym-storefront-layout-empty-sfl-step-desc">${SwymStorefrontLayoutContext?.Strings?.emptySflStep2Description || ''}</div>
                        </div>
                      </div>
                    </div>
                    <div class="swym-storefront-layout-empty-sfl-notice swym-storefront-layout-empty-sfl-notice--amber">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="8" stroke="#B45309" stroke-width="1.2"/>
                        <path d="M9 5V9L11 11" stroke="#B45309" stroke-width="1.2" stroke-linecap="round"/>
                      </svg>
                      <span class="swym-storefront-layout-empty-sfl-notice-text"></span>
                    </div>
                    <hr class="swym-storefront-layout-empty-state-divider" />
                    <a href="${cartUrl}" class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-sfl-go-to-cart">
                      ${SwymStorefrontLayoutContext?.Strings?.emptySflGoToCartCTA || ''}
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none"><path d="M13.8536 4.85368C14.0488 4.65841 14.0488 4.34183 13.8536 4.14657L10.6716 0.964589C10.4763 0.769327 10.1597 0.769327 9.96447 0.964589C9.7692 1.15985 9.7692 1.47643 9.96447 1.6717L12.7929 4.50012L9.96447 7.32855C9.7692 7.52381 9.7692 7.84039 9.96447 8.03566C10.1597 8.23092 10.4763 8.23092 10.6716 8.03566L13.8536 4.85368ZM0.5 5.00012L13.5 5.00012L13.5 4.00012L0.5 4.00012L0.5 5.00012Z" fill="currentColor"/></svg>
                    </a>
                    <a href="${accountUrl}" class="swym-storefront-layout-empty-state-cta-button swym-storefront-layout-empty-sfl-login-cta">
                      ${SwymStorefrontLayoutContext?.Strings?.emptySflLoginCTA || ''}
                    </a>
                    <div class="swym-storefront-layout-empty-state-signup-text">
                      ${SwymStorefrontLayoutContext?.Strings?.emptySflSignupText || ''} <a href="${accountUrl}" class="swym-storefront-layout-empty-state-signup-link">${SwymStorefrontLayoutContext?.Strings?.emptySflSignupCTA || ''}</a>
                    </div>
                  </div>
                </div>
              </div>
            `;
          }
    
          this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
    
          const sflNoticeEl = this.elements.itemsContainer.querySelector('.swym-storefront-layout-empty-sfl-notice-text');
          if (sflNoticeEl) {
            sflNoticeEl.innerHTML = sflNoticeText || '';
          }
        }
    
    
      }
    }
    
    
    class SwymStorefrontLayoutSavedForYouContainer extends HTMLElement {
      constructor() {
        super();
        this.elements = {};
        this.initUI();
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched, () => {
          this.loadSavedForYouItems();
        });
      }
    
      initUI() {
        this.renderUI();
        this.initElement();
      }
    
      renderUI() {
        this.innerHTML = `
          <div class="swym-storefront-layout-header">
            <swym-storefront-layout-saved-for-you-title></swym-storefront-layout-saved-for-you-title>
          </div>
          <div class="swym-storefront-layout-body" role="region" aria-labelledby="swym-saved-for-you-title">
            <swym-storefront-layout-saved-for-you-list></swym-storefront-layout-saved-for-you-list>
          </div>
        `;
      }
    
      initElement() {
        this.elements = {
          savedForYouList: this.querySelector('swym-storefront-layout-saved-for-you-list')
        };
      }
    
      loadSavedForYouItems() {
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        if (shouldShowMultiple) {
          // Multi-list: items live in the dedicated "Saved For Me" list
          const sfyList = SwymStorefrontLayoutContext.getSfyList();
          SwymStorefrontLayoutContext.savedForYouItems = sfyList?.listcontents || [];
          SwymStorefrontLayoutContext.savedForYouList = sfyList || SwymStorefrontLayoutContext?.DefaultList;
        } else {
          // Single-list: items are source-tagged inside DefaultList
          const allItems = SwymStorefrontLayoutContext?.DefaultList?.listcontents || [];
          SwymStorefrontLayoutContext.savedForYouItems = allItems.filter(item => item.source === 'auto-wishlist');
          SwymStorefrontLayoutContext.savedForYouList = SwymStorefrontLayoutContext?.DefaultList;
        }
        document.dispatchEvent(new CustomEvent(SwymStorefrontLayoutContext?.CustomEvents?.SavedForYouFetched));
      }
    }
    
    class SwymStorefrontLayoutSavedForYouTitle extends HTMLElement {
      constructor() {
        super();
        this.renderTitle();
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForYouFetched, () => {
          this.renderTitle();
        });
      }
    
      renderTitle() {
        const totalCount = SwymStorefrontLayoutContext?.savedForYouItems?.length || 0;
    
        // Drawer UI Polish: personalize SFY title for single wishlist + logged-in users (drawer only)
        const { shouldShowMultiple } = SwymStorefrontLayoutContext.getMultiWishlistConfig();
        const isDrawer = SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-drawer';
        const isLoggedIn = SwymStorefrontLayoutContext?.isShopperLoggedIn;
        const customerName = swymEscAttr(SwymStorefrontLayoutContext?.SwymCustomerData?.name?.split(' ')?.[0]);
        let sfyTitleText = SwymStorefrontLayoutContext?.Strings?.tabSavedForYou || 'Saved For You';
        if (isDrawer && !shouldShowMultiple && isLoggedIn && customerName) {
          sfyTitleText = (SwymStorefrontLayoutContext?.Strings?.personalizedSfyTitle || 'Saved For {{name}}').replace('{{name}}', customerName);
        }
    
        const hideCount = isDrawer && !shouldShowMultiple;
        const sfyTitleIcon = isDrawer ? (SwymStorefrontLayoutExtensions?.getWishlistIconSvg?.('filled') || '') : '';
    
        this.innerHTML = `
          <div>
            <div class="swym-storefront-layout-title" id="swym-saved-for-you-title" role="heading" aria-level="2">
              ${sfyTitleIcon}
              ${sfyTitleText}
            </div>
            ${ !hideCount && totalCount ? `<div class="swym-storefront-layout-total-list-items-count" id="swym-saved-for-you-items-count" aria-live="polite">${totalCount} ${totalCount <= 1 ? SwymStorefrontLayoutContext?.Strings?.item : SwymStorefrontLayoutContext?.Strings?.items}</div>` : ''}
          </div>
        `;
        const titleElement = this.querySelector('.swym-storefront-layout-title');
        SwymStorefrontLayoutExtensions?.applyHeadingFontStyles(titleElement);
      }
    }
    
    class SwymStorefrontLayoutSavedForYouList extends HTMLElement {
      constructor() {
        super();
        this.elements = {};
        this.renderUI();
        document.addEventListener(SwymStorefrontLayoutContext?.CustomEvents?.SavedForYouFetched, () => {
          this.renderItems();
        });
      }
    
      renderUI() {
        this.innerHTML = `
          <div id="swym-storefront-layout-sfy-items-container" class="swym-storefront-layout-items-container swym-storefront-layout-saved-for-you-list-container" role="list" aria-label="${SwymStorefrontLayoutContext?.Strings?.tabSavedForYou || 'Saved For You'} items" aria-busy="true" aria-live="polite">
            <swym-storefront-layout-loader loading="true" loadertype="${SwymStorefrontLayoutContext?.LoaderViewType?.WishlistListItem}" buttonCta="${SwymStorefrontLayoutContext?.Strings?.addToCart}" height="100px"></swym-storefront-layout-loader>
          </div>
        `;
        this.elements = {
          itemsContainer: this.querySelector('#swym-storefront-layout-sfy-items-container')
        };
      }
    
      async renderItems() {
        const items = SwymStorefrontLayoutContext?.savedForYouItems || [];
        // In multi-list mode this is the "Saved For Me" list; in single-list it's DefaultList.
        // The correct lid is needed so remove/move operations target the right list.
        const list = SwymStorefrontLayoutContext?.savedForYouList || SwymStorefrontLayoutContext?.DefaultList;
    
        if (!this.elements.itemsContainer) return;
    
        if (items.length === 0) {
          this.elements.itemsContainer.innerHTML = `
            <div class="swym-storefront-layout-empty-container swym-storefront-layout-empty-sfy"></div>
          `;
          this.elements.itemsContainer.classList.add('swym-storefront-layout-items-has-empty');
          this.elements.itemsContainer.setAttribute('aria-busy', 'false');
          return;
        }
    
        // Reverse-chronological: most recently auto-wishlisted appears first
        const sortedItems = [...items].sort((a, b) => (b.cdate || b.ts || 0) - (a.cdate || a.ts || 0));
    
        const fragment = document.createDocumentFragment();
        sortedItems.forEach((item) => {
          const el = document.createElement('template');
          el.innerHTML = `<swym-storefront-layout-item id="swym-storefront-layout-sfy-item-${item.empi}-${item.epi}" class="swym-storefront-layout-sfy-item ${SwymStorefrontLayoutContext?.getSelectedVariant(item, item?.cprops?.selectedVariantId || item?.epi)?.available === false ? 'swym-storefront-layout-item-sold-out' : ''}"></swym-storefront-layout-item>`;
          fragment.appendChild(el.content);
        });
        this.elements.itemsContainer.innerHTML = '';
        this.elements.itemsContainer.appendChild(fragment);
    
        sortedItems.forEach((item) => {
          const el = document.querySelector(`#swym-storefront-layout-sfy-item-${item.empi}-${item.epi}`);
          el?.setData({
            item,
            listItemType: SwymStorefrontLayoutContext?.ListItemType?.SavedForYouItem,
            list
          });
        });
        this.elements.itemsContainer.classList.remove('swym-storefront-layout-items-has-empty');
        this.elements.itemsContainer.setAttribute('aria-busy', 'false');
      }
    }
    
    // Show the login nudge when wishlist data is available.
    document.addEventListener(
      SwymStorefrontLayoutContext?.CustomEvents?.WishlistFetched,
      () => { SwymStorefrontLayoutExtensions?.Notification?.setLoginNudge?.(); }
    );
    
    customElements.define('swym-storefront-layout-as-modal', SwymStorefrontLayoutAsModal);
    if(SwymStorefrontLayoutContext?.Settings?.StorefrontLayoutType === 'as-section'){
      customElements.define('swym-storefront-layout-as-section', SwymStorefrontLayoutAsSection);
    }
    customElements.define('swym-storefront-layout-as-drawer', SwymStorefrontLayoutAsDrawer);
    customElements.define('swym-storefront-layout-collection-carousel', SwymStorefrontLayoutCollectionCarousel);
    customElements.define('swym-storefront-layout-item', SwymStorefrontLayoutWishlistItem);
    customElements.define('swym-storefront-layout-default-wishlist', SwymStorefrontLayoutDefaultWishList);
    customElements.define('swym-storefront-layout-collection-list', SwymStorefrontLayoutCollectionList);
    customElements.define('swym-storefront-layout-actions', SwymStorefrontLayoutActions);
    customElements.define('swym-storefront-layout-action-tooltip', SwymStorefrontLayoutActionTooltip);
    customElements.define('swym-storefront-layout-notification', SwymStorefrontLayoutNotification);
    customElements.define('swym-storefront-layout-loader', SwymStorefrontLayoutLoader);
    customElements.define('swym-storefront-layout-login-user', SwymStorefrontLayoutLoggedUser);
    customElements.define('swym-storefront-layout-title', SwymStorefrontLayoutTitle);
    customElements.define('swym-storefront-layout-tabs', SwymStorefrontLayoutTabs);
    customElements.define('swym-storefront-layout-tab-content', SwymStorefrontLayoutTabContent);
    customElements.define('swym-storefront-layout-wishlist-container', SwymStorefrontLayoutWishlistContainer);
    customElements.define('swym-storefront-layout-sfl-container', SwymStorefrontLayoutSaveForLaterContainer);
    customElements.define('swym-storefront-layout-sfl-title', SwymStorefrontLayoutSaveForLaterTitle);
    customElements.define('swym-storefront-layout-sfl-list', SwymStorefrontLayoutSaveForLaterList);
    customElements.define('swym-storefront-layout-saved-for-you-container', SwymStorefrontLayoutSavedForYouContainer);
    customElements.define('swym-storefront-layout-saved-for-you-title', SwymStorefrontLayoutSavedForYouTitle);
    customElements.define('swym-storefront-layout-saved-for-you-list', SwymStorefrontLayoutSavedForYouList);
})();